<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>

    <loading :loading="loading" />
    <v-card class="v-card-bottom-30">
      <v-card-title>
        <h4>{{ use_language.order }}</h4> <v-icon>mdi-chevron-right</v-icon><span
          class="font-weight-regular body-1 mr-2">{{ use_language.info_order }} {{ format_order_id(OrderMaster.ID) }}</span>
        <span v-if="this.detail_IsPreOrder == 1" class="text-info">(Pre-Order)</span>
        <v-chip color="orange" dark small class="ml-2" label>
          <v-icon left small>mdi-archive</v-icon>
          {{ use_language.storage_order }}
        </v-chip>
        <v-spacer />
        <v-menu offset-y v-if="!isArchive">
          <template v-slot:activator="{ on, attrs }">
            <v-btn :elevation="1" outlined color="success" v-bind="attrs" v-on="on">
              <v-icon size="18" left>fa-file-alt</v-icon>
              <span class="pl-1">{{ use_language.print_document }}</span>
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list class="">
            <v-list-item v-for="item in printDocumentOption" :key="item.text"
              @click="printDocument = item, print_page(OrderMaster.ID)">
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
    
        <v-btn class="ml-4" color="primary" outlined @click="black_to_order_page()">{{ use_language.close }}</v-btn>
      </v-card-title>
    </v-card>

    <v-card elevation="0" class="v-card-bottom-30" style="background-color: transparent;">
      <v-card-text class="px-0" style="background-color: transparent;">
        <v-row v-show="this.OrderMaster.ID != ''">
          <v-col class="px-0 py-0 m-0 my-0">
            <v-card class="px-5 py-2 v-card-bottom-30" elevation="1">
              <v-row v-if="this.get_token != null" class="pb-3">
                <v-col cols="12">
                  <h3>{{ use_language.customer_url }}</h3>
                </v-col>
                <v-col cols="12" md="10" class="pt-5">
                  <a :href="this.detail_Token" target="_blank">
                    {{ this.detail_Token }}
                    <input type="hidden" id="testing-code" style="width:100%" v-model="detail_Token" />
                  </a>
                  <a class="pl-3" @click="copyToken()"><v-icon size="18" left>mdi-content-copy</v-icon></a>
                </v-col>


              </v-row>
            </v-card>
            <v-card  class="px-5 py-2 v-card-bottom-30" elevation="1">
              <v-row class="form-group">
                <v-col cols="8">
                  <h3>{{ use_language.info_order }} : {{this.detail_saleType}}</h3>
                  <small v-if="!platformReferenceSourceID2.includes(detail_order.referenceSourceID)"> {{ use_language.open_order_by }} : {{ detail_order.createdByStaffShopName }}</small>
                </v-col>
                <v-col cols="4" align="right">
                  <v-btn @click="ClickEditOrderDetail()" v-if="!isArchive" :disabled="!authorize" icon class="ma-0">
                    <v-icon size="18">fa-edit</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-divider />
              <template v-if="can_edit_b2b == false">
                <v-row>
                  <v-col class="px-0 py-0" cols="12" md="6" lg="6">
                    <v-row class="form-group" v-if="this.detail_saleType=='B2B'">
                      <v-col cols="6" md="4" lg="4"><strong> {{ use_language.order_type }} : </strong></v-col>
                      <v-col cols="6" md="8" lg="8" class="pl-0">{{ this.detail_orderType }}</v-col>
                    </v-row>
                    <v-row class="form-group"  v-if="this.detail_saleType=='B2B'">
                      <v-col cols="6" md="4" lg="4"><strong> {{ use_language.quotation_number }} : </strong></v-col>
                      <v-col cols="6" md="8" lg="8" class="pl-0">{{ detail_order.quotationNumber }}</v-col>
                    </v-row>
                    <v-row class="form-group"  v-if="this.detail_saleType=='B2B'">
                      <v-col cols="6" md="4" lg="4"><strong> {{ use_language.sale_order_number }} : </strong></v-col>
                      <v-col cols="6" md="8" lg="8" class="pl-0">{{ detail_order.invoiceNo }}</v-col>
                    </v-row>
                    <v-row v-if="!platformReferenceSourceID2.includes(detail_order.referenceSourceID)" class="form-group">
                      <v-col cols="6" md="4" lg="4"><strong> {{ use_language.reference_no_label }} : </strong></v-col>
                      <v-col cols="6" md="8" lg="8" class="pl-0">{{  detail_order.referenceNumber  }}</v-col>
                    </v-row>
                    <v-row class="form-group" v-if="this.detail_saleType=='B2C' && !platformReferenceSourceID2.includes(detail_order.referenceSourceID)">
                      <v-col cols="6" md="4" lg="4"><strong> {{ use_language.transport }} : </strong></v-col>
                      <v-col cols="6" md="8" lg="8" class="pl-0">
                        <v-img 
                          v-if="detail_order.expressCompanyName"
                          :src="detail_order.expressCompanyLogo" 
                          width="80"
                        >
                        </v-img>
                      </v-col>
                    </v-row>
                    <v-row class="form-group"  v-if="this.detail_saleType=='B2B'">
                      <v-col cols="6" md="4" lg="4"><strong> {{ use_language.sale_date }} : </strong></v-col>
                      <v-col cols="6" md="8" lg="8" class="pl-0">{{formatDatetime(this.detail_order.confirmedOrderDate)}}</v-col>
                    </v-row>
                    

                 
                  </v-col>
                  <v-col  class="px-0 py-0" cols="12" md="6" lg="6">
                    
                    <v-row class="form-group"  v-if="this.detail_saleType=='B2B'">
                      <v-col cols="6" md="4" lg="4"><strong> {{ use_language.due_delivery_date }} : </strong></v-col>
                      <v-col cols="6" md="8" lg="8" class="pl-0">{{ (detail_order.dueDeliveryDate? formatDatetime(detail_order.dueDeliveryDate).substr(0,10) : '') }}</v-col>
                    </v-row>
                    
                    <v-row class="form-group"  v-if="this.detail_saleType=='B2B'">
                      <v-col cols="6" md="4" lg="4"><strong> {{ use_language.stock_reservation }} : </strong></v-col>
                      <v-col cols="6" md="8" lg="8" class="pl-0">{{ (detail_order.isReserveStock? use_language.stock_is_reserve: use_language.no_stock_reserve) }}</v-col>
                    </v-row>
                    <v-row class="form-group" v-if="this.detail_saleType=='B2B'">
                      <v-col cols="6" md="4" lg="4"><strong> {{ use_language.transport }} : </strong></v-col>
                      <v-col cols="6" md="8" lg="8" class="pl-0">
                        <v-img 
                          v-if="detail_order.expressCompanyName"
                          :src="detail_order.expressCompanyLogo" 
                          width="80"
                        >
                        </v-img>
                      </v-col>
                    </v-row>
                    <v-row v-if="!platformReferenceSourceID2.includes(detail_order.referenceSourceID)" class="form-group">
                      <v-col cols="6" md="4" lg="4"><strong> {{ use_language.sales_channel }} : </strong></v-col>
                      <v-col cols="6" md="8" lg="8" class="pl-0">
                        <v-row justify-center>
                          <v-avatar 
                            v-if="detail_order.channelLogo != '' && detail_order.channelLogo != null" 
                            size="25px"
                            class="mr-2"
                          >
                          <img :src="detail_order.channelLogo" /></v-avatar>
                          {{ detail_order.channelName }}
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row v-if="!platformReferenceSourceID2.includes(detail_order.referenceSourceID)" class="form-group">
                      <v-col cols="6" md="4" lg="4"><strong> {{ use_language.salesperson }} : </strong></v-col>
                      <v-col cols="6" md="8" lg="8" class="pl-0">{{detail_order.salemanName}}</v-col>
                    </v-row>
                    <v-row class="form-group" v-if="shop_id == 8985 && this.detail_saleType=='B2B'">
                      <v-col cols="6" md="4" lg="4"><strong> {{ use_language.salesperson_2 }} : </strong></v-col>
                      <v-col cols="6" md="8" lg="8" class="pl-0">{{detail_order.salemanName2 != null ? detail_order.salemanName2 : ''}}</v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="form-group">
                  <v-col cols="3" md="2" lg="2"><strong> {{ use_language.customer }} : </strong></v-col>
                  <v-col v-if="detail_order.shopCustomerName" cols="9" md="10" lg="10" class="pl-0">
                 
                     {{this.detail_order.shopCustomerName+" "+this.detail_order.shopCustomerPhone}}
                  </v-col>
                </v-row>
                <v-row class="form-group">
                  <v-col cols="3" md="2" lg="2"><strong> {{ use_language.delivery_address }} : </strong></v-col>
                  <v-col v-if="detail_order.receiverName" cols="9" md="10" lg="10" class="pl-0">{{detail_order.receiverName+' '+detail_order.receiverPhone + ' ' + detail_order.receiverAddress}}</v-col>
                </v-row>
                <v-row class="form-group">
                  <v-col cols="3" md="2" lg="2"><strong> {{ use_language.bill_address }} : </strong></v-col>
                  <v-col v-if="detail_order.InvoiceName" cols="9" md="10" lg="10" class="pl-0">{{ detail_order.InvoiceName+(detail_order.InvoiceTaxID?' ('+detail_order.InvoiceTaxID+')':'')+' '+detail_order.InvoicePhone+' '+detail_order.InvoiceAddress}}</v-col>
                </v-row>
              </template>
              <template v-else>
                <v-row >
                  <v-col class="px-0 py-0" cols="12" md="6" lg="6">

                

                    <v-row class="form-group" v-if="this.detail_saleType=='B2B'">
                      <v-col cols="12" md="4" lg="4">
                        <strong> {{ use_language.order_type }} : </strong>
                      </v-col>
                      <v-col cols="12" md="8" lg="8" >
                        <v-combobox
                          ref="refCustomerSaleSelect"
                          v-model="select_order_type"
                          :items="orderTypeList"
                          :label="use_language.order_type"
                          item-key="text"
                          item-value="value"
                          outlined
                          hide-details
                          dense
                          @change="genOrderNumber"
                        >
                        </v-combobox>
                      </v-col>
                    </v-row>

                    <v-row class="form-group" v-if="this.detail_saleType=='B2B'">
                      <v-col cols="12" md="4" lg="4">
                        <strong> {{ use_language.quotation_number }} : </strong>
                      </v-col>
                      <v-col cols="12" md="8" lg="8" >
                        <v-text-field v-model="txt_quotationNumber" dense outlined hide-details></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row class="form-group" v-if="this.detail_saleType=='B2B'">
                      <v-col cols="12" md="4" lg="4">
                        <strong> {{ use_language.sale_order_number }} : </strong>
                      </v-col>
                      <v-col cols="12" md="8" lg="8">
                        <v-text-field v-model="txt_invoiceNo" dense outlined hide-details></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row class="form-group"  v-if="!platformReferenceSourceID2.includes(detail_order.referenceSourceID)">
                      <v-col cols="12" md="4" lg="4">
                        <strong> {{ use_language.reference_no_label }} : </strong>
                      </v-col>
                      <v-col cols="12" md="8" lg="8" >
                        <v-text-field v-model="txt_referenceNumber" dense outlined hide-details></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="form-group" v-if="this.detail_saleType=='B2C' && !platformReferenceSourceID2.includes(detail_order.referenceSourceID)">
                      <v-col cols="12" md="4" lg="4">
                        <strong> {{ use_language.transport }} : </strong>
                      </v-col>

                      <v-col cols="12" md="8" lg="8">
                        <v-combobox
                          v-model="express_selected"
                          :items="ExpressList"
                          :label="use_language.transport"
                          item-key="expressCompanyName"
                          item-value="shopExpressID"
                          outlined
                          hide-details
                          dense
                          clearable
                          return-object
                        >
                          <template slot="selection" slot-scope="data">
                            <img style="width:40px" :src="data.item.logoPic"/>
                            <v-col  class='mx-0 py-0 pr-0 mr-0'>
                              <span>{{ data.item.expressCompanyName }}</span>
                            </v-col>
                          </template>
                          <template slot="item" slot-scope="data">
                            <img style="width:60px" :src="data.item.logoPic"/>
                            <v-col class='ml-3'>
                              <span>{{ data.item.expressCompanyName }}</span>
                            </v-col>
                          </template>
                        </v-combobox>
                      </v-col>
                    </v-row>

                
                    <v-row class="form-group" v-if="this.detail_saleType=='B2B'">
                      <v-col cols="12" md="4" lg="4">
                        <strong> {{ use_language.sale_date }} : </strong>
                      </v-col>
                      <v-col cols="12" md="8" lg="8" >
                        <v-menu
                          ref="menu_search_sale_date"
                          v-model="menu_search_sale_date"
                          :close-on-content-click="false"
                          :return-value.sync="dt_due_sale_date"
                          transition="scale-transition"
                          offset-y
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="computed_search_sale_date"
                              @change="value => computed_search_sale_date = value"
                              autocomplete="off"
                              :label="use_language.sale_date"
                              outlined
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              hide-details
                              dense
                              v-on="on"
                              clearable
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="dt_due_sale_date" @input="menu_search_sale_date = false, $refs.menu_search_sale_date.save(dt_due_sale_date)" no-title class="my-0">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>

                
                  </v-col>

                  <v-col class="px-0 py-0" cols="12" md="6" lg="6">
                    <v-row class="form-group" v-if="this.detail_saleType=='B2B'">
                      <v-col cols="12" md="4" lg="4">
                        <strong> {{ use_language.desired_delivery_date }} : </strong>
                      </v-col>
                      <v-col cols="12" md="8" lg="8" >
                        <v-menu
                          ref="menu_search_delivery_date"
                          v-model="menu_search_delivery_date"
                          :close-on-content-click="false"
                          :return-value.sync="dt_due_delivery_date"
                          transition="scale-transition"
                          offset-y
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="computed_search_delivery_date"
                              @change="value => computed_search_delivery_date = value"
                              autocomplete="off"
                              :label="use_language.desired_delivery_date"
                              outlined
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              hide-details
                              dense
                              v-on="on"
                              clearable
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="dt_due_delivery_date" @input="menu_search_delivery_date = false, $refs.menu_search_delivery_date.save(dt_due_delivery_date)" no-title class="my-0">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row class="form-group" v-if="select_order_type.value==10 && this.detail_saleType=='B2B'" >
                      <v-col cols="12" md="4" lg="4"  >
                        <h4> {{ use_language.reserve_stock }} :</h4>
                      </v-col>
                      <v-col cols="12" md="8" lg="8"  >
                        <v-radio-group v-model="isReserveQuantity" row>
                          <v-radio v-for="items in isReserveQuantityTypeList"
                            :key="items.indexOf" :value="items.value" :label="items.text">
                            <template v-slot:label>
                              <h4>{{ items.text }}</h4>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row class="form-group" v-if="this.detail_saleType=='B2B'">
                      <v-col cols="12" md="4" lg="4">
                        <strong> {{ use_language.transport }} : </strong>
                      </v-col>
                      <v-col cols="12" md="8" lg="8">
                        <v-combobox
                          v-model="express_selected"
                          :items="ExpressList"
                          :label="use_language.transport"
                          item-key="expressCompanyName"
                          item-value="shopExpressID"
                          outlined
                          hide-details
                          dense
                          clearable
                          return-object
                        >
                          <template slot="selection" slot-scope="data">
                            <img style="width:40px" :src="data.item.logoPic"/>
                            <v-col  class='mx-0 py-0 pr-0 mr-0'>
                              <span>{{ data.item.expressCompanyName }}</span>
                            </v-col>
                          </template>
                          <template slot="item" slot-scope="data">
                            <img style="width:60px" :src="data.item.logoPic"/>
                            <v-col class='ml-3'>
                              <span>{{ data.item.expressCompanyName }}</span>
                            </v-col>
                          </template>
                        </v-combobox>
                      </v-col>
                    </v-row>

                    <v-row class="form-group"   v-if="!platformReferenceSourceID2.includes(detail_order.referenceSourceID)" >
                      <v-col cols="12" md="4" lg="4">
                        <strong> {{ use_language.sales_channel }} : </strong>
                      </v-col>
                      <v-col cols="12" md="8" lg="8" >
                        <v-combobox
                          ref="refCustomerChannelSelect"
                          v-model="channel"
                          :items="channelList"
                          :label="use_language.sales_channel"
                          item-key="channelName"
                          item-value="id"
                          outlined
                          hide-details
                          return-object
                          dense
                        >
                          <template slot="selection" slot-scope="data">
                            <img style="width:25px" :src="data.item.logoPic"/>
                            <v-col  class='mx-0 py-0 pr-0 mr-0'>
                              <span>{{ data.item.channelName }}</span>
                            </v-col>
                          </template>
                          <template slot="item" slot-scope="data">
                            <img style="width:25px" :src="data.item.logoPic"/>
                            <v-col class='ml-3'>
                              <span>{{ data.item.channelName }}</span>
                            </v-col>
                          </template>
                        </v-combobox>
                      </v-col>
                    </v-row>

                    <v-row class="form-group"  v-if="!platformReferenceSourceID2.includes(detail_order.referenceSourceID)">
                      <v-col cols="12" md="4" lg="4">
                        <strong> {{ use_language.salesperson }} : </strong>
                      </v-col>
                      <v-col cols="12" md="8" lg="8"  >
                        <v-combobox
                          ref="refCustomerSaleSelect"
                          v-model="detail_saleman1"
                          :items="customerSalemanList"
                          :label="use_language.salesperson"
                          item-key="text"
                          item-value="value"
                          outlined
                          hide-details
                          dense
                          return-object
                        >
                          <template v-slot:label> <span>{{ use_language.salesperson }}</span></template>
                        </v-combobox>
                      </v-col>
                    </v-row>

                    <v-row class="form-group" v-if="shop_id == 8985 && this.detail_saleType=='B2B'">
                      <v-col cols="12" md="4" lg="4">
                        <strong> {{ use_language.salesperson_2 }} : </strong>
                      </v-col>
                      <v-col cols="12" md="8" lg="8"  >
                        <v-combobox
                          v-model="detail_saleman2"
                          :items="customerSalemanList"
                          :label="use_language.salesperson"
                          item-key="text"
                          item-value="value"
                          outlined
                          hide-details
                          dense
                          clearable
                          return-object
                        >
                          <template v-slot:label> <span>{{ use_language.salesperson_2 }}</span></template>
                        </v-combobox>
                      </v-col>
                    </v-row>

                  </v-col>
                </v-row>
                <v-row class="form-group">
                    <v-col cols="12" md="2" lg="2">
                      <strong> {{ use_language.customer }} : </strong>
                    </v-col>
                    <v-col cols="12" md="10" lg="10" class="d-flex  ">
                      <span v-if="this.detail_order.shopCustomerID != null">  {{this.detail_order.shopCustomerName+" "+this.detail_order.shopCustomerPhone}}     </span>
                               
                      <a v-if="!isArchive" @click="dialog_addcustomer = true,LoadCountry()">
                        <v-icon color="danger" size="16" class="mr-0">mdi-plus</v-icon> {{ use_language.add }}
                      </a>
                    </v-col>
                </v-row>
                <v-row class="form-group">
                  <v-col cols="12" md="2" lg="2">
                    <strong> {{ use_language.delivery_address }} : </strong>
                  </v-col>
               
                  <v-col v-if="(!platformReferenceSourceID.includes(detail_order.referenceSourceID) || detail_order.isSellerOwnFleet)"  cols="12" md="10" lg="10" class="d-flex  ">
                  
                      <v-combobox
                        ref="refCustomerShipSelect"
                        v-model="customerAddress_selected"
                        :items="customerAddressList"
                        :label="use_language.delivery_address"
                        item-key="text"
                        item-value="id"
                        outlined
                        hide-details
                        dense
                        clearable
                        return-object
                        :disabled="this.detail_order.shopCustomerID == null"
                      >
                        <template v-slot:label> <span>{{ use_language.delivery_address }}</span></template>
                       
                      </v-combobox> 
                        <a   @click="dialog_addshipping = true,LoadDataEditAddress()" class="mx-2" v-if="this.detail_order.shopCustomerID != null&& customerAddress_selected!=null && !isArchive">
                          <v-icon color="danger"   size="16" >mdi-pencil</v-icon> 
                        </a>
                       
                      <a :tooltip="use_language.add_address" @click="dialog_addshipping = true, OpenAddShippingAddress()" v-if="this.detail_order.shopCustomerID != null && !isArchive">
                        <v-icon color="danger" size="18" >mdi-plus</v-icon> 
                      </a>
                        
                  </v-col>
             
                    <v-col v-else cols="12" md="10" lg="10" class="d-flex  ">
                    {{detail_order.receiverName+' '+detail_order.receiverPhone + ' ' + detail_order.receiverAddress}} 
                  </v-col>  
                </v-row>

                <v-row class="form-group">
                  <v-col cols="12" md="2" lg="2">
                    <strong> {{ use_language.bill_address }} : </strong>
                  </v-col>
                  <v-col cols="12" md="10" lg="10" class="d-flex ">
                    <v-combobox
                      ref="refCustomerInvoiceSelect"
                      v-model="customerAddressInvoice_selected"
                      :items="customerAddressInvoiceList"
                      :label="use_language.bill_address"
                      item-key="text"
                      item-value="id"
                      outlined
                      hide-details
                      dense
                      clearable
                      return-object
                      :disabled="this.detail_order.shopCustomerID == null"
                    >
                      <template v-slot:label> <span>{{ use_language.bill_address }}</span></template>
                    </v-combobox>
                      <a @click="OpenEditShippingInvoice(), dialog_addshipping_invoice = true"  class="mx-2" v-if="this.detail_order.shopCustomerID != null && customerAddressInvoice_selected !=null && !isArchive">
                      <v-icon  color="danger" size="16" >mdi-pencil</v-icon> 
                    </a>
                    <a @click="dialog_addshipping_invoice = true" v-if="this.detail_order.shopCustomerID != null && !isArchive">
                      <v-icon  color="danger" size="18" >mdi-plus</v-icon> 
                    </a>
                   
                  </v-col>
                </v-row>
                <v-row class="form-group">
                  <v-col cols="12" class="text-right">
                    <v-btn @click="SubmitEditOrderInfo()" :loading="isSaving" dark color="primary">{{ use_language.save }}</v-btn>
                  </v-col>
                </v-row>
              </template>
            </v-card>

            <!-- คลัง และ สถานะ -->
            <div v-if="this.detail_saleType!='B2B'">
              <div v-if="size == 'xs' || size == 'sm'">
                <v-card class="px-5 py-2 v-card-bottom-30" elevation="1">
                  <v-row>

                    <v-col cols="6">
                      <h3>{{ use_language.warehouse }}</h3>
                    </v-col>
                    <v-col cols="6" class="py-0" align="right">
                      <v-btn v-if="detail_statusId < 40 && !isArchive" :disabled="!authorize" icon class="ma-0"
                        @click="ClickEditWarehouse()"><v-icon size="18">fa-edit</v-icon></v-btn>
                    </v-col>

                    <v-col cols="12" v-if="can_edit_warehouse == true">
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-select v-model="Warehouse_List_selected" autocomplete="off" :items="Warehouse_List"
                            item-key="id" item-value="id" item-text="name" return-object outlined dense></v-select>
                        </v-col>
                        <v-col cols="12" md="8"><v-btn color="primary" @click="shop_change_warehouse()">{{
                          use_language.save }}</v-btn></v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" v-else>{{ this.detail_order.warehouseName }}</v-col>
                  </v-row>
                </v-card>

                <v-card class="px-5 py-2 v-card-bottom-30" elevation="1">
                  <v-row>

                    <v-col cols="6">
                      <h3>{{ use_language.status }}</h3>
                    </v-col>
                    <v-col cols="6" align="right">
                      <!-- <v-btn v-if="(canChangeStatusOrder == 1 && detail_statusId < 40 && detail_referenceSourceID != 3 && detail_referenceSourceID != 4 && detail_referenceSourceID != 5 && detail_referenceSourceID != 11) " color="primary" outlined class="mx-2" @click="deleteShipping()">{{use_language.cancel_order}}</v-btn> -->
                    </v-col>

                    <v-col cols="12" v-if="AllowChangeOrderStatus">
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-select v-model="detail_shiping_staus_update_select" autocomplete="off"
                            :items="change_items_status" item-key="text" item-value="value" :label="use_language.order_status"
                            return-object outlined>
                            <template v-slot:label> <span>{{ use_language.order_status }}</span> </template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="8"><v-btn color="primary" @click="shop_change_shipping_status()">{{
                          use_language.save
                        }}</v-btn></v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" v-else>
                      <span v-if="this.detail_statusId == 10" style="color: black;">{{ this.detail_order.shippingStatusName }}</span>
                      <span v-if="this.detail_statusId == 20" style="color: #E40078;">{{ this.detail_order.shippingStatusName }}</span>
                      <span v-if="this.detail_statusId == 30" style="color: #ff7ac0;">{{ this.detail_order.shippingStatusName }}</span>
                      <span v-if="this.detail_statusId == 40" style="color: orange;">{{ this.detail_order.shippingStatusName }}</span>
                      <span v-if="this.detail_statusId == 50" style="color: blue;">{{ this.detail_order.shippingStatusName }}</span>
                      <span v-if="this.detail_statusId == 60" style="color: #9acd32;">{{ this.detail_order.shippingStatusName }}</span>
                      <span v-if="this.detail_statusId == 70" style="color: green;">{{ this.detail_order.shippingStatusName }}</span>
                      <span v-if="this.detail_statusId == 90" style="color: red;">{{ this.detail_order.shippingStatusName }}</span>


                    </v-col>

                  </v-row>
                </v-card>
              </div>
              <div v-else>
                <v-row>
                  <v-col cols="6" class="ma-0 pa-0 pr-3">
                    <v-card class="px-5 py-2 v-card-bottom-30" elevation="1" style="max-height : 175px">
                      <v-row>

                        <v-col cols="6">
                          <h3 style="margin-bottom: 21px">{{ use_language.warehouse }}</h3>
                        </v-col>
                        <v-col cols="6" align="right">
                          <v-btn v-if="detail_statusId < 40 && !isArchive" :disabled="!authorize" icon class="ma-0"
                            @click="ClickEditWarehouse()"><v-icon size="18">fa-edit</v-icon></v-btn>
                        </v-col>

                        <v-col cols="12" class="ma-0 pa-0" v-if="can_edit_warehouse == true">
                          <v-row class="ma-0 pa-0">
                            <v-col cols="8" md="8" class="py-4">
                              <v-select v-model="Warehouse_List_selected" autocomplete="off" :items="Warehouse_List"
                                item-key="id" item-value="id" item-text="name" outlined return-object hide-details
                                dense></v-select>
                            </v-col>
                            <v-col cols="4" md="4" class="py-4"><v-btn color="primary" @click="shop_change_warehouse()">{{
                              use_language.save }}</v-btn></v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" class="py-3 pb-10" v-else>{{  this.detail_order.warehouseName }} </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="6" class="ma-0 pa-0 pl-3">
                    <v-card class="px-5 py-2 v-card-bottom-30" elevation="1" style="max-height : 175px" v-if="authorize || isArchive">
                      <v-row>

                        <v-col cols="6">
                          <h3 style="margin-bottom: 21px">{{ use_language.status }}</h3>
                        </v-col>


                        <v-col cols="12" class="ma-0 pa-0" v-if="AllowChangeOrderStatus && !isArchive">
                          <v-row class="ma-0 pa-0">
                            <v-col cols="8" md="8" class="py-4">
                              <v-select v-model="detail_shiping_staus_update_select" autocomplete="off" return-object
                                :items="change_items_status" item-key="text" item-value="value" outlined hide-details
                                dense></v-select>
                            </v-col>
                            <v-col cols="4" md="4" class="py-4" align="right"><v-btn v-if="!isArchive" :disabled="!authorize"
                                color="primary" @click="shop_change_shipping_status()">{{ use_language.save
                                }}</v-btn></v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" class="py-3 pb-10" v-else>
                          <span v-if="this.detail_statusId == 10" style="color: black;">{{ this.detail_order.shippingStatusName
                          }}</span>
                          <span v-if="this.detail_statusId == 20" style="color: #E40078;">{{ this.detail_order.shippingStatusName
                          }}</span>
                          <span v-if="this.detail_statusId == 30" style="color: #ff7ac0;">{{ this.detail_order.shippingStatusName
                          }}</span>
                          <span v-if="this.detail_statusId == 40" style="color: orange;">{{ this.detail_order.shippingStatusName
                          }}</span>
                          <span v-if="this.detail_statusId == 50" style="color: blue;">{{ this.detail_order.shippingStatusName }}</span>
                          <span v-if="this.detail_statusId == 60" style="color: #9acd32;">{{ this.detail_order.shippingStatusName
                          }}</span>
                          <span v-if="this.detail_statusId == 70" style="color: green;">{{ this.detail_order.shippingStatusName
                          }}</span>
                          <span v-if="this.detail_statusId == 90" style="color: red;">{{ this.detail_order.shippingStatusName }}</span>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </div>

            <v-card v-if="(!platformReferenceSourceID.includes(detail_referenceSourceID) || (platformReferenceSourceID.includes(detail_referenceSourceID) && detail_isSellerOwnFleet)) && this.detail_saleType!='B2B'"
              class="px-5 py-2 v-card-bottom-30" elevation="1">
              <v-row class="form-group">
                <v-col cols="9">
                  <h3>{{ use_language.sender_address }}</h3>
                </v-col>
              </v-row>
              <v-row class="form-group">
                <v-col cols="4" md="2" lg="1"><strong> {{ use_language.sender_name }} : </strong></v-col>
                <v-col cols="8" md="10" lg="11">{{ this.detail_order.senderName }}</v-col>
              </v-row>
              <v-row class="form-group">
                <v-col cols="4" md="2" lg="1"><strong> {{ use_language.tel }} : </strong></v-col>
                <v-col cols="8" md="10" lg="11">{{ this.detail_order.senderPhone }}</v-col>
              </v-row>
              <v-row class="form-group">
                <v-col cols="4" md="2" lg="1"><strong> {{ use_language.address }} : </strong></v-col>
                <v-col cols="8" md="10" lg="11">{{ this.detail_order.senderAddress }}</v-col>
              </v-row>
            </v-card>


       
       
 
            <!-- แพลตฟอร์ม -->
            <v-card class="px-5 py-5 v-card-bottom-30" elevation="1" v-if="orderItemTempList.length > 0">
              <v-row class="form-group">
                <v-col cols="9">
                  <h3>{{ use_language.platform }}</h3>
                </v-col>
              </v-row>
              <v-row class="form-group">
                <v-col cols="4" md="3" lg="2"><strong> {{ use_language.shop }} : </strong></v-col>
                <v-col cols="8" md="9" lg="10">
                  <div >
                     {{ this.detail_order.shopName }}
                  </div>
                  
                </v-col>
              </v-row>
              <v-row class="form-group">
                <v-col cols="4" md="3" lg="2"><strong> {{ use_language.reference_number }} : </strong></v-col>
                <v-col cols="8" md="9" lg="10">
                  <div v-if="this.detail_ReferenceSourceID == 6">
                    {{ this.detail_RealReferenceNumber }} ({{ this.detail_ReferenceNumber }})
                  </div>
                  <div v-else>
                    {{ this.detail_ReferenceNumber }}
                  </div>
                </v-col>
              </v-row>
              <v-row class="form-group">
                <v-col cols="4" md="3" lg="2"><strong> {{ use_language.channel }} : </strong></v-col>
                <v-col cols="8" md="9" lg="10">
                  <v-img style="margin:5px;" :src="this.detail_ChannelSourceLogoPic" aspect-ratio="1"
                    class="grey lighten-2" max-width="30" max-height="30"
                    @click="image_click(detail_ChannelSourceLogoPic, 0)"></v-img>
                </v-col>
              </v-row>
              <v-row class="form-group"
                v-if="(this.detail_referenceSourceID == 3 || this.detail_referenceSourceID == 4 || this.detail_referenceSourceID == 11) && marketplace_status != null">
                <v-col cols="4" md="3" lg="2"><strong> {{ use_language.status_from_platform }} : </strong></v-col>
                <v-col cols="8" md="9" lg="10">
                  {{ marketplace_status }}
                </v-col>
              </v-row>
               <v-row class="form-group"
                v-if="(this.detail_referenceSourceID == 3 || this.detail_referenceSourceID == 4 || this.detail_referenceSourceID == 11)">
                <v-col cols="4" md="3" lg="2"><strong> {{ use_language.parcel_format }} : </strong></v-col>
                <v-col cols="8" md="9" lg="10">
                 <span v-if="this.detail_IsCOD == false"><v-chip color="info" outlined>Non-COD</v-chip></span>
                  <span v-else><v-chip color="primary">COD</v-chip> </span>
                </v-col>
              </v-row>
              <v-row class="form-group" v-if="this.detail_order.tempSenderAddress != null">
                <v-col cols="4" md="3" lg="2"><strong> {{ use_language.sender }} : </strong></v-col>
                <v-col cols="8" md="9" lg="10">{{ this.detail_order.tempSenderAddress }}</v-col>
              </v-row>
              <v-row class="form-group" v-if="this.detail_order.tempAddress != null">
                <v-col cols="4" md="3" lg="2"><strong> {{ use_language.recipient }} : </strong></v-col>
                <v-col cols="8" md="9" lg="10">{{ this.detail_order.tempAddress }}</v-col>
              </v-row>
              <v-row class="form-group">
                <v-col cols="12" md="3" lg="2"><strong> {{ use_language.to_pack }} : </strong></v-col>
                <v-col cols="12" md="9" lg="10" style="overflow-x: auto">
                  <v-simple-table class="packhai-border-table">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center" width="90px">{{ use_language.tb_image }}</th>
                          <th class="text-left" width="650px">{{ use_language.name }}</th>
                          <th class="text-left" width="150px">{{ use_language.type }}</th>
                          <th class="text-left" width="100px">{{ use_language.sku }}</th>
                          <th class="text-right" width="70px">{{ use_language.quantity }}</th>
                          <th class="text-right" width="170px">{{ use_language.unit_price }}</th>
                          <th class="text-right" width="170px">{{ use_language.price_before_discount }}</th>
                          <th class="text-right" width="170px">{{ use_language.seller_discount }}</th>
                          <th class="text-right" width="170px">{{ use_language.platform_discount }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in orderItemTempList" :key="item.name">
                          <td class="text-center">
                            <v-img style="margin:5px;" :src="item.imgUrl" aspect-ratio="1" class="grey lighten-2"
                              width="50px" height="50px" @click="image_click(item.imgUrl, 0)"></v-img>
                          </td>
                          <td class="text-left">
                            <div v-if="item.notSku" class="color-red">
                              {{ item.name }}
                              <br />
                              {{ use_language.product_not_found_system }}
                            </div>
                            <div v-else>
                              {{ item.name }}
                            </div>
                            <div v-if="item.marketPlaceItemID" style="color:gray;font-size:10px;">
                              {{  'ItemID : '+item.marketPlaceItemID+', SkuID : '+item.marketPlaceSKUID }}
                            </div>
                          </td>
                          <td class="text-left">
                            <div>
                              {{ item.propDescription }}
                            </div>
                          </td>
                          <td class="text-left">
                            <div v-if="item.notSku" class="color-red">
                              {{ item.sku }}
                            </div>
                            <div v-else>
                              {{ item.sku }}
                            </div>
                          </td>
                          <td class="text-right">{{ item.quantity }}</td>
                          <td class="text-right">{{ format_price(item.unitPrice) }}</td>
                          <td class="text-right">{{ format_price(item.unitPrice * item.quantity) }}</td>
                          <td class="text-right">{{ format_price(item.sellerUnitPriceDiscount) }}</td>
                          <td class="text-right">{{ format_price(item.platformUnitPriceDiscount) }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <div v-if="this.detail_referenceSourceID == 11">
                    <v-row align="end">
                      <v-col cols="8" align="end"><strong>{{ use_language.price_before_discount }} :</strong></v-col>
                      <v-col cols="4" align="end">
                        <span v-if="this.detail_totalPrice != null">{{ format_price(this.detail_totalPrice) }}
                          {{ use_language.bath }}
                        </span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>

                    <v-row align="end">
                      <v-col cols="8" class="pt-0" align="end"><strong>{{ use_language.order_discount }} :</strong></v-col>
                      <v-col cols="4" class="pt-0" align="end">
                        <span v-if="OrderMaster.OrderDiscount != null">{{ format_price(OrderMaster.OrderDiscount * -1)
                        }}
                          {{ use_language.bath }}</span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>
                    <v-row align="end">
                      <v-col cols="8" class="pt-0" align="end"><strong>{{ use_language.shipping_cost }}
                          :</strong></v-col>
                      <v-col cols="4" class="pt-0" align="end">
                        <span v-if="detail_DeliveryCost != null">{{ format_price(detail_DeliveryCost) + ' ' +
                          use_language.bath }}</span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>
                    <v-row align="end">
                      <v-col cols="8" class="pt-0" align="end"><strong>{{ use_language.discount }} Seller voucher :</strong></v-col>
                      <v-col cols="4" class="pt-0" align="end">
                        <span v-if="OrderMaster.OrderDiscount != null">{{ format_price(detail_SellerVoucher * -1)
                        }}
                          {{
                            use_language.bath }}</span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>
                    <v-row align="end">
                      <v-col cols="8" class="pt-0" align="end"><strong> {{ use_language.delivery_discount_from }} Seller:</strong></v-col>
                      <v-col cols="4" class="pt-0" align="end">
                        <span v-if="detail_DeliveryCost != null">{{ format_price(detail_SellerDeliveryDiscount
                          * -1) }} {{
                            use_language.bath }}</span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>
                    <v-row align="end">
                      <v-col cols="8" class="pt-0" align="end" style="font-size: 18px;color:green"><strong>{{ use_language.sales }}
                          :</strong></v-col>
                      <v-col cols="4" class="pt-0" align="end" style="font-size: 18px;color:green">
                        <span>{{ format_price(detail_totalPrice + detail_DeliveryCost +
                          (OrderMaster.OrderDiscount * -1) +
                          (detail_SellerVoucher * -1) + (detail_SellerDeliveryDiscount *
                          -1)+OrderMaster.OrderDiscount) }}
                          {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>
                    <v-row align="end">
                      <v-col cols="8" class="pt-0" align="end"><strong>{{ use_language.discount }} Platform voucher :</strong></v-col>
                      <v-col cols="4" class="pt-0" align="end">
                        <span v-if="detail_PlatformVoucher != null">{{ format_price(detail_PlatformVoucher *
                          -1) }} {{
                          use_language.bath }}</span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>

                    <v-row align="end">
                      <v-col cols="8" class="pt-0" align="end"><strong> {{ use_language.delivery_discount_from }} Platform :</strong></v-col>
                      <v-col cols="4" class="pt-0" align="end">
                        <span v-if="detail_PlatformDeliveryDiscount != null">{{
                          format_price(detail_PlatformDeliveryDiscount * -1) }} {{ use_language.bath }}</span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>

                    <v-row align="end">
                      <v-col cols="8" class="pt-0" align="end"><strong> {{ use_language.discount_from }} coin Platform :</strong></v-col>
                      <v-col cols="4" class="pt-0" align="end">
                        <span>{{ format_price((detail_ShopeeCoinDiscount ?? 0) * -1) }} {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>

                    <v-row align="end">
                      <v-col cols="8" class="pt-0" align="end"><strong>{{ use_language.payment_channel_discount }} :</strong></v-col>
                      <v-col cols="4" class="pt-0" align="end">
                        <span>{{ format_price((detail_PaymentDiscount ?? 0) * -1) }} {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>

                    <v-row align="end">
                      <v-col cols="8" class="pt-0" align="end" style="font-size: 16px;"><strong>{{ use_language.total_amount_by_customer }}
                          :</strong></v-col>
                      <v-col cols="4" class="pt-0" align="end" style="font-size: 16px;">
                        <span>{{ format_price(detail_BuyerPaidAmount ?? (detail_orderTotalAmount + (detail_PlatformVoucher * -1) +
                          (detail_PlatformDeliveryDiscount * -1) - (detail_ShopeeCoinDiscount ?? 0) - (detail_PaymentDiscount ?? 0))) }} {{ use_language.bath }}</span>

                      </v-col>
                    </v-row>

                  </div>
                  <div v-else>
                    <v-row align="end" style="height: 30px;">
                      <v-col cols="8" class="py-0" align="end"><strong>{{ use_language.price_before_discount }}
                          :</strong></v-col>
                      <v-col cols="4" class="py-0" align="end">
                        <span v-if="this.detail_totalPrice != null">{{ format_price(this.detail_totalPrice) }}
                          {{ use_language.bath }}
                        </span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>

                    <v-row align="end" style="height: 30px;">
                      <v-col cols="8" class="py-0" align="end"><strong>{{ use_language.order_discount }} :</strong></v-col>
                      <v-col cols="4" class="py-0" align="end">
                        <span v-if="OrderMaster.OrderDiscount != null">{{ format_price(OrderMaster.OrderDiscount * -1) + ' '+use_language.bath }}</span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>
                    <v-row align="end" style="height: 30px;">
                      <v-col cols="8" class="py-0" align="end"><strong>{{ use_language.discount }} Seller voucher :</strong></v-col>
                      <v-col cols="4" class="py-0" align="end">
                        <span v-if="OrderMaster.OrderDiscount != null">{{ format_price(detail_SellerVoucher * -1)
                          + ' ' +
                          use_language.bath }}</span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>
                    <v-row align="end" style="height: 30px;">
                      <v-col cols="8" class="py-0" align="end"><strong>{{ use_language.shipping_cost
                          }}:</strong></v-col>
                      <v-col cols="4" class="py-0" align="end">
                        <span v-if="this.detail_DeliveryCost != null">{{ format_price(this.detail_DeliveryCost) + ' '+use_language.bath }}</span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>
                    <v-row align="end" style="height: 30px;">
                      <v-col cols="8" class="py-0" align="end"><strong> {{ use_language.shipping_discount }} :</strong></v-col>
                      <v-col cols="4" class="py-0" align="end">
                        <span v-if="this.detail_DeliveryCost != null">{{
                          format_price(this.detail_SellerDeliveryDiscount * -1) }}
                          {{ use_language.bath }}</span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>
                    <v-row align="end" style="height: 30px;">
                      <v-col v-if="OrderMaster.VATType == 0 || OrderMaster.VATType == 1" cols="8" class="py-0"
                        align="end"><strong> VAT
                          (No VAT)
                          :</strong></v-col>
                      <v-col v-if="OrderMaster.VATType == 2" cols="8" class="py-0" align="end"><strong> VAT (Included)
                          :</strong></v-col>
                      <v-col v-if="OrderMaster.VATType == 3" cols="8" class="py-0" align="end"><strong> VAT (Excluded)
                          :</strong></v-col>
                      <v-col cols="4" class="py-0" align="end">
                        <span v-if="this.detail_DeliveryCost != null">{{ format_price(OrderMaster.VATAmount) }}
                          {{ use_language.bath }}</span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </v-col>
                    </v-row>
                    <v-row align="end" style="height: 30px;">
                      <v-col cols="8" class="py-0" align="end"><strong>{{ use_language.total_all }} :</strong></v-col>
                      <v-col cols="4" class="py-0" align="end">
                        <span>{{ format_price(detail_orderTotalAmount) }} {{ use_language.bath }}</span>

                      </v-col>
                    </v-row>
                    <v-row v-if="detail_PlatformVoucher != 0 && detail_PlatformVoucher != null" align="end"
                      style="height: 30px;">

                      <v-col cols="12" class="py-0" align="end" style="color:grey">
                        **{{ use_language.order_has_platform_discount }} {{ format_price(detail_PlatformVoucher) }}
                        {{ use_language.bath }}
                      </v-col>
                    </v-row>
                  </div>

                </v-col>
              </v-row>
            </v-card>

            <v-card class="px-5 py-2 v-card-bottom-30" elevation="1" v-if="this.detail_saleType!='B2B' && !platformReferenceSourceID.includes(detail_referenceSourceID)  ">
              <v-row>
                <v-col cols="8">
                  <h3>{{ use_language.parcel_format }}</h3>
                </v-col>
                <v-col cols="4" align="right">
                  <v-btn v-if="detail_statusId < 40 && !isArchive" :disabled="!authorize" icon class="ma-0"
                    @click="can_edit_data_cod = !can_edit_data_cod, edit_cod_amount = detail_CODAmount, edit_cod_bank = detail_ShopBankAccountID, can_edit_cod()"><v-icon
                      size="18">fa-edit</v-icon></v-btn>
                </v-col>
              </v-row>
              <v-row v-if="can_edit_data_cod == false">
                <v-col>
                  <span v-if="this.detail_IsCOD == false"><v-chip color="info" outlined>Non-COD</v-chip></span>
                  <span v-else><v-chip color="primary">COD</v-chip> </span>
                  <span class="pl-4"
                    v-if="this.detail_IsCOD == true && this.detail_referenceSourceID != 3 && this.detail_referenceSourceID != 4 && this.detail_referenceSourceID != 11">
                    {{ use_language.total_ }} {{ this.detail_CODAmount }} {{ use_language.bath }}</span>
                  <br>
                  <br>
                  <span
                    v-if="this.detail_IsCOD == true && this.detail_referenceSourceID != 3 && this.detail_referenceSourceID != 4 && this.detail_referenceSourceID != 11">
                    <strong> {{ use_language.bank }} : </strong>{{ this.detail_BankName }} {{ this.detail_AccountName }}
                    {{
                      this.detail_AccountNumber }}
                  </span>

                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="12">
                  <v-radio-group v-model="cod_list_select" row>
                    <v-radio v-for="n in cod_list" :key="n.ID" :label="n.text" :value="n.ID"></v-radio>
                  </v-radio-group>
                  <br>
                  <v-divider />
                </v-col>
                <v-col cols="12" v-if="cod_list_select == 0">
                  <v-row class="pl-10 pb-3">
                    <v-col cols="12" sm="12" lg="12">
                      <v-btn @click="order_update_iscod_status(1)" color="primary">{{ use_language.button_save }}</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" v-else>
                  <v-row>
                    <v-col cols="12" sm="2" lg="1"><strong> {{ use_language.total_ }} : </strong></v-col>
                    <v-col cols="12" md="10" lg="11">
                      <v-text-field :value="edit_cod_amount" @change="value => edit_cod_amount = value"
                        autocomplete="off" ref="edit_cod_amount" type="number" outlined hide-details dense
                        style="max-width: 150px;"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="2" lg="1"><strong> {{ use_language.bank }} : </strong></v-col>
                    <v-col cols="12" md="10" lg="11">
                      <v-container v-if="cod_bank_data.length > 0" class="px-0" fluid>
                        <v-radio-group v-model="edit_cod_bank" ref="edit_cod_bank_2">
                          <v-radio v-for="n in cod_bank_data" :key="n.ID" :label="`${n.text}`" :value="n.ID"></v-radio>
                        </v-radio-group>
                      </v-container>
                      <div v-else>
                        {{ use_language.no_bank_info }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class=" pb-3">
                    <v-col cols="12">
                      <v-btn @click="order_update_iscod_status(1)" color="primary">{{ use_language.button_save }}</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>

            <v-card class="px-5 py-2  v-card-bottom-30" elevation="1" v-if="can_edit_product == false">
              <v-card-title>

                <!-- สินค้าที่สั่ง -->
              </v-card-title>
              <v-row>
                <v-col cols="6">
                  <h3>{{ use_language.ordered_products }}</h3>
                </v-col>
                <v-col cols="6" align="right">
                  <v-btn icon v-if="!isArchive" :disabled="!authorize"
                    @click="get_data_stock_for_edit(), edit_cod_amount = detail_CODAmount, edit_insurance_amount = detail_InsuranceAmount"><v-icon
                      size="18">fa-edit</v-icon></v-btn></v-col>
              </v-row>
              <v-row class="form-group">
                <v-col style="background: #fff ;" cols="12">
                  <v-simple-table v-if="orderItemInvoice_tmp.length != 0" class="packhai-border-table">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center" width="120px">{{ use_language.image }}</th>
                          <th class="text-left">{{ use_language.product }}</th>
                          <th class="text-left">{{ use_language.barcode }}</th>
                          <th class="text-left">{{ use_language.sku }}</th>
                          <th class="text-right">{{ use_language.quantity }}</th>
                          <th class="text-right">{{ use_language.price_per_piece }}</th>
                          <th class="text-right">{{ use_language.discount }}</th>
                          <th class="text-right">{{ use_language.total_price }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item2 in orderItemInvoice_tmp" :key="item2.id">
                          <td class="text-center">
                            <div align="center">
                              <v-img style="margin:5px;" :src="item2.photoLink" aspect-ratio="1" class="grey lighten-2"
                                width="50" height="50" @click="image_click(item2.photoLink, 0)"></v-img>
                            </div>

                          </td>
                          <td class="text-left">
                            {{ item2.productName }}
                            <span class="fn-11 color-b3">
                              {{ (item2.prop1Description != null ? item2.prop1Description : "") +
                                (item2.prop2Description
                                  != null && item2.prop2Description != '' ? ", " + item2.prop2Description : "") }}
                            </span>
                          </td>
                          <td class="text-left">{{ item2.barcode }}</td>
                          <td class="text-left">{{ item2.sku }}</td>
                          <td class="text-right">{{ item2.quantity }}</td>
                          <td class="text-right">{{ item2.unitPrice }}</td>
                          <td class="text-right">{{ item2.discount }}</td>
                          <td class="text-right"><span v-if="item2.quantity != null">{{ format_price(item2.unitPrice *
                            item2.quantity - item2.discount) }}</span></td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <div v-else>-</div>
                </v-col>
                <v-col cols="12" md="6" class="py-0" justify="end">
                </v-col>
                <v-col cols="12" md="6" class="py-0" justify="end" v-if="detail_order['shippingStatusID'] == 10">
                </v-col>
              </v-row>
              <v-row
                v-if="orderItemTempList.length == 0 || (!platformReferenceSourceID.includes(this.detail_referenceSourceID))">
                <v-col cols="4">
                  <table style="width:100%">
                    <tr>
                      <td class="pb-2">
                        <strong>{{ use_language.cargo_insurance }} :</strong>
                      </td>
                      <td class="pb-2" style="width: 150px;">
                        <span v-if="this.detail_InsuranceAmount != null">{{ format_price(this.detail_InsuranceAmount) }}
                          {{ use_language.bath }}</span>
                        <span v-else> {{ use_language.no_insurance }}</span>
                      </td>
                    </tr>
                  </table>
                </v-col>
                <v-col cols="8">
                  <table style="width:100%">
                    <tr>
                      <td class="text-right pb-2">
                        <strong> <span v-if="OrderMaster.VATType == null || OrderMaster.VATType == 0 || OrderMaster.VATType == 1">{{
                          use_language.total_price }}</span>
                          <span v-if="OrderMaster.VATType == 2">{{ use_language.price_including_tax }}</span> <span
                            v-if="OrderMaster.VATType == 3">{{ use_language.price_not_include_tax }} :</span> </strong>
                      </td>
                      <td class="text-right  pb-2" style="width: 150px;">
                        <span v-if="this.detail_totalPrice != null">
                          {{ format_price(this.detail_totalPrice) }} {{ use_language.bath }}</span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-right  pb-2">
                        <strong>{{ use_language.shipping_cost }} :</strong>
                      </td>
                      <td class="text-right  pb-2" style="width: 150px;">
                        <span v-if="this.detail_DeliveryCost != null">{{ format_price(this.detail_DeliveryCost) }}
                          {{ use_language.bath }}</span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-right  pb-2">
                        <strong>{{ use_language.discount }} :</strong>
                      </td>
                      <td class="text-right  pb-2" style="width: 150px;">
                        <span v-if="this.detail_DeliveryCost != null">{{ format_price(this.OrderMaster.OrderDiscount * -1) }}
                          {{ use_language.bath }}</span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-right  pb-2">
                        <strong
                          v-if="OrderMaster.VATType == null || OrderMaster.VATType == 0 || OrderMaster.VATType == 1">{{
                            use_language.no_vat_ }}
                          :</strong>
                        <strong v-else-if="OrderMaster.VATType == 2">{{ use_language.vat_included_ }} :</strong>
                        <strong v-else-if="OrderMaster.VATType == 3">{{ use_language.vat_excluded_ }} :</strong>
                      </td>
                      <td class="text-right  pb-2" style="width: 150px;">
                        <span v-if="this.detail_DeliveryCost != null">{{ format_price(OrderMaster.VATAmount) }}
                          {{ use_language.bath }}</span>
                        <span v-else> 0 {{ use_language.bath }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-right  pb-2">
                        <strong>{{ use_language.total_all }} :</strong>
                      </td>
                      <td class="text-right  pb-2" style="width: 150px;">
                        <span v-if="detail_sum_unintPrice_and_DeliveryCost != null && OrderMaster.VATType == 3">{{
                          format_price(parseFloat(detail_totalPrice) + parseFloat(detail_DeliveryCost) +
                            parseFloat(OrderMaster.VATAmount) - parseFloat(OrderMaster.OrderDiscount)) }}
                          {{ use_language.bath }}</span>
                        <span
                          v-else-if="detail_sum_unintPrice_and_DeliveryCost != null && OrderMaster.VATType == 2">{{
                            format_price(parseFloat(detail_totalPrice) + parseFloat(detail_DeliveryCost) -
                              parseFloat(OrderMaster.OrderDiscount)) }} {{ use_language.bath }}</span>
                        <span
                          v-else-if="detail_sum_unintPrice_and_DeliveryCost != null && OrderMaster.VATType == 1">{{
                            format_price(parseFloat(detail_totalPrice) + parseFloat(detail_DeliveryCost) +
                              (detail_DeliveryCost == null
                                ? 0 : parseFloat(OrderMaster.OrderDiscount) * -1)) }} {{ use_language.bath }} </span>
                        <span v-else> 0 {{ use_language.bath }} </span>
                      </td>
                    </tr>
                  </table>
                </v-col>
              </v-row>
            </v-card>


            <v-card class="px-5 py-5 v-card-bottom-30" elevation="1" v-if="can_edit_product == true">

              <v-row class="form-group">
                <v-col cols="6">
                  <h3>{{ use_language.edit_product }}</h3>
                </v-col>
                <v-col cols="6" align="right">
                  <v-btn icon class="ma-0" @click="can_edit_product = false"><v-icon size="18">fa-edit</v-icon></v-btn>
                </v-col>
              </v-row>
              <v-row v-if="!IsAbleToEditOrderItem" class="form-group">
                <v-col cols="12">

                  <ul style="color:red">
                    <li>
                      {{ use_language.order_detail_desc_1 }}
                    </li>
                    <li>
                      {{ use_language.order_detail_desc_2 }}
                    </li>
                    <li>
                      {{ use_language.order_detail_desc_3 }}
                    </li>
                  </ul>

                </v-col>

              </v-row>
              <v-row class="form-group">
                <v-col cols="12" class="pa-0">
                  <v-card-text class="pa-0">
                    <v-row>
                      <v-col cols="12" md="5" lg="3" class="pt-0">
                        <v-select v-if="detailOrderProduct_tmp.length != 0" v-model="Warehouse_List_selected"
                          :items="Warehouse_List" item-text="name" item-value="id" persistent-hint return-object dense
                          hide-details disabled outlined single-line></v-select>
                        <v-select v-else v-model="Warehouse_List_selected" :items="Warehouse_List" item-text="name"
                          item-value="id" persistent-hint return-object dense hide-details outlined
                          single-line></v-select>
                      </v-col>
                      <v-col cols="12" md="7" lg="9" class="py-0">
                        <v-btn color="primary" class="mr-1" outlined @click="OpenPopup(limits, 0)">
                          <v-icon center>mdi-plus</v-icon>
                          {{ use_language.select_product }}
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="pb-0">
                        <v-data-table :headers="header_edit_item_show" :items="detailOrderProduct_tmp"
                          :items-per-page="10000" hide-default-footer :no-data-text="use_language.please_select_product"
                          class="packhai-border-table packhai-table">
                          <template v-slot:no-data> <span>{{ use_language.please_select_product }}</span> </template>

                          <template v-slot:item.Index="{ item }">
                            {{ detailOrderProduct_tmp.indexOf(item) + 1 }}
                          </template>
                          <template v-slot:item.orderMasterId="{ item }">
                            <v-text-field :value="item.orderMasterId" @change="value => item.orderMasterId = value"
                              autocomplete="off" dense hide-details outlined ref="OrderItemTempID"
                              type="number"></v-text-field>
                          </template>
                          <template v-slot:item.photoLink="{ item }">
                            <v-img :src="item.photoLink == null ? '' : item.photoLink" width="50" height="50"
                              class="ma-1"></v-img>
                          </template>
                          <template v-slot:item.productName="{ item }">
                            {{ item.productName }}
                            <br v-if="item.prop1Description != null && item.prop1Description != ''" />
                            <span class="fn-11 color-b3"
                              v-if="item.prop1Description != null && item.prop1Description != ''">
                              {{ (item.prop1Description != null ? item.prop1Description : "") + (item.prop2Description
                                !=
                                null && item.prop2Description != '' ? ", " + item.prop2Description : "") }}
                            </span>
                            <br v-if="item.barcode != null && item.barcode != ''" />
                            <span class="fn-11 color-b3" v-if="item.barcode != null && item.barcode != ''">

                              barcode : {{ item.barcode }}
                            </span>
                            <br v-if="item.sku != null && item.sku != ''" />
                            <span class="fn-11 color-b3" v-if="item.sku != null && item.sku != ''">

                              sku : {{ item.sku }}
                            </span>

                          </template>
                          <template v-slot:item.unitPrice="{ item }">
                            <v-text-field :value="item.unitPrice" @change="value => item.unitPrice = value"
                              autocomplete="off" dense hide-details outlined ref="untiPriceInput" type="number"
                              @blur="unitPriceInput(item)"></v-text-field>
                          </template>
                          <template v-slot:item.quantity="{ item }">
                            <v-text-field :value="item.quantity" @change="value => item.quantity = value"
                              autocomplete="off" dense hide-details outlined ref="quantity" type="number"
                              @blur="quantityInput(item)"></v-text-field>
                          </template>
                          <template v-slot:item.discountPercent="{ item }">
                            <v-text-field v-model="item.discountPercent"
                              :disabled="item.quantity == '' || item.quantity == null" autocomplete="off" dense
                              hide-details outlined type="number" @input="calculateDiscountPercent(item)"
                              @change="calculateTotalStockPrice()"></v-text-field>
                          </template>
                          <template v-slot:item.discount="{ item }">
                            <v-text-field v-model="item.discount"
                              :disabled="item.discountPercent != '' || item.discountPercent != null" autocomplete="off"
                              dense hide-details outlined type="number"></v-text-field>
                          </template>
                          <template v-slot:item.itemPrice="{ item }">
                            <span v-if="item.itemPrice != null">{{ formatMoney(item.itemPrice.toFixed(2)) }}</span>
                            <span v-else>{{ item.itemPrice }}</span>
                          </template>
                          <template v-slot:item.Delete="{ item }">
                            <v-btn icon color="red"
                              @click="remove_data_product(item )"><v-icon>mdi-delete-outline</v-icon></v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row justify="end">
                      <v-col cols="12" lg="6" class="hidden-md-and-down pa-0"
                        v-if="detail_IsCOD == true && IsCanEditCOD">
                        <v-row class="py-3">
                          <v-col lg="3" xl="2">
                            <span style="color : red;"><b>{{ use_language.elite }} COD :</b></span>
                          </v-col>
                          <v-col lg="3" xl="3">
                            <v-text-field :value="edit_cod_amount" @change="value => edit_cod_amount = value"
                              autocomplete="off" ref="edit_cod_amount" type="number" outlined hide-details
                              dense></v-text-field>
                          </v-col>
                          <v-col lg="7" xl="6">
                          </v-col>
                        </v-row>

                        <v-row class="py-3">
                          <v-col lg="3" xl="2">
                            <span style="color : red;"><b>{{ use_language.insure_product }} :</b></span>
                          </v-col>
                          <v-col lg="3" xl="3">
                            <v-text-field :value="edit_insurance_amount"
                              @change="value => edit_insurance_amount = value" autocomplete="off"
                              ref="edit_insurance_amount" type="number" outlined hide-details dense></v-text-field>
                          </v-col>
                          <v-col lg="7" xl="6">
                          </v-col>
                        </v-row>

                      </v-col>
                      <v-col cols="12" lg="6" class="pa-0">
                        <v-divider></v-divider>
                        <v-row class="py-3">
                          <v-col cols="6">
                            {{ use_language.total_product_value }}
                          </v-col>
                          <v-col cols="6" align="right">
                            <span>{{ formatMoney(this.ProductPrice.toFixed(2)) }}</span>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="py-3">
                          <v-col cols="6">
                            {{ use_language.vat }}
                          </v-col>
                          <v-col cols="6" align="end">
                            {{ format_price(totalVat) }}
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="py-3">
                          <v-col cols="8">
                            {{ use_language.shipping_cost }}
                          </v-col>
                          <v-col cols="4">
                            <v-text-field :value="textField_deliveryCost" autocomplete="off" dense hide-details outlined
                              type="number" @blur="calculateDiscountOrder()"
                              @change="value => textField_deliveryCost = value"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="justify-space-between">
                          <v-col cols="8" class="d-flex">
                            {{ use_language.discount }}
                            <v-select style="width:50px;" v-model="select_discountType" :items="['฿', '%']" dense
                              hide-details outlined class="pl-2" @change="calculateDiscountOrder()"></v-select>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field :value="textField_discount" autocomplete="off" dense hide-details outlined
                              type="number" @blur="calculateDiscountOrder()"
                              @change="value => textField_discount = value"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="py-3">
                          <v-col cols="4" md="2">
                            {{ use_language.vat }}
                          </v-col>
                          <v-col cols="8" md="10" align="end">
                            {{ format_price(totalVat) }}
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pb-4">
                          <v-col cols="4" md="2">
                            <h4>{{ use_language.total }}</h4>
                          </v-col>
                          <v-col cols="8" md="10" align="end">
                            <h4>{{ format_price((totalPrice + Number(textField_deliveryCost) - totalDiscount) +
                              (select_vatType == 3
                                ? totalVat : 0)) }}</h4>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row>
                          <v-col class="pb-0">
                            <v-select v-model="select_vatType"
                              :items="[{ text: use_language.no_tax, value: 1 }, { text: use_language.price_including_tax, value: 2 }, { text: use_language.price_not_include_tax, value: 3 }]"
                              dense hide-details item-text="text" item-value="value" outlined
                              @change="calculateVAT()"></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="pb-0">
                            <v-textarea :value="textarea_remarkProduct" dense hide-details outlined
                              :placeholder="use_language.note" rows="2" @change="value => textarea_remarkProduct = value">
                              <template v-slot:label> <span>{{ use_language.note }}</span> </template>
                            </v-textarea>
                          </v-col>
                        </v-row>
                        <v-row class="py-3 hidden-lg-and-up" v-if="detail_IsCOD == true && IsCanEditCOD">
                          <v-col cols="4" md="2">
                            <span style="color : red;"><b>{{ use_language.elite }} COD :</b></span>
                          </v-col>
                          <v-col cols="8" md="10">
                            <v-text-field :value="edit_cod_amount" @change="value => edit_cod_amount = value"
                              autocomplete="off" ref="edit_cod_amount" type="number" outlined hide-details
                              dense></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row justify="end">
                      <v-col lg="5" align="right">
                        <v-btn color="primary" @click="update_data_product()">{{ use_language.save }}</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card>

            <!-- สินค้าที่แพ็ก -->
            <v-card class="px-5 py-5 v-card-bottom-30" elevation="1" v-if="can_edit_packaged == false">
              <v-row class="form-group">
                <v-col cols="6">
                  <h3>{{ use_language.packaged_goods }}</h3>
                </v-col>
                <v-col cols="6" align="right">
                  <v-btn icon v-if="!isArchive" :disabled="!authorize" @click="btnEditPackaged()"><v-icon
                      size="18">fa-edit</v-icon></v-btn>
                </v-col>
              </v-row>
              <v-row class="form-group">
                <v-col style="background: #fff ;" cols="12">
                  <div class="mb-5" v-for="pac in packageList" :key="pac.id">
                    <v-row class="pa-0 ma-0 ">
                      <v-col cols="6" class="pa-0">
                        <b class="pr-2">Package #{{ pac.packageNo + ' (PK' + pac.id + ')' }}</b>
                      </v-col>
                      <v-col cols="6" class="pa-0 text-right">
                        <span v-if="pac.dueDeliveryDate != null">{{ use_language.due_delivery_date }} : {{
                          set_format_date_time(pac.dueDeliveryDate).substr(0, 10) }}</span>
                      </v-col>
                    </v-row>
                    <v-simple-table v-if="pac.itemList.length != 0" class="packhai-border-table">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-center" width="120px">{{ use_language.image }}</th>
                            <th class="text-left">{{ use_language.product }}</th>
                            <th class="text-left" width="140px">{{ use_language.barcode }}</th>
                            <th class="text-left" width="140px">{{ use_language.sku }}</th>
                            <th v-if="IsHasSerial" class="text-right" width="120px">Serial No</th>
                            <th class="text-center" width="120px">{{ use_language.quantity_need_to_pack }}</th>
                            <th class="text-center" width="120px">{{ use_language.actual_number_of_packs }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item2 in pac.itemList" :key="item2.id">
                            <td class="text-center">
                              <div align="center">
                                <v-img style="margin:5px;" :src="item2.photoLink" aspect-ratio="1"
                                  class="grey lighten-2" width="50" height="50"
                                  @click="image_click(item2.photoLink, 0)"></v-img>
                              </div>

                            </td>
                            <td class="text-left">
                              {{ item2.productName }}
                              <span class="fn-11 color-b3">
                                {{ (item2.prop1Description != null ? item2.prop1Description : "") +
                                  (item2.prop2Description != null ? " , " + item2.prop2Description : "") }}
                              </span>
                            </td>
                            <td class="text-left">{{ item2.barcode }}</td>
                            <td class="text-left">{{ item2.sku }}</td>
                            <td v-if="IsHasSerial" class="text-right">{{ item2.serialNumber }}</td>
                            <td class="text-center">{{ formatMoney(item2.quantity) }}</td>
                            <td class="text-center">{{ formatMoney(item2.packedQuantity) }}</td>


                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <div v-else>-</div>
                  </div>
                </v-col>
              </v-row>
            </v-card>

            <v-card class="px-5 py-5 v-card-bottom-30" elevation="1" v-if="can_edit_packaged == true">
              <v-row class="form-group">
                <v-col cols="6">
                  <h3>{{ use_language.edit }}{{ use_language.packaged_goods }}</h3>
                </v-col>
                <v-col cols="6" align="right">
                  <v-btn icon v-if="!isArchive" :disabled="!authorize" @click="can_edit_packaged = false"><v-icon
                      size="18">fa-edit</v-icon></v-btn>
                </v-col>
              </v-row>
              <v-row class="form-group">
                <v-col style="background: #fff ;" cols="12">
                  <div class="mb-5" v-for="pac of packageList" :key="pac.id">



                    <v-row class="pa-0 ma-0 ">
                      <v-col cols="6" class="pa-0">
                        <b class="pr-2">Package #{{ pac.packageNo + ' (PK' + (pac.id == 0 ? "" : pac.id) + ')' }}</b>
                        <v-btn class="mr-2" color="primary" outlined :disabled="checkSplitBtn(pac)"
                          @click="btnSplitPackage(pac)">
                          {{ use_language.separate_parcel }}
                        </v-btn>
                        <v-btn color="primary" outlined
                          @click="{ OpenPopupAddPackage(pac, limits, 0), packageNo = pac.packageNo }" :disabled="checkSplitBtn1(pac)">
                          {{ use_language.ad_product }}
                        </v-btn>
                      </v-col>
                      <v-col cols="6" class="pa-0">
                        <table style="width:100%" v-if="!platformReferenceSourceID.includes(detail_referenceSourceID)">
                          <tr>
                            <td class="pa-0 text-right">
                              {{ use_language.due_delivery_date }} :
                            </td>
                            <td class="pa-0" style="width:150px">


                              <v-menu ref="menuStartDate" v-model="pac.showDateMenu" :close-on-content-click="true"  
                                transition="scale-transition" offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field outlined v-model="pac.dueDeliveryDateShow" :label="use_language.start"
                                    prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" clearable
                                    @click:clear="pac.dueDeliveryDateShow = null, pac.dueDeliveryDateTemp = null"
                                    hide-details></v-text-field>
                                </template>
                                <v-date-picker v-model="pac.dueDeliveryDateTemp"
                                  @change="pac.dueDeliveryDateShow = formatDateTimeToThai(pac)" no-title scrollable>
                                </v-date-picker>
                              </v-menu>
                            </td>
                          </tr>
                        </table>
                      </v-col>

                    </v-row>


                    <v-row>
                      <v-col cols="12" class="pb-0 px-0">


                        <v-data-table v-model="pac.select" :headers="header_edit_item_packag_show" :items="pac.itemList"
                          :items-per-page="10000" item-key="productMasterItemId" hide-default-footer show-select
                          :ripple="false" class="packhai-border-table packhai-table">

                          <template v-slot:no-data> <span>{{ use_language.please_select_product }}</span> </template>
                          <template v-slot:item.data-table-select="{ isSelected, select }">
                            <v-simple-checkbox :ripple="false" class="data-table-select-column" :value="isSelected"
                              @input="select($event)"></v-simple-checkbox>
                          </template>
                          <template v-slot:header.data-table-select="{ on, props }">
                            <v-simple-checkbox class="data-table-select-column" v-bind="props" v-on="on"
                              :ripple="false" />
                          </template>
                          <template v-slot:item.productName="{ item }">
                            {{ item.productName }}
                            <span class="fn-11 color-b3">
                              {{ (item.prop1Description != null ? item.prop1Description : "") + (item.prop2Description
                                !=
                                null && item.prop2Description != '' ? ", " + item.prop2Description : "") }}
                            </span>
                          </template>
                          <template v-slot:item.photoLink="{ item }">

                            <img :src="item.photoLink" height="50" width="50" class="ma-1 "
                              @click="OpenPhoto(item.photoLink)" />

                          </template>

                          <template v-slot:item.Delete="{ item, index }">
                            <v-btn icon color="red" v-if="pac.packageStatusID<80 && pac.endPackingDate==null && pac.packedByStatusMoveDate==null"
                              @click="{ btnDeletePacked(item, index), packageNo = pac.packageNo }"><v-icon>mdi-delete-outline</v-icon></v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>


                  </div>
                </v-col>
              </v-row>
              <v-row justify="end">
                <v-col cols="4" lg="5" align="right" class="pt-4">
                  <v-btn color="primary" @click="btnSaveChangePackage()">{{ use_language.save }}</v-btn>
                </v-col>
              </v-row>
            </v-card>

            <v-card class="px-5 py-5 v-card-bottom-30" elevation="1">
              <v-row class="form-group">
                <v-col cols="6">
                  <h3>{{ use_language.note }} {{ use_language.for_shop }}</h3>
                </v-col>
                <v-col cols="6" align="right">
                  <v-btn icon v-if="!isArchive" :disabled="!authorize" class="ma-0"
                    @click="can_edit_remark = !can_edit_remark, edit_detail_remark = detail_Remark"><v-icon
                      size="18">fa-edit</v-icon></v-btn>
                </v-col>
              </v-row>
              <v-row class="form-group">
                <v-col v-if="can_edit_remark == true" cols="12" md="8" lg="6">
                  <v-textarea v-model="edit_detail_remark" filled auto-grow></v-textarea>
                  <br>
                  <v-btn @click="detail_edit_remark(null, 0)" dark color="primary">{{ use_language.save }}</v-btn>
                </v-col>
                <v-col v-else style="background: #fff ;" cols="12">
                  <span v-if="this.detail_Remark == null">-</span> <span v-else>{{ this.detail_Remark }}</span>
                </v-col>
              </v-row>
            </v-card>

            <v-card class="px-5 py-5 v-card-bottom-30" elevation="1">
              <v-row class="form-group">
                <v-col cols="6">
                  <h3>{{ use_language.note }} {{ use_language.for_customer }}</h3>
                </v-col>
                <v-col cols="6" align="right">
                  <v-btn icon v-if="!isArchive" :disabled="!authorize" class="ma-0"
                    @click="can_edit_remarkCustomer = !can_edit_remarkCustomer, edit_detail_remarkCustomer = detail_RemarkCustomer"><v-icon
                      size="18">fa-edit</v-icon></v-btn>
                </v-col>
              </v-row>
              <v-row class="form-group">
                <v-col v-if="can_edit_remarkCustomer == true" cols="12" md="8" lg="6">
                  <v-textarea v-model="edit_detail_remarkCustomer" filled auto-grow></v-textarea>
                  <br>
                  <v-btn @click="detail_edit_remark(null, 1)" dark color="primary">{{ use_language.save }}</v-btn>
                </v-col>
                <v-col v-else style="background: #fff ;" cols="12">
                  <span v-if="this.detail_RemarkCustomer == null">-</span> <span v-else>{{ this.detail_RemarkCustomer }}</span>
                </v-col>
              </v-row>
            </v-card>

            <v-card class="px-5 py-5 v-card-bottom-30" elevation="1">
              <v-row class="form-group">
                <v-col cols="6">
                  <h3>{{ use_language.note }} {{ use_language.for_warehouse }}</h3>
                </v-col>
                <v-col cols="6" align="right">
                  <v-btn icon v-if="!isArchive" :disabled="!authorize" class="ma-0"
                    @click="can_edit_remarkWarehouse = !can_edit_remarkWarehouse, edit_detail_remarkWarehouse = detail_RemarkWarehouse"><v-icon
                      size="18">fa-edit</v-icon></v-btn>
                </v-col>
              </v-row>
              <v-row class="form-group">
                <v-col v-if="can_edit_remarkWarehouse == true" cols="12" md="8" lg="6">
                  <v-textarea v-model="edit_detail_remarkWarehouse" filled auto-grow></v-textarea>
                  <br>
                  <v-btn @click="detail_edit_remark(null, 2)" dark color="primary">{{ use_language.save }}</v-btn>
                </v-col>
                <v-col v-else style="background: #fff ;" cols="12">
                  <span v-if="this.detail_RemarkWarehouse == null">-</span> <span v-else>{{ this.detail_RemarkWarehouse }}</span>
                </v-col>
              </v-row>
            </v-card>

            <v-card class="px-5 py-2 v-card-bottom-30" elevation="1">

              <v-row>
                <v-col cols="8">
                  <h3>{{ use_language.order_status_ }}</h3>
                </v-col>
                <v-col cols="4"></v-col>
              </v-row>
              <div>
                 <v-data-table
                  :headers="orderStatusTableHeader"
                  :items="order_status_history_list"
                  class="packhai-border-table"
                  hide-default-footer
                  id="datatablexs"
                  :items-per-page="999999"
                  :mobile-breakpoint="0"
                  > 
                      <template v-slot:item.shippingStatusName="{ item }">
                          {{ item.shippingStatusName==null?  item.description :item.shippingStatusName }}
                      </template>
                      <template v-slot:item.date="{ item }">
                          {{ formatDatetime(item.date) }}
                      </template>
                
                  
                  </v-data-table>

                
              </div>
            </v-card>

           

            <v-card class="px-5 py-5 v-card-bottom-30" elevation="1"
              v-if="!platformReferenceSourceID.includes(this.detail_referenceSourceID) && this.detail_IsCOD == false">
              <v-row class="form-group">
                <v-col cols="6">
                  <h3>{{ use_language.transfer_notification }}</h3>
                </v-col>
                <v-col cols="6" align="right">
                  <v-btn class="hidden-xs-only" outlined color="success"
                    @click="btnOpenAddSlip(), isFullscreen = false, can_edit_cod()"><v-icon left>fa-plus</v-icon>{{
                      use_language.add_payment_statement }}</v-btn>
                  <v-btn class="hidden-sm-and-up" outlined color="success"
                    @click="btnOpenAddSlip(), isFullscreen = true, can_edit_cod()"><v-icon left>fa-plus</v-icon>{{
                      use_language.add_payment_statement }}</v-btn>
                </v-col>
              </v-row>
              <v-row class="form-group">
                <v-col style="background: #fff ;overflow-x: auto" cols="12">
                  <v-simple-table class="packhai-border-table" style="min-width:1240px">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center" style="width:60px"></th>
                          <th class="text-center" style="width:60px"></th>
                          <th class="text-center" style="width:120px">{{ use_language.due_payment }}</th>
                          <th class="text-center" style="width:150px">{{ use_language.transfer_date }}</th>

                          <th class="text-center" style="width:180px">{{ use_language.bank }}</th>
                          <th class="text-center" style="width:90px">{{ use_language.quantity }}</th>
                          <th class="text-center" style="width:90px">{{ use_language.withholding }}</th>
                          <th class="text-center" style="width:90px">{{ use_language.status }}</th>
                          <th class="text-center" style="width:150px">{{ use_language.remark }}</th>
                          <th class="text-center" style="width:90px">{{ use_language.slip }}</th>
                          <th class="text-center" style="width:150px">{{ use_language.updated }}</th>
                          <th class="text-center" style="width:90px">{{ use_language.updated_by }}</th>

                          <!-- <th class="text-center" v-if="detail_statusId == 20 && CanApprove ==1">{{use_language.delete}}</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in detailOrderPayment" :key="item.name">

                          <td class="text-center"> <v-btn v-if="item.id != 0" icon @click="btnEditPayment(item)"
                              color="primary"><v-icon class="fn-18" color="primary">fa-edit</v-icon></v-btn> </td>
                          <td class="text-center"> <v-btn v-if="item.id != 0" icon
                              @click="delete_data_payment_alert(item)" color="primary"><v-icon class="fn-18"
                                color="red">fa-trash-alt</v-icon></v-btn> </td>
                          <td class="text-center">{{ set_format_date_time(item.dueDate).substr(0, 10) }}</td>
                          <td class="text-center">{{ set_format_date_time(item.informDatetime) }}</td>

                          <td class="text-left">{{ item.bankAccountText }}</td>
                          <td class="text-right">{{ format_price(item.amount) }}</td>
                          <td class="text-right">{{ format_price(item.withholdingAmount) }}</td>
                          <td class="text-center">
                            <span v-if="item.statusID == 1">{{ use_language.draft }}</span>
                            <span style="color:orange" v-if="item.statusID == 2">{{ use_language.awaiting_payment }}</span>
                            <span style="color:purple" v-if="item.statusID == 3">{{ use_language.balance_tracking }}</span>
                            <span style="color:green" v-if="item.statusID == 4">{{ use_language.paid_status }}</span>
                          </td>
                          <td class="text-left">{{ item.remark }}</td>
                          <td class="text-lecenterft">
                            <v-img v-if="item.photoLink != null" style="margin:5px;" :src="item.photoLink"
                              aspect-ratio="1" class="grey lighten-2" max-width="50" max-height="50"
                              @click="OpenPhoto(item.photoLink, 0)"></v-img>
                          </td>
                          <td class="text-center">{{ set_format_date_time((item.updateDateTime == null ?
                            item.createdDatetime : item.updateDateTime)) }}</td>
                          <td class="text-center">{{ (item.updateByName == null ? item.createdByName
                            : item.updateByName) }}</td>
                          <!-- <td class="text-center" style="width: 240px" v-if="detail_statusId == 20 && CanApprove ==1" >
                            <v-row class="pa-0" v-if="item.disApproved == null && item.approved == null ">
                              <v-col cols="12" md="6" class="pa-0 py-2">
                                <v-btn @click="approvePaymentAlert(item.id, item.orderMasterID), show_reject = false" dark color="success" class="mx-2"><v-icon left>fa-check-circle</v-icon>{{use_language.approve}}</v-btn>
                              </v-col>
                              <v-col cols="12" md="6" class="pa-0 py-2">
                                <v-btn @click="rejectPaymentAlert(item.id, item.orderMasterID), show_reject = true" dark outlined color="danger" class="mx-2"><v-icon left>fa-times-circle</v-icon>{{use_language.reject}}</v-btn>
                              </v-col>
                            </v-row>
                            <span v-else-if="item.approved != null" style="color: green;"> <b>{{use_language.approve}}</b></span>
                            <span v-else-if="item.disApproved != null" style="color: red;"><b>{{use_language.reject}}</b></span>
                          </td> -->

                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <br>
                  <v-btn v-if="CanApprove == 1 && show_reject == true" @click="backStatusOrderToOpen()" dark
                    color="danger" class="mx-2"><v-icon left>fa-undo-alt</v-icon>{{ use_language.Bounce_order }}</v-btn>
                </v-col>
              </v-row>
            </v-card>

            <v-card class="px-5 py-5 v-card-bottom-30" elevation="1">
              <v-row class="form-group">
                <v-col cols="6">
                  <h3>{{ use_language.attachment }}</h3>
                </v-col>
                <v-col cols="6" align="right">
                  <v-btn color="success" outlined @click="dialog_doc = true"><v-icon left>fa-plus</v-icon>{{
                    use_language.Adddocument }}</v-btn>
                </v-col>
              </v-row>
              <v-row class="form-group">
                <v-col style="background: #fff ;" cols="12">
                  <v-simple-table class="packhai-border-table">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">File url</th>
                          <th class="text-left">{{ use_language.category }}</th>
                          <th class="text-left">{{ use_language.delete }}</th>
                          <!-- <th class="text-center" v-if="detail_statusId == 20 && CanApprove ==1">{{use_language.delete}}</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in fileAttach" :key="item.id">
                          <td class="text-left">

                            <a v-if="item.fileUrl" :href="item.fileUrl" target="_blank">
                               {{ use_language.click_ }}
                              <input type="hidden" id="testing-code" style="width:100%" v-model="item.fileUrl" />
                            </a>
                             <a  v-if="item.base64Data"  @click="ConvertBase64ToPDF(item.base64Data)" target="_blank">
                              {{ use_language.click_ }}
                               
                            </a>
                       
                          </td>
                          <td class="text-left">{{ ((item.documentTypeID==1)?use_language.cover_page:item.documentType) }}</td>
                          <td class="text-center" width="60px">
                            <a @click="DeleteFileAttach(item.id)"><v-icon size="16"
                                color="red darken-3">fa-trash-alt</v-icon></a>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <br>
                  <v-btn v-if="CanApprove == 1 && show_reject == true" @click="backStatusOrderToOpen()" dark
                    color="danger" class="mx-2"><v-icon left>fa-undo-alt</v-icon>{{ use_language.Bounce_order }}</v-btn>
                </v-col>
              </v-row>
            </v-card>

            <v-dialog v-model="dialog_doc" persistent max-width="800">
              <v-card>
                <v-card-title>
                  {{ use_language.Adddocument }}
                  <v-spacer />
                  <v-btn icon @click="dialog_doc = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-divider />
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="3" lg="3" class="pb-0">
                      <h4>{{ use_language.category_ }} :</h4>
                    </v-col>
                    <v-col cols="12" sm="9" lg="5" class="pb-0">
                      <v-select v-model="input_doc_select" ref="input_doc_select"
                        :items="[{ 'value': null, 'name': use_language.please_select_ }, { 'value': 'ใบปะหน้า', 'name': use_language.print_cover_sheet }, { 'value': 'ใบกำกับภาษี', 'name': use_language.tax_invoice }]"
                        item-text="name" item-value="value" outlined dense hide-details="auto"></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" lg="3" class="pb-0">
                      <h4>{{ use_language.document }} :</h4>
                    </v-col>
                    <v-col cols="12" sm="9" lg="5" class="pb-0">
                      <v-file-input v-model="input_docFileUpload" ref="input_docFileUpload"
                        accept="image/x-png,image/gif,image/jpeg, application/pdf" :placeholder="use_language.supports_"
                        outlined hide-details="auto" dense prepend-icon="" prepend-inner-icon="mdi-file">
                        <template v-slot:label> <span>{{ use_language.supports_ }}</span> </template>
                        <template v-slot:selection="{ text }">
                          <v-chip small label color="primary">
                            {{ text }}
                          </v-chip>
                        </template>
                      </v-file-input>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-divider />
                <v-card-actions class="p2-5">
                  <v-btn outlined color="primary" @click="submit_docFile()">
                    {{ use_language.Adddocument }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <div v-if="packageList != null && packageList.length > 0">
              <div v-for="pac in packageList" :key="pac.id">
                <v-card elevation="1" class="v-card-bottom-30">
                  <v-card-text>
                    <v-row>
                      <v-col cols="6">
                        <h3>{{ use_language.box_pack }} #{{ pac.packageNo }}</h3>
                      </v-col>
                      <v-col cols="6" class="text-right">
                        <v-btn icon class="ma-0" @click="OpenEditBoxDialog(pac)"><v-icon
                            size="18">fa-edit</v-icon></v-btn>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                        <b> {{ use_language.weight }} : </b>
                      </v-col>
                      <v-col cols="8" md="9" lg="10" class="pb-0">
                        <span v-if="pac.weight != null">{{ pac.weight }} {{ use_language.kg }}</span>
                        <span v-else> - </span>
                      </v-col>
                      <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                        <b> {{ use_language.width_length_height }} : </b>
                      </v-col>
                      <v-col cols="8" md="9" lg="10" class="pb-0">
                        <span v-if="pac.cubic1 != null && pac.cubic2 != null && pac.cubic3 != null">{{ pac.cubic1 + ' x '+ pac.cubic2 + ' x ' + pac.cubic3 }}</span>
                        <span v-else> - </span>
                        <span v-if="pac.boxName != null && pac.boxName != ''">
                          / {{ use_language.box }} {{ pac.boxName }}
                        </span>
                      </v-col>
                      <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                        <b> {{ use_language.freight }} : </b>
                      </v-col>
                      <v-col cols="8" md="9" lg="10" class="pb-0">
                        <span v-if="pac.deliveryPrice != null">{{ pac.deliveryPrice }} {{ use_language.bath }}</span>
                        <span v-else> - </span>
                      </v-col>
                      <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                        <b> {{ use_language.remote_area }} : </b>
                      </v-col>
                      <v-col cols="8" md="9" lg="10" class="pb-0">
                        <span v-if="pac.remotePrice != null">{{ pac.remotePrice }} {{ use_language.bath }}</span>
                        <span v-else> - </span>
                      </v-col>
                      <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                        <b> % COD : </b>
                      </v-col>
                      <v-col cols="8" md="9" lg="10" class="pb-0">
                        <span v-if="pac.codPercent">{{ pac.codPercent }} %</span>
                        <span v-else> - </span>
                      </v-col>
                      <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                        <b> {{ use_language.fee_cod }} : </b>
                      </v-col>
                      <v-col cols="8" md="9" lg="10" class="pb-0">
                        <span v-if="pac.codCharged != null">{{ pac.codCharged }} {{ use_language.bath }}</span>
                        <span v-else> - </span>
                      </v-col>
                      <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                        <b> {{ use_language.box_fee }} : </b>
                      </v-col>
                      <v-col cols="8" md="9" lg="10" class="pb-0">
                        <span v-if="pac.boxPrice != null">{{ pac.boxPrice }} {{ use_language.bath }}</span>
                        <span v-else> - </span>
                      </v-col>
                      <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                        <b> {{ use_language.pack_fee }} : </b>
                      </v-col>
                      <v-col cols="8" md="9" lg="10" class="pb-0">
                        <span v-if="pac.packPrice != null">{{ pac.packPrice }} {{ use_language.bath }}</span>
                        <span v-else> - </span>
                      </v-col>
                      <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                        <b> {{ use_language.bubble_fee }} : </b>
                      </v-col>
                      <v-col cols="8" md="9" lg="10" class="pb-0">
                        <span v-if="pac.bubblePrice != null">{{ pac.bubblePrice }} {{ use_language.bath }}</span>
                        <span v-else> - </span>
                      </v-col>
                      <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                        <b> {{ use_language.otherservice_fee }} : </b>
                      </v-col>
                      <v-col cols="8" md="9" lg="10" class="pb-0">
                        <span v-if="pac.otherServicePrice != null">{{ pac.otherServicePrice }}
                          {{ use_language.bath }}</span>
                        <span v-else> - </span>
                      </v-col>
                      <v-col v-if="pac.vrichTransactionFee != null" cols="4" md="3" lg="2" class="form-group pb-0">
                        <b> {{ use_language.vrichTransaction_fee }} : </b>
                      </v-col>
                      <v-col v-if="pac.vrichTransactionFee != null" cols="8" md="9" lg="10" class="pb-0">
                        <span>{{ detail_VrichTransactionFee }} {{ use_language.bath }}</span>
                      </v-col>
                      <v-col cols="4" md="3" lg="2" class="form-group">
                        <b> {{ use_language.discount }} : </b>
                      </v-col>
                      <v-col cols="8" md="9" lg="10" class="pb-0">
                        <span v-if="pac.discount != null">{{ pac.discount }} {{ use_language.bath }}</span>
                        <span v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-divider>
                    </v-divider>
                     <v-row v-if="platformReferenceSourceID1.includes(detail_referenceSourceID)">
                      <v-col cols="4" md="3" lg="2" class="form-group ">
                        <b> {{ use_language.logistic_type }} : </b>
                      </v-col>
                      <v-col cols="8" md="9" lg="10">
                        <div  v-if="pac.isSellerOwnFleet" align="left">
                          Own fleet
                        </div>
                        <div  v-else  align="left">
                          Platform provided
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" md="3" lg="2" class="form-group ">
                        <b> {{ use_language.transport }} : </b>
                      </v-col>
                      <v-col cols="8" md="9" lg="10">
                        <div v-if="pac.trackStatus != null" align="left">
                          <v-img v-if="pac.trackStatus.expressLogo != null" max-height="10vh" max-width="10vh"
                            :src="pac.trackStatus.expressLogo">
                          </v-img>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" md="3" lg="2" class="form-group  ">
                        <b> {{ use_language.tracking_no }} : </b>
                      </v-col>
                      <v-col cols="8" md="9" lg="10">
                        <div>
                          {{ pac.trackStatus ? pac.trackStatus.trackingNo : '' }}
                          <div class="pb-2" />
                          <div v-if="pac.trackStatus != null" class="hidden-sm-and-down">
                            <div v-if="pac.trackStatus.status != null && pac.trackStatus.status.length > 0">
                              <div v-for="(item, index) in pac.trackStatus.status" :key="index">
                                <span> {{ formatDatetime(item.date) + " " + item.description }} </span>
                              </div>
                            </div>

                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <div v-if="pac.trackStatus != null" class="hidden-sm-and-up">
                      <div v-if="pac.trackStatus.status != null && pac.trackStatus.status.length > 0">
                        <v-row class="pb-2" v-for="(item, index) in pac.trackStatus.status" :key="index">
                          <v-col cols="4" class="pb-0">
                            <span> {{ formatDatetime(item.date) }} </span>
                          </v-col>
                          <v-col cols="8" class="pb-0">
                            <span> {{ item.description }}</span>
                          </v-col>
                        </v-row>
                      </div>

                    </div>
                    <v-row class="pb-2">
                      <v-col cols="4" md="3" lg="2" class="form-group "> <b>{{ use_language.parcel_status }} : </b> </v-col>
                      <v-col cols="8" md="9" lg="10" class="pb-2">
                        <div v-if="pac.trackStatus != null && pac.trackStatus.packageStatusName != ''">
                          <span v-if="pac.trackStatus.packageStatusID == 80" style="color: purple;">{{
                            pac.trackStatus.packageStatusName }} </span>
                          <span v-else-if="pac.trackStatus.packageStatusID == 90" style="color: orange;">{{
                            pac.trackStatus.packageStatusName }} </span>
                          <span v-else-if="pac.trackStatus.packageStatusID == 100" style="color: #ff7ac0;">{{
                            pac.trackStatus.packageStatusName }} </span>
                          <span v-else-if="pac.trackStatus.packageStatusID == 110" style="color: #ff7ac0;">{{
                            pac.trackStatus.packageStatusName }} </span>
                          <span v-else-if="pac.trackStatus.packageStatusID == 120" style="color:  #ff7ac0;">{{
                            pac.trackStatus.packageStatusName }} </span>
                          <span v-else-if="pac.trackStatus.packageStatusID == 130" style="color:  green;">{{
                            pac.trackStatus.packageStatusName }} </span>
                          <span v-else-if="pac.trackStatus.packageStatusID == 140" style="color:  red;">{{
                            pac.trackStatus.packageStatusName }} </span>
                          <span v-else>{{ pac.trackStatus.packageStatusName }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>
            </div>
            <div v-else>
              <v-card elevation="1" class="v-card-bottom-30" v-if="detail_order['shippingStatusID'] >= 30">
                <v-card-text>

                  <v-row>
                    <v-col cols="12">
                      <h3>{{ use_language.box_pack }} #{{ pac.packageNo }}</h3>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                      <b> {{ use_language.weight }} : </b>
                    </v-col>
                    <v-col cols="8" md="9" lg="10" class="pb-0">
                      <span v-if="detail_Weight != null">{{ detail_Weight }} {{ use_language.kg }}</span>
                      <span v-else> - </span>
                    </v-col>
                    <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                      <b> {{ use_language.width_length_height }} : </b>
                    </v-col>
                    <v-col cols="8" md="9" lg="10" class="pb-0">
                      <span v-if="detail_Width != null && detail_Height != null && detail_Long != null">{{ detail_Width
                        + ' x ' +
                        detail_Height + ' x ' + detail_Long }}</span>
                      <span v-else> - </span>
                      <span v-if="detail_BoxName != null && detail_BoxName != ''">
                        / {{ use_language.box }} {{ detail_BoxName }}
                      </span>
                    </v-col>
                    <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                      <b> {{ use_language.freight }} : </b>
                    </v-col>
                    <v-col cols="8" md="9" lg="10" class="pb-0">
                      <span v-if="detail_DeliveryPrice != null">{{ detail_DeliveryPrice }} {{ use_language.bath
                      }}</span>
                      <span v-else> - </span>
                    </v-col>
                    <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                      <b> {{ use_language.remote_area }} : </b>
                    </v-col>
                    <v-col cols="8" md="9" lg="10" class="pb-0">
                      <span v-if="detail_RemotePrice != null">{{ detail_RemotePrice }} {{ use_language.bath }}</span>
                      <span v-else> - </span>
                    </v-col>
                    <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                      <b> % COD : </b>
                    </v-col>
                    <v-col cols="8" md="9" lg="10" class="pb-0">
                      <span v-if="detail_CODPercent">{{ detail_CODPercent }} %</span>
                      <span v-else> - </span>
                    </v-col>
                    <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                      <b> {{ use_language.fee_cod }} : </b>
                    </v-col>
                    <v-col cols="8" md="9" lg="10" class="pb-0">
                      <span v-if="detail_CODCharged != null">{{ detail_CODCharged }} {{ use_language.bath }}</span>
                      <span v-else> - </span>
                    </v-col>
                    <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                      <b> {{ use_language.box_fee }} : </b>
                    </v-col>
                    <v-col cols="8" md="9" lg="10" class="pb-0">
                      <span v-if="detail_BoxPrice != null">{{ detail_BoxPrice }} {{ use_language.bath }}</span>
                      <span v-else> - </span>
                    </v-col>
                    <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                      <b> {{ use_language.pack_fee }} : </b>
                    </v-col>
                    <v-col cols="8" md="9" lg="10" class="pb-0">
                      <span v-if="detail_PackPrice != null">{{ detail_PackPrice }} {{ use_language.bath }}</span>
                      <span v-else> - </span>
                    </v-col>
                    <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                      <b> {{ use_language.bubble_fee }} : </b>
                    </v-col>
                    <v-col cols="8" md="9" lg="10" class="pb-0">
                      <span v-if="detail_BubblePrice != null">{{ detail_BubblePrice }} {{ use_language.bath }}</span>
                      <span v-else> - </span>
                    </v-col>
                    <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                      <b> {{ use_language.otherservice_fee }} : </b>
                    </v-col>
                    <v-col cols="8" md="9" lg="10" class="pb-0">
                      <span v-if="detail_OtherServicePrice != null">{{ detail_OtherServicePrice }}
                        {{ use_language.bath }}</span>
                      <span v-else> - </span>
                    </v-col>
                    <v-col v-if="detail_VrichTransactionFee != null" cols="4" md="3" lg="2" class="form-group pb-0">
                      <b> {{ use_language.vrichTransaction_fee }} : </b>
                    </v-col>
                    <v-col v-if="detail_VrichTransactionFee != null" cols="8" md="9" lg="10" class="pb-0">
                      <span>{{ detail_VrichTransactionFee }} {{ use_language.bath }}</span>
                    </v-col>


                    <v-col cols="4" md="3" lg="2" class="form-group">
                      <b> {{ use_language.discount }} : </b>
                    </v-col>
                    <v-col cols="8" md="9" lg="10" class="pb-0">
                      <span v-if="detail_Discount != null">{{ detail_Discount }} {{ use_language.bath }}</span>
                      <span v-else> - </span>
                    </v-col>
                  </v-row>

                </v-card-text>
              </v-card>
            </div>




            <v-card class="px-5 py-5 v-card-bottom-30" elevation="1" v-if="this.detail_RealTransferDatetime != null">
              <v-row>
                <v-col cols="12">
                  <h3>{{ use_language.date_of_deposit }}</h3>
                </v-col>
                <v-col style="background: #fff ;" cols="12">
                  {{ this.detail_RealTransferDatetime }}
                </v-col>
              </v-row>
            </v-card>

            <!-- รูปภาพแพ็กของ -->
            <v-card class="px-5 py-5 v-card-bottom-30" elevation="1"
              v-if="this.detail_statusId >= 30 && data_master_pic != null && data_master_media != null && (data_master_pic.length > 0 || data_master_media.length > 0)">
              <v-row v-if="data_master_pic.length > 0">
                <v-col cols="12">
                  <h3>{{ use_language.product_pack_picture }}</h3>
                </v-col>
                <v-col style="background: #fff ;" cols="4" md="3" xl="2" lg="2" v-for="item_pic in data_master_pic"
                  :key="item_pic.id">
                  <v-card>
                    <v-img style="margin:5px;" :src="item_pic.pic" aspect-ratio="1" class="grey lighten-2"
                      @click="image_click(item_pic.pic, item_pic.mediaType)"></v-img>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-if="data_master_media.length > 0">
                <v-col cols="12">
                  <h3>{{ use_language.video_pack }}</h3>
                </v-col>
                <div v-for="item_media in data_master_media" :key="item_media.id" style=" width: 100%;">
                  <v-col cols="12" md="6" lg="5" xl="4">
                    <div class="hidden-xs-only">
                      <iframe :src="item_media.pic" allow="autoplay" scrolling="no" frameborder="0" height="400"
                        style="position: relative; width: 100%;"></iframe>
                    </div>
                    <div class="hidden-sm-and-up">
                      <iframe :src="item_media.pic" allow="autoplay" scrolling="no" frameborder="0" height="200"
                        style="position: relative; width: 100%;"></iframe>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" lg="7" xl="8"></v-col>
                </div>
              </v-row>

            </v-card>

            <!-- รายการ RMA (เฉพาะ shop ใน whitelist) -->
            <v-card elevation="0" class="v-card-bottom-10" style="background-color: transparent;"
              v-if="allowedRMAShopIDs.includes(shop_id)">
              <v-card-text class="px-0" style="background-color: transparent;">
                <v-row v-show="this.OrderMaster.ID != ''">
                  <v-col class="px-0 py-0 m-0 my-0">
                    <v-card class="px-5 py-2 v-card-bottom-30" elevation="1">
                      <v-row>
                        <v-col cols="6">
                          <h3>RMA Request</h3>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-data-table
                            :headers="rmaHeaders"
                            :items="rmaList"
                            :loading="rmaLoading"
                            :items-per-page="9999"
                            hide-default-footer
                            :no-data-text="use_language.no_item_list"
                            :loading-text="use_language.loading_dots"
                            class="elevation-0">
                            <template v-slot:[`item.photoLink`]="{ item }">
                              <v-img v-if="item.photoLink" :src="item.photoLink" max-width="50" max-height="50" contain />
                              <v-icon v-else size="40" color="grey lighten-2">mdi-image-off</v-icon>
                            </template>
                            <template v-slot:[`item.created`]="{ item }">
                              {{ formatDatetime(item.created) }}
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- กำไรขาดทุน -->
            <v-card elevation="0" class="v-card-bottom-30" style="background-color: transparent;"
              v-if="checkPermission.SeeCost && (profitSection_OrderItemInvoice.length > 0 || orderItemProfit_tmp.length > 0 || (orderProfit_tmp && orderProfit_tmp.length > 0)) ">
              <v-card-text class="px-0" style="background-color: transparent;">
                <v-row v-show="this.OrderMaster.ID != ''">
                  <v-col class="px-0 py-0 m-0 my-0">
                    <v-card class="px-5 py-2  v-card-bottom-30" elevation="1">
                      <v-card-title>
                      </v-card-title>
                      <v-row>
                        <v-col cols="6">
                          <h3>{{ use_language.profit_report }}</h3>
                        </v-col>

                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-tabs v-model="tab">

                            <v-tab v-for="i in tab_list" :key="i.id" @click="SeeTabDetails(i.id)"> {{ i.name }} </v-tab>
                          </v-tabs>
                        </v-col>

                      </v-row>
                      <v-tabs-items v-model="tab" touchless>
                        <v-tab-item v-for="i in tab_list" :key="i.id">
                          <div v-if="i.id == 0">
                            <v-row v-if="profitSection_OrderItemInvoice.length > 0">
                              <v-col>
                                <span>{{ use_language.ordered_products }}</span>
                                <v-data-table :headers="profitSection_OrderItemInvoice_header"
                                  :items="profitSection_OrderItemInvoice" class="elevation-0 packhai-border-table"
                                  hide-default-footer :items-per-page="10000" mobile-breakpoint="0">
                                  <template v-slot:item.photoLink="{ item }">
                                    <v-img style="margin:5px;" :src="item.photoLink" aspect-ratio="1"
                                      class="grey lighten-2" width="50" height="50"
                                      @click="image_click(item.photoLink, 0)"></v-img>

                                  </template>
                                  <template v-slot:item.product="{ item }">

                                    {{ item.productName }} <span style="color:gray">
                                      {{
                                        (item.prop1Description != null && item.prop1Description != "" ?
                                          item.prop1Description : "") + (item.prop2Description != null &&
                                            item.prop2Description != "" ? " , " + item.prop2Description : "")
                                      }}
                                      <span v-if="item.sku"> {{ use_language.sku + ' : ' + item.sku }}</span>
                                      <span v-if="item.barcode"> {{ ((item.sku) ? ', ' : '') + use_language.barcode + ' : '+item.barcode}}</span>
                                    </span>

                                  </template>
                                  <template v-slot:item.quantity="{ item }">
                                    {{ format_number(item.quantity) }}

                                  </template>
                                  <template v-slot:item.unitPrice="{ item }">
                                    {{ format_price(item.unitPrice) }}

                                  </template>
                                  <template v-slot:item.discount="{ item }">
                                    {{ format_price(item.discount) }}

                                  </template>

                                  <template v-slot:item.total="{ item }">
                                    {{ format_price((item.quantity * item.unitPrice) - item.discount) }}

                                  </template>
                                </v-data-table>
                                <br>
                                <span>{{ use_language.total_productCost }}</span>
                                <v-data-table :headers="headers_lot_import1" :items="profitSection_OrderItemLot"
                                  class="elevation-0 packhai-border-table" hide-default-footer :items-per-page="10000"
                                  mobile-breakpoint="0">
                                  <template v-slot:item.photoLink="{ item }">
                                    <v-img style="margin:5px;" :src="item.photoLink" aspect-ratio="1"
                                      class="grey lighten-2" width="50" height="50"
                                      @click="image_click(item.photoLink, 0)"></v-img>

                                  </template>
                                  <template v-slot:item.product="{ item }">

                                    {{ item.productName }} <span style="color:gray">
                                      {{
                                        (item.prop1Description != null && item.prop1Description != "" ?
                                          item.prop1Description : "") + (item.prop2Description != null &&
                                            item.prop2Description != "" ? " , " + item.prop2Description : "")
                                      }}
                                      <span v-if="item.sku"> {{ use_language.sku + ' : ' + item.sku }}</span>
                                      <span v-if="item.barcode"> {{ ((item.sku) ? ', ' : '') + use_language.barcode + ' : '+item.barcode}}</span>
                                    </span>

                                  </template>
                                  <template v-slot:item.importExportMasterIDText="{ item }">
                                    <a @click="OpenImportExport(item.importExportMasterID)">{{
                                      item.importExportMasterIDText }}</a>

                                  </template>
                                  <template v-slot:item.importDate="{ item }">
                                    {{ formatDatetime(item.importDate).substr(0, 10) }}

                                  </template>
                                  <template v-slot:item.costPrice="{ item }">
                                    {{ format_price(item.costPrice) }}

                                  </template>
                                  <template v-slot:item.quantity="{ item }">
                                    {{ format_number(item.quantity) }}

                                  </template>
                                  <template v-slot:item.total="{ item }">
                                    {{ format_price(item.total) }}

                                  </template>
                                </v-data-table>

                              </v-col>
                            </v-row>
                            <v-row v-else>
                              <v-col cols="12">

                                <v-card v-for="item in orderItemProfit_tmp" :key="item.id"
                                  style="border: 1px solid #d7d7d7;color:black">
                                  <v-card-text style="color:black">

                                    <v-row>
                                      <v-col cols="1" align="left">
                                        <v-img style="margin:5px;" :src="item.photoLink" aspect-ratio="1"
                                          class="grey lighten-2" width="50" height="50"
                                          @click="image_click(item.photoLink, 0)"></v-img>
                                      </v-col>
                                      <v-col cols="3" align="left">
                                        <span class="smallheader">{{ use_language.product }}</span><br>
                                        {{ item.productName }} <span style="color:gray">
                                          {{
                                            (item.prop1Description != null && item.prop1Description != "" ?
                                              item.prop1Description : "") + (item.prop2Description != null &&
                                                item.prop2Description != "" ? " , " + item.prop2Description : "")
                                          }}
                                          <span v-if="item.sku"> {{ use_language.sku + ' : ' + item.sku }}</span>
                                          <span v-if="item.barcode"> {{ ((item.sku) ? ', ' : '') + use_language.barcode + ' : '+item.barcode}}</span>
                                        </span>
                                      </v-col>
                                      <v-col cols="2" align="center">
                                        <span class="smallheader">{{ use_language.quantity }}</span><br>
                                        {{ format_number(item.quantity) }}
                                      </v-col>
                                      <v-col cols="2" align="right">
                                        <span class="smallheader">{{ use_language.price }}(ex vat)</span><br>
                                        {{ format_price(item.unitPrice) }}
                                      </v-col>
                                      <v-col cols="2" align="right">
                                        <span class="smallheader">{{ use_language.discount }}</span><br>
                                        {{ format_price(item.discount) }}
                                      </v-col>

                                      <v-col cols="2" align="right">
                                        <span class="smallheader">{{ use_language.total }}</span><br>
                                        {{ format_price((item.unitPrice * item.quantity) - item.discount) }}
                                      </v-col>

                                    </v-row>

                                    <v-data-table :headers="headers_lot_import" :items="item.lotData"
                                      class="elevation-0 packhai-border-table" hide-default-footer
                                      :items-per-page="10000" mobile-breakpoint="0">
                                      <template v-slot:item.importExportMasterIDText="{ item }">
                                        <a @click="OpenImportExport(item.importExportMasterID)">{{
                                          item.importExportMasterIDText }}</a>

                                      </template>
                                      <template v-slot:item.importDate="{ item }">
                                        {{ formatDatetime(item.importDate).substr(0, 10) }}

                                      </template>
                                      <template v-slot:item.costPrice="{ item }">
                                        {{ format_price(item.costPrice) }}

                                      </template>
                                      <template v-slot:item.quantity="{ item }">
                                        {{ format_number(item.quantity) }}

                                      </template>
                                      <template v-slot:item.total="{ item }">
                                        {{ format_price(item.total) }}

                                      </template>
                                    </v-data-table>

                                  </v-card-text>

                                  <!-- <v-card-text> 
                                  <v-card-text> 
                                    <v-row>
                                      <v-col cols="6">
                                        {{ use_language.connected_warehouse }}
                                      </v-col>
                                      <v-col cols="6" align="right">
                                      <a @click="GetShopLazadaWarehouseForAdd(item)">+ {{ use_language.add_warehouse_btn }}</a> 
                                      </v-col >
                                    </v-row>
                                    <v-data-table
                                      :headers="headers_lazada_warehouse"
                                      :items="item.warehouseList"
                                      class="elevation-0 packhai-border-table"
                                      hide-default-footer
                                      :items-per-page="10000"
                                      mobile-breakpoint="0"
                                    > 
                                    <template v-slot:item.isDelete="{ item }">
                                      <a @click="DeleteShopLazadaWarehouse(item)" >
                                        <v-icon size="16" color="red darken-3">fa-trash-alt</v-icon>
                                      </a>
                                    </template>
                                  </v-data-table>

                                  </v-card-text>
                                </v-card-text> -->
                                </v-card>

                              </v-col>
                            </v-row>


                            <v-row>

                              <v-col cols="12">
                                <table style="width:100%">
                                  <tr v-for="(item, index) in orderProfit_tmp" :key="index">
                                    <td class="text-right pb-2">
                                      <strong>{{ item.description }} :</strong>
                                    </td>
                                    <td class="text-right pb-2" style="width: 150px;">
                                      <span v-if="item.amount != null"
                                        :class="item.amount >= 0 ? 'text-green' : 'text-red'">
                                        {{ format_price(item.amount) }} {{ use_language.bath }}
                                      </span>
                                      <span v-else>0 {{ use_language.bath }}</span>
                                    </td>
                                  </tr>
                                </table>
                              </v-col>
                            </v-row>
                          </div>
                          <div v-if="i.id == 1" class="v-card-bottom-30">
                            <v-row>
                              <v-col cols="12">
                                <v-data-table :headers="purchaseOrder_header" :items="purchaseOrder_item"
                                  :items-per-page="9999999999" hide-default-footer
                                  class="packhai-border-table hidden-xs-only">


                                  <template v-slot:item.amount="{ item }">
                                    {{ format_price(item.amount) }}
                                  </template>

                                  <template v-slot:item.invoiceDate="{ item }">
                                    {{ formatDatetime(item.invoiceDate) }}
                                  </template>
                                  <template v-slot:item.idText="{ item }">
                                    <a @click="editPurchase(item.id)"> {{ item.idText }} </a>
                                  </template>


                                  <template v-slot:item.updated="{ item }">
                                    {{ formatDatetime(item.updated) }}
                                  </template>


                                </v-data-table>
                              </v-col>

                            </v-row>
                          </div>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- promotion -->
             <v-card class="px-5 py-5 v-card-bottom-30" elevation="1" v-if="promotion_item && promotion_item.length>0">
              <v-row class="form-group">
                <v-col>
                  <h3>{{ use_language.promotion }}</h3>
                </v-col>
              </v-row>
              <v-row class="form-group">
                <v-col style="background: #fff ;" cols="12">
                  <v-data-table :headers="promotion_header" :items="promotion_item"
                    :items-per-page="9999999999" hide-default-footer
                    class="packhai-border-table"
                  >
                    
                  <template  v-slot:item.name="{ item }">
                    <div class="py-3">

                 
                      <a   style="color:black" @click="OpenPromotion(item )">  <span class="fn-13" style="font-weight: bold"  > {{ item.name }}</span></a><br>
                      <span  style="color: gray;"> {{ item.formattedDateStart }} -
                      {{ item.formattedDateEnd }}
                    
                      </span>
                    </div>
                  </template>
                  <template v-slot:item.isOverlap="{ item }">
                      <v-row justify="center">
                          <v-col cols="12"  >
                          <span v-if="item.isOverlapped"><v-icon size="10" color="success">mdi-checkbox-blank-circle</v-icon> {{ use_language.can_overlap }}</span>
                          <span v-else><v-icon size="10" color="red">mdi-checkbox-blank-circle</v-icon> {{ use_language.cannot_overlap }}<br/>{{ use_language.priority }} : {{ item.priority }}</span>
                      </v-col>
                      </v-row>
                  </template>
                  <template v-slot:item.isPromotionType="{ item }">
                      <v-row>
                          <span v-if="item.promotionType === 2">{{ use_language.quantity }} {{ item.minQuantity }} {{ use_language.item }}</span>
                          <span v-if="item.promotionType === 1">{{ use_language.amount_money }} {{ item.minSpend }} {{ use_language.baht }}</span>
                      </v-row>
                  </template>


                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>

          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- เพิ่มรายการชำระเงิน -->
    <v-dialog v-model="dialog_add_slip" :fullscreen="isFullscreen" scrollable max-width="800" min-width="800"
      persistent>
      <v-card class="my-0">
        <v-card-title>
          <span v-if="input_transferId == 0">{{ use_language.add_payment_notification }}</span>
          <span v-else>{{ use_language.edit_payment_notification }}</span>
          <v-spacer />
          <v-btn icon @click="btnClosePayment()"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" md="3" lg="2" class="pb-0">
                  <h4>{{ use_language.status }} :</h4>
                </v-col>
                <v-col cols="12" sm="9" lg="10" class="pb-0">
                  <v-radio-group row v-model="input_transferStatusID">
                    <v-radio :label="use_language.draft" value="1"> </v-radio>
                    <v-radio :label="use_language.awaiting_payment" value="2"> </v-radio>
                    <v-radio :label="use_language.paid_status" value="4"> </v-radio>
                  </v-radio-group>

                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" lg="2" class="pb-0">
                  <h4>{{ use_language.transfer_amount }} :</h4>
                </v-col>
                <v-col cols="12" sm="9" lg="10" class="pb-0">
                  <v-text-field :value="input_transferAmount" @change="value => input_transferAmount = value"
                    autocomplete="off" ref="input_transferAmount" type="number" outlined hide-details
                    dense></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="3" lg="2" class="pb-0">
                  <h4>{{ use_language.withholding }} :</h4>
                </v-col>
                <v-col cols="12" sm="9" lg="10" class="pb-0">
                  <v-text-field :value="input_transferWithholdingAmount" @change="value => input_transferWithholdingAmount = value"
                    autocomplete="off" ref="input_transferAmount" type="number" outlined hide-details
                    dense></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="3" lg="2" class="pb-0">
                  <h4>{{ use_language.due_payment }} :</h4>
                </v-col>
                <v-col cols="12" sm="9" lg="10" class="pb-0">

                  <v-menu v-model="menu_due_date" :close-on-content-click="false" transition="scale-transition" offset-y
                    max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field :value="computed_due_date" @change="value => computed_due_date = value"
                        autocomplete="off" ref="select_dueDate" outlined prepend-icon=""
                        prepend-inner-icon="mdi-calendar" readonly hide-details dense v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="select_dueDate" no-title @input="menu_due_date = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row v-if="input_transferStatusID == '4'">
                <v-col cols="12" md="3" lg="2" class="pb-0">
                  <h4>{{ use_language.real_payment_date }} :</h4>
                </v-col>
                <v-col cols="12" md="5" lg="4" class="pb-0">
                  <v-menu v-model="menu_transfer_date" :close-on-content-click="false" transition="scale-transition"
                    offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field :value="computed_transfer_date" @change="value => computed_transfer_date = value"
                        autocomplete="off" ref="select_transferDate" outlined prepend-icon=""
                        prepend-inner-icon="mdi-calendar" readonly hide-details dense v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="select_transferDate" no-title
                      @input="menu_transfer_date = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6" md="2" lg="3" class="pb-0">
                  <v-select :value="select_transferHour" hide-details dense
                    @change="value => select_transferHour = value" :label="use_language.hour" autocomplete="off"
                    ref="select_transferHour" :items="transferHourItems" outlined></v-select>
                </v-col>

                <v-col cols="6" md="2" lg="3" class="pb-0">
                  <v-select :value="select_transferMinute" hide-details dense
                    @change="value => select_transferMinute = value" :label="use_language.minute" autocomplete="off"
                    ref="select_transferMinute" :items="transferMinuteItems" outlined></v-select>
                </v-col>
              </v-row>

              <v-row v-if="input_transferStatusID == '4'">
                <v-col cols="12" md="3" lg="2" class="pb-0">
                  <h4>{{ use_language.bank }} :</h4>
                </v-col>
                <v-col cols="12" sm="9" lg="10" class="pb-0">
                  <v-select v-model="paymentBank" :items="shop_bank_account_to_show" item-text="fullBankName"
                    item-value="id" persistent-hint dense hide-details outlined return-object
                    style="width:100%"></v-select>

                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" lg="2" class="pb-0">
                  <h4>{{ use_language.remark }} :</h4>
                </v-col>
                <v-col cols="12" sm="9" lg="10" class="pb-0">
                  <v-text-field v-model="input_transferRemark" autocomplete="off" outlined hide-details
                    dense></v-text-field>

                </v-col>
              </v-row>
              <v-row v-if="input_transferStatusID == '4'">
                <v-col cols="12" md="3" lg="2" class="pb-0">
                  <h4>{{ use_language.attach_slip }} :</h4>
                </v-col>
                <v-col cols="12" sm="9" lg="10" class="pb-0">
                  <v-file-input v-model="input_transferFileUpload" ref="input_transferFileUpload" outlined hide-details
                    dense prepend-icon="" prepend-inner-icon="mdi-file-image">
                    <template v-slot:selection="{ text }">
                      <v-chip small label color="primary">
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                </v-col>
              </v-row>



            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-5" style="justify-content: flex-end;">
          <v-btn outlined color="primary" @click="btnSavePayment()">
            {{ use_language.save }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addOrderPopup.Dialog" scrollable :max-width="addOrderPopup.MaxWidth" persistent
      :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card elevation="1" class="ma-0">
        <v-card-title class="height-57 pa-0">
          <table style="width: 100%">
            <tr>
              <td style="width: 120px;">
                <v-select dense outlined hide-details max-width="50px" :label="use_language.search_by" v-model="StockSearchType"
                  :items="['ทั้งหมด', 'ชื่อ', 'sku', 'barcode']"></v-select>
              </td>
              <td style="width: 140px;">

                <v-select dense outlined hide-details :label="use_language.category" v-model="StockIsProductSet"
                  :items="['ทั้งหมด', 'สินค้าไม่จัดเซ็ท', 'สินค้าจัดเซ็ท']"></v-select>
              </td>
              <td class="px-2 hidden-xs-only">
                <v-text-field ref="refSearchStockModelPopup" :value="searchStockModelPopup" autocomplete="off"
                  class="pl-2" dense hide-details @change="value => searchStockModelPopup = Trim_value(value)"
                  @keyup.enter="PopupsearchStock(limits, 0)"></v-text-field>
              </td>
              <td style="width: 40px;" class="hidden-xs-only">
                <v-btn color="primary" class="mr-1 px-2" @click="PopupsearchStock(limits, 0)">
                  <v-icon center>mdi-magnify</v-icon>
                  {{ use_language.search }}
                </v-btn>
              </td>
              <td style="width: 40px;">
                <v-btn icon @click="addOrderPopup.Dialog = false"><v-icon color="danger">mdi-close</v-icon></v-btn>
              </td>
            </tr>
          </table>
        </v-card-title>
        <v-divider />

        <!-- PC -->
       
        <v-card-text class="overflow-x-auto pt-1 pb-1 hidden-xs-only"
          :style="{ height: addOrderPopup.MaxHeight + 'px' }">
          <v-data-table :headers="addOrderPopup.headers" :items="addOrderPopup.Data" item-key="productMasterItemID"
            :items-per-page="90000000000" show-select
            v-model="addOrderPopup.SelectPackage"
             hide-default-footer class="elevation-0 packhai-checkbox-select">
             <template v-slot:header.data-table-select="{ on, props }">
              <span>{{ use_language.choose }}</span>
            </template>
            <template v-slot:item.photoLink="{ item }">
              <v-btn v-if="item.photoLink != null && item.photoLink != ''" icon @click="OpenPhoto(item.photoLink)">
                <img :src="item.photoLink" height="30">
              </v-btn>
            </template>
            <template v-slot:item.name="{ item }">
              <v-row class="mb-3 mt-3">
                <v-col cols="12" align="left" class="pa-0">
                  <div class="fn-13" style="font-weight: bold ">
                    {{ item.name }}</div>
                </v-col>

                <v-col cols="12" align="left" class="pa-0" v-if="item.productCode != null && item.productCode != ''">
                  <span class="color-gray-13">
                    {{ !item.productCode ? "" : use_language.number_product + " : " }} {{ item.productCode }}
                  </span>
                </v-col>


                <v-col cols="12" align="left" class="pa-0"
                  v-if="item.prop1Description != null && item.prop1Description != ''">
                  <span class="color-gray-13">
                    {{ use_language.type + " : " + item.prop1Description + (item.prop2Description == null ? "" : ", "+item.prop2Description)}}
                  </span>
                </v-col>


                <v-col cols="12" align="left" class="pa-0">
                  <span class="color-gray-13">{{ !item.barcode ? "" : use_language.barcode + " : " }} {{ item.barcode }}
                  </span>
                </v-col>




                <v-col cols="12" v-if="item.isProductSet" align="left" class="pa-0">
                  <span class="fn-13">
                    <v-icon size="22" color="orange darken-3" disabled>mdi-package-variant-closed-plus</v-icon>
                    {{ use_language.set_products }}
                  </span>
                </v-col>
              </v-row>

            </template>
            <template v-slot:item.unitPrice="{ item }">
              <span v-if="item.unitPrice == null || item.unitPrice == 0"> </span>
              <span v-else> {{ format_price(item.unitPrice == null || item.unitPrice == '' || item.unitPrice == 0 ? '' :
                item.unitPrice) }} </span>
            </template>
            <template v-slot:item.quantityAvailable="{ item }">
              <span> {{ formatMoney(item.quantityAvailable) }} </span>
            </template>
          </v-data-table>
        </v-card-text>
        <!-- PC -->

        <!-- Mobile -->
        <v-card-text class="overflow-x-auto pt-1 pb-1 hidden-sm-and-up"
          :style="{ height: addOrderPopup.MaxHeight + 'px' }">
          <table style="width: 100%" class="hidden-sm-and-up">
            <tr>


              <td class="px-2">
                <v-text-field ref="refSearchStockModelPopup" :value="searchStockModelPopup" autocomplete="off" dense
                  hide-details @change="value => searchStockModelPopup = Trim_value(value)"
                  @keyup.enter="PopupsearchStock(limits, 0)"></v-text-field>
              </td>
              <td style="width: 40px;">
                <v-btn color="primary" class="mr-1 px-2" @click="PopupsearchStock(limits, 0)">
                  <v-icon center>mdi-magnify</v-icon>
                  {{ use_language.search }}
                </v-btn>
              </td>

            </tr>
          </table>
          <v-data-iterator :items="addOrderPopup.Data" :items-per-page="900000000" hide-default-header
            hide-default-footer>
            <template v-slot:default="props">
              <v-card v-for="item in props.items" :key="item.productMasterItemID" class="mt-4">
                <v-card-text class="pa-0">
                  <v-row>


                    <v-col cols="12">

                      <b> {{ item.name }}</b>
                    </v-col>
                    <v-col cols="3">
                      <a v-if="item.photoLink != null && item.photoLink != ''" @click="OpenPhoto(item.photoLink)">
                        <img :src="item.photoLink" style="width:100%">
                      </a>
                      <a v-else style="width:100%">
                        <span class="bold-color-gray-12"> No Picture </span>
                      </a>
                    </v-col>
                    <v-col cols="9">
                      <v-row class="pa-0">
                        <v-col cols="12" class="pa-0">
                          <span v-if="item.prop1Description != null && item.prop1Description != ''"> {{
                            use_language.type }}
                            : {{ (item.prop1Description != null && item.prop1Description != "" ? item.prop1Description :
                              "")
                              + (item.prop2Description != null && item.prop2Description != "" ? " , " +
                                item.prop2Description :
                                "") }}</span>
                        </v-col>
                      </v-row>
                      <v-row class="pa-0">
                        <v-col cols="12" class="pa-0">
                          <span v-if="item.sku != null && item.sku != ''"> {{ use_language.sku }} : {{ item.sku
                          }}</span>
                        </v-col>
                      </v-row>
                      <v-row class="pa-0">
                        <v-col cols="12" class="pa-0">
                          <span v-if="item.barcode != null && item.barcode != ''"> {{ use_language.barcode }} : {{
                            item.barcode }}</span>
                        </v-col>
                      </v-row>
                      <v-row class="pa-0">
                        <v-col cols="12" class="pa-0">
                          <span> {{ use_language.selling_price }} : {{ format_price(item.salePrice) }}</span>
                        </v-col>
                      </v-row>
                      <v-row class="pa-0">
                        <v-col cols="12" class="pa-0">
                          <span> {{ use_language.quantity }} : {{ formatMoney(item.quantityAvailable) }}</span>
                        </v-col>
                      </v-row>
                      <v-row class="pa-0">
                        <v-col cols="12" v-if="item.isProductSet" align="left" class="pa-0">
                          <span class="fn-13">
                            <v-icon size="22" color="orange darken-3" disabled>mdi-package-variant-closed-plus</v-icon>
                            {{ use_language.set_products }}
                          </span>
                        </v-col>
                      </v-row>



                    </v-col>
                    <v-col cols="12">
                      <v-btn v-if="item.selectProduct" style="width:100%" left depressed color="primary"
                        @click="ProductSelect(item, addOrderPopup.Data.indexOf(item))"> <v-icon left>
                          mdi-checkbox-multiple-marked-circle-outline</v-icon> {{ use_language.choose }} </v-btn>
                      <v-btn v-else outlined depressed color="primary" style="width:100%"
                        @click="ProductSelect(item, addOrderPopup.Data.indexOf(item))"> {{ use_language.choose }}
                      </v-btn>

                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
          </v-data-iterator>
        </v-card-text>
        <!-- Mobile -->

        <div v-if="pageLength > 1 && addOrderPopup.Data.length > 0" class="text-center pa-1" @click="changePage()">
          <v-pagination v-model="page" :length="pageLength" :total-visible="pageTotalVisible"
            color="error"></v-pagination>
        </div>

        <v-divider />
        <div class="height-57 pa-2 " align="right">
          <v-btn color="primary" class="mr-2" :loading="addOrderPopup.loading" @click="Submit_addOrderPopup()">
            {{ use_language.add_product }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_photo" max-width="1200">
      <v-card class="my-0">
        <v-card-text>
          <v-row v-show="media_type == 0">
            <v-col cols="12">
              <v-img v-if="dialog_photo_link != null" :src="dialog_photo_link" aspect-ratio="1.5" contain></v-img>
            </v-col>
          </v-row>
          <v-row v-show="media_type == 1">
            <v-col cols="12">
              <iframe src="https://drive.google.com/file/d/1MryzbX1BLDrJofcvM5X8eIfApWEd-bS5/preview" width="640"
                height="480" allow="autoplay"></iframe>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ShowPhoto" max-width="500">
      <v-card class="ma-0">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" class="text-center">
              <img class="hidden-md-and-up" :src="ShowPhotoLink" width="300">
              <img class="hidden-sm-and-down" :src="ShowPhotoLink" width="450">
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn text color="#1976d2" @click="Opentap(ShowPhotoLink)">{{ use_language.newtab }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="#1976d2" @click="ShowPhoto = false">{{ use_language.close }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_not_enough_stock" persistent scrollable max-width="800">
      <v-card elevation="1" class="ma-0">
        <v-card-title>
          <v-spacer />
          <v-btn icon @click="dialog_not_enough_stock = false"><v-icon color="danger">mdi-close</v-icon></v-btn>
        </v-card-title>
        <!-- <v-divider/> -->
        <v-card-text>
          <v-row>
            <v-col cols="12" class="pt-0">
              <span style="color: red">*** {{ dialog_massage }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-0">
              <v-data-table :headers="[
                { text: use_language.picture, value: 'photoLink', align: 'center', sortable: false },
                { text: use_language.product, value: 'name', align: 'left', sortable: false, width: 200 },
                { text: use_language.available_quantity, value: 'quantityAvailable', align: 'right', sortable: false },
                { text: use_language.needed, value: 'quantityRequest', align: 'right', sortable: false },
                { text: use_language.stock_shortage, value: 'quantityShortage', align: 'right', sortable: false, width: 10 }
              ]" :items="orderItemProductResponse" :items-per-page="10000" hide-default-footer
                class="packhai-border-table packhai-table">
                <template v-slot:item.photoLink="{ item }">
                  <img v-if="item.photoLink != null" style="width: 50px" :src="item.photoLink"
                    @click="image_click(item.photoLink)" />
                </template>
                <template v-slot:item.name="{ item }">
                  <span>{{ item.name }}</span><br>
                  <span style="color: #A9A9A9">SKU : {{ item.sku }}</span><br>
                  <span style="color: #A9A9A9">{{ use_language.type }} : {{ item.propDescription }}</span>
                </template>
                <template v-slot:item.quantityAvailable="{ item }">
                  {{ format_number(item.quantityAvailable) }}
                </template>
                <template v-slot:item.quantityRequest="{ item }">
                  {{ format_number(item.quantityRequest) }}
                </template>
                <template v-slot:item.quantityShortage="{ item }">
                  <span style="color: red">{{ format_number(item.quantityShortage) }}</span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="edit_box_dialog" scrollable max-width="70%" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title>
          <!-- this.my_express.expressLogoDialog  -->
          <span>{{ use_language.edit_parcel }}{{ update_data_pack.packageNo }}</span>
          <v-spacer />
          <v-btn icon @click="edit_box_dialog = false"><v-icon color="danger">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>


          <v-row  >
            <v-col cols="12">
              <v-row>
                <v-col cols="4" md="3" lg="2" class="pt-0 pb-1"> {{ use_language.weight }} : </v-col>
                <v-col cols="8" md="2" lg="2" class="pt-0 pb-1">
                  <v-text-field :value="update_data_pack.weight" @change="(value) => (update_data_pack.weight = value)"
                 :disabled="update_data_pack.isPackhaiWarehouse"   type="number" autocomplete="off" ref="update_weight" outlined dense hide-details></v-text-field>
                </v-col>
                <v-col cols="12" md="1" lg="1" class="pt-0 pb-1"> </v-col>
                <v-col cols="4" md="2" lg="2" class="pt-0 pb-1"> {{ use_language.transport }} : </v-col>
                <v-col cols="8" md="4" lg="5" class="pt-0 pb-1">
                  <span
                    v-if="!platformReferenceSourceID1.includes(update_data_pack.referenceSourceID) || update_data_pack.isSellerOwnFleet">
                    <v-select v-model="update_data_pack.shopExpressSelected" :items="update_data_pack.shopExpressList"
                      item-text="expressCompanyName" item-value="id" persistent-hint return-object dense hide-details
                      outlined single-line>
                      <template slot="selection" slot-scope="data">
                        <img v-if="data.item.logoPic != null" :src="data.item.logoPic" class="mr-2"
                          style="width: 60px" />
                        {{ data.item.expressCompanyName }}
                      </template>
                      <template slot="item" slot-scope="data">
                        <img v-if="data.item.logoPic != null" :src="data.item.logoPic" class="mr-2"
                          style="width: 60px" />
                        {{ data.item.expressCompanyName }}
                      </template>
                    </v-select>

                  </span>
                  <span v-else>
                    <v-img v-if="update_data_pack.expressCompanyLogo != null" max-height="10vh" max-width="10vh"
                      :src="update_data_pack.expressCompanyLogo">
                    </v-img>
                  </span>
                </v-col>
              </v-row>
              <v-row class="">
                <v-col cols="4" md="3" lg="2" class="pt-0 pb-1"> {{ use_language.cubic1 }} : </v-col>
                <v-col cols="8" md="2" lg="2" class="pt-0 pb-1">
                  <v-text-field :value="update_data_pack.cubic1" @change="(value) => (update_data_pack.cubic1 = value)"
                 :disabled="update_data_pack.isPackhaiWarehouse"   type="number" autocomplete="off" ref="update_cubic1" outlined dense hide-details></v-text-field>
                </v-col>
                <v-col cols="12" md="1" lg="1" class="pt-0 pb-1"> </v-col>
                <v-col cols="4" md="2" lg="2" class="pt-0 pb-1"> TrackingNo : </v-col>
                <v-col cols="8" md="4" lg="5" class="pt-0 pb-1">
                  <v-text-field
                    v-if="!platformReferenceSourceID1.includes(update_data_pack.referenceSourceID) || update_data_pack.isSellerOwnFleet"
                    :value="update_data_pack.trackingNo" @change="(value) => (update_data_pack.trackingNo = value)"
                    autocomplete="off" ref="update_trackingNo" outlined dense hide-details></v-text-field>
                  <span v-else>{{ update_data_pack.trackingNo }}</span>
                </v-col>
              </v-row>
              <v-row class="">
                <v-col cols="4" md="3" lg="2" class="pt-0 pb-1">{{ use_language.cubic2 }} : </v-col>
                <v-col cols="8" md="2" lg="2" class="pt-0 pb-1">
                  <v-text-field :value="update_data_pack.cubic2" @change="(value) => (update_data_pack.cubic2 = value)"
                   :disabled="update_data_pack.isPackhaiWarehouse" type="number" autocomplete="off" ref="update_cubic2" outlined dense hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row class="">
                <v-col cols="4" md="3" lg="2" class="pt-0 pb-1"> {{ use_language.cubic3 }} : </v-col>
                <v-col cols="8" md="2" lg="2" class="pt-0 pb-1">
                  <v-text-field :value="update_data_pack.cubic3" @change="(value) => (update_data_pack.cubic3 = value)"
                   :disabled="update_data_pack.isPackhaiWarehouse" type="number" autocomplete="off" ref="update_cubic3" outlined dense hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row class="">
                <v-col cols="4" md="3" lg="2" class="pt-0 pb-1"> {{ use_language.box_name }} : </v-col>
                <v-col cols="8" md="2" lg="2" class="pt-0 pb-1">
                  <v-text-field :value="update_data_pack.boxName"
                    @change="(value) => (update_data_pack.boxName = value)" autocomplete="off" ref="update_boxName"
                  :disabled="update_data_pack.isPackhaiWarehouse"  outlined dense hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="">
                <v-col cols="4" md="3" lg="2" class="pt-0 pb-1"> {{ use_language.pack_fee }} : </v-col>
                <v-col cols="8" md="2" lg="2" class="pt-0 pb-1">
                  <v-text-field :value="update_data_pack.packPrice"
                    @change="(value) => (update_data_pack.packPrice = value)" type="number" autocomplete="off"
                 :disabled="update_data_pack.isPackhaiWarehouse"   ref="update_packPrice" outlined dense hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row class="">
                <v-col cols="4" md="3" lg="2" class="pt-0 pb-1"> {{ use_language.freight }} : </v-col>
                <v-col cols="8" md="2" lg="2" class="pt-0 pb-1">
                  <v-text-field :value="update_data_pack.deliveryPrice"
                    @change="(value) => (update_data_pack.deliveryPrice = value)" type="number" autocomplete="off"
                  :disabled="update_data_pack.isPackhaiWarehouse"  ref="update_deliveryPrice" outlined dense hide-details></v-text-field>
                </v-col>

              </v-row>
              <v-row class="">
                <v-col cols="4" md="3" lg="2" class="pt-0 pb-1"> % COD : </v-col>
                <v-col cols="8" md="2" lg="2" class="pt-0 pb-1">
                  <v-text-field :value="update_data_pack.codPercent"
                    @change="(value) => (update_data_pack.codPercent = value)" type="number" autocomplete="off"
                  :disabled="update_data_pack.isPackhaiWarehouse"  ref="update_codPercent" outlined dense hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row class="">
                <v-col cols="4" md="3" lg="2" class="pt-0 pb-1"> {{ use_language.service_charge }} : </v-col>
                <v-col cols="8" md="2" lg="2" class="pt-0 pb-1">

                  <v-text-field :value="update_data_pack.codCharged" autocomplete="off" ref="update_remotePrice"
                   :disabled="update_data_pack.isPackhaiWarehouse" outlined dense  hide-details></v-text-field>
                </v-col>

              </v-row>
              <v-row class="">
                <v-col cols="4" md="3" lg="2" class="pt-0 pb-1"> {{ use_language.remote_area }} : </v-col>
                <v-col cols="8" md="2" lg="2" class="pt-0 pb-1">
                  <v-text-field :value="update_data_pack.remotePrice" :disabled="update_data_pack.isPackhaiWarehouse"
                    @change="(value) => (update_data_pack.remotePrice = value)" type="number" autocomplete="off"
                    ref="update_remotePrice" outlined dense hide-details></v-text-field>
                </v-col>
              </v-row>

            </v-col>


          </v-row>
          <!-- <v-row v-else>
            <v-col cols="12">
              <v-row>
                <v-col cols="4" md="3" lg="2" class="pt-0 pb-1"> ขนส่ง : </v-col>
                <v-col cols="8" md="4" lg="5" class="pt-0 pb-1">
                  <span
                    v-if="!platformReferenceSourceID1.includes(update_data_pack.referenceSourceID) || update_data_pack.isSellerOwnFleet">
                    <v-select v-model="update_data_pack.shopExpressSelected" :items="update_data_pack.shopExpressList"
                      item-text="expressCompanyName" item-value="id" persistent-hint return-object dense hide-details
                      outlined single-line>
                      <template slot="selection" slot-scope="data">
                        <img v-if="data.item.logoPic != null" :src="data.item.logoPic" class="mr-2"
                          style="width: 60px" />
                        {{ data.item.expressCompanyName }}
                      </template>
                      <template slot="item" slot-scope="data">
                        <img v-if="data.item.logoPic != null" :src="data.item.logoPic" class="mr-2"
                          style="width: 60px" />
                        {{ data.item.expressCompanyName }}
                      </template>
                    </v-select>

                  </span>
                  <span v-else>
                    <v-img v-if="update_data_pack.expressCompanyLogo != null" max-height="10vh" max-width="10vh"
                      :src="update_data_pack.expressCompanyLogo">
                    </v-img>
                  </span>
                </v-col>

              </v-row>
              <v-row class="">
                <v-col cols="4" md="3" lg="2" class="pt-0 pb-1"> TrackingNo : </v-col>
                <v-col cols="8" md="4" lg="5" class="pt-0 pb-1">
                  <v-text-field
                    v-if="!platformReferenceSourceID1.includes(update_data_pack.referenceSourceID) || update_data_pack.isSellerOwnFleet"
                    :value="update_data_pack.trackingNo" @change="(value) => (update_data_pack.trackingNo = value)"
                    autocomplete="off" ref="update_trackingNo" outlined dense hide-details></v-text-field>
                  <span v-else>{{ update_data_pack.trackingNo }}</span>
                </v-col>

              </v-row>
            </v-col>
          </v-row> -->

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row class="pb-3">
            <v-col align="right">
              <v-btn color="primary" @click="update_data_pack_function()">{{ use_language.button_save }}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- แยกพัสดุ -->
    <v-dialog v-model="splitPackagePopup.dialog" scrollable :max-width="splitPackagePopup.MaxWidth" persistent
      :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card elevation="1" class="ma-0">
        <v-card-title class="height-57 pa-0">
          <div class="v-list-item">
            <div class="v-list-item__content pa-2">
              {{ use_language.confirm_package_separate }}
            </div>
            <div>
              <v-btn icon @click="splitPackagePopup.dialog = false"><v-icon color="danger">mdi-close</v-icon></v-btn>
            </div>
          </div>
        </v-card-title>
        <v-card>
          <v-row class="item-center">
            <v-col cols="2"><span>{{ use_language.type_transfer }} :</span></v-col>
            <v-col cols="6">
              <v-radio-group v-model="splitPackageDataSet.radio" row hide-details>
                <v-radio :label="use_language.separate_new_box" value="0"></v-radio>
                <v-row>
                  <v-radio :label="use_language.put_in_box" value="1"></v-radio>

                  <v-col cols="5">
                    <v-text-field v-model.number="splitPackageDataSet.moveTo" autocomplete="off" outlined hide-details
                      dense :disabled="splitPackageDataSet.radio != 1" type="number">
                    </v-text-field>
                  </v-col>

                </v-row>
              </v-radio-group>

            </v-col>
          </v-row>
          <v-card-text class="overflow-x-auto pt-1 pb-2 hidden-xs-only"
            :style="{ height: splitPackagePopup.MaxHeight + 'px' }">
            <v-data-table :headers="splitPackageDataSet.headers" :items="splitPackageDataSet.dataSet" fixed-header
              :items-per-page="9999999999" hide-default-footer class="elevation-1 packhai-border-table packhai-table"
              item-value="productName" item-key="stockShopId">
              <template v-slot:item.photoLink="{ item }">
                <a v-if="item.photoLink != null && item.photoLink != ''" icon @click="openPhoto(item.photoLink)">
                  <v-img style="margin: 0px 0px 0px 20px" v-if="item.photoLink != '' && item.photoLink != null"
                    :src="item.photoLink" aspect-ratio="1" class="grey lighten-2" max-width="50"
                    max-height="50"></v-img>
                </a>
              </template>
              <template v-slot:item.moveQuantity="{ item }">
                <v-text-field v-model.number="item.moveQuantity" @change="value => item.moveQuantity = value"
                  autocomplete="off" dense hide-details outlined ref="quantity" type="number"></v-text-field>
              </template>
            </v-data-table>
          </v-card-text>

        </v-card>

        <v-divider />
        <v-card-actions>
          <v-row>
            <v-col cols="6">
              {{ use_language.select_all }} {{ splitPackageDataSet.dataSet.length }} {{ use_language.item_unit }}
            </v-col>
            <v-col cols="6" align="right">
              <v-btn color="primary" @click="btnSubmitSplitPackage()">
                {{ use_language.carry_out }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addPackagePopup.Dialog" scrollable :max-width="addPackagePopup.MaxWidth" persistent
      :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card elevation="1" class="ma-0">
        <v-card-title class="height-57 pa-0">
          <div class="v-list-item">
            <div class="pa-2">
              {{ use_language.search }}
            </div>
            <div class="v-list-item__content pa-2">
              <v-text-field v-model="addPackagePopup.searchStockModelPopup" autocomplete="off" class="pl-2" dense
                hide-details @keyup.enter="btnSearchPackagek(addPackagePopup.limits, 0)"></v-text-field>
            </div>
            <div class="pa-2">
              <v-btn :elevation="1" color="primary" class="pa-2" dark
                @click="btnSearchPackagek(addPackagePopup.limits, 0)">
                <v-icon size="22" class="pr-1">mdi-magnify</v-icon>
                {{ use_language.search }}
              </v-btn>
            </div>
            <div>
              <v-btn icon @click="addPackagePopup.Dialog = false"><v-icon color="danger">mdi-close</v-icon></v-btn>
            </div>
          </div>
        </v-card-title>
        <v-divider />

        <!-- PC -->
        <v-card-text class="overflow-x-auto pt-1 pb-1 hidden-xs-only"   
          :style="{ height: addPackagePopup.MaxHeight + 'px' }">
          <v-data-table v-model="addPackagePopup.SelectPackage" :headers="addPackagePopup.headers"
            :items="addPackagePopup.Data" item-key="productMasterItemID" :items-per-page="90000000000" hide-default-footer show-select
            class="elevation-0 packhai-checkbox-select">
            <template v-slot:header.data-table-select="{ on, props }">
              <span>{{ use_language.choose }}</span>
            </template>
            <template v-slot:item.selectProduct="{ item }">
              <v-checkbox color="red" hide-details></v-checkbox>
            </template>
            <template v-slot:item.photoLink="{ item }">
              <v-btn v-if="item.photoLink != null && item.photoLink != ''" icon @click="OpenPhoto(item.photoLink)">
                <img :src="item.photoLink" height="30">
              </v-btn>
            </template>
            <template v-slot:item.name="{ item }">
              <v-row class="mb-3 mt-3">
                <v-col cols="12" align="left" class="pa-0">
                  <div class="fn-13" style="font-weight: bold ">
                    {{ item.name }}</div>
                </v-col>

                <v-col cols="12" align="left" class="pa-0" v-if="item.productCode != null && item.productCode != ''">
                  <span class="color-gray-13">
                    {{ !item.productCode ? "" : use_language.number_product + " : " }} {{ item.productCode }}
                  </span>
                </v-col>


                <v-col cols="12" align="left" class="pa-0"
                  v-if="item.prop1Description != null && item.prop1Description != ''">
                  <span class="color-gray-13">
                    {{ use_language.type + " : " + item.prop1Description + (item.prop2Description == null ? "" : ", "+item.prop2Description)}}
                  </span>
                </v-col>


                <v-col cols="12" align="left" class="pa-0">
                  <span class="color-gray-13">{{ !item.barcode ? "" : use_language.barcode + " : " }} {{ item.barcode }}
                  </span>
                </v-col>




                <v-col cols="12" v-if="item.isProductSet" align="left" class="pa-0">
                  <span class="fn-13">
                    <v-icon size="22" color="orange darken-3" disabled>mdi-package-variant-closed-plus</v-icon>
                    {{ use_language.set_products }}
                  </span>
                </v-col>
              </v-row>

            </template>
            <template v-slot:item.packedQuantity="{ item }">
              <v-text-field v-model.number="item.packedQuantity" autocomplete="off" dense hide-details outlined
                ref="quantity" type="number"></v-text-field>
            </template>
            <template v-slot:item.unitPrice="{ item }">
              <span v-if="item.unitPrice == null || item.unitPrice == 0"> </span>
              <span v-else> {{ format_price(item.unitPrice == null || item.unitPrice == '' || item.unitPrice == 0 ? '' :
                item.unitPrice) }} </span>
            </template>
            <template v-slot:item.quantityAvailable="{ item }">
              <span> {{ formatMoney(item.quantityAvailable) }} </span>
            </template>
          </v-data-table>
        </v-card-text>
        <!-- PC -->

  <!-- Mobile -->
        <v-card-text class="overflow-x-auto pt-1 pb-1 hidden-sm-and-up"
          :style="{ height: addOrderPopup.MaxHeight + 'px' }">
          
          <v-data-iterator :items="addPackagePopup.Data" :items-per-page="900000000" hide-default-header
            hide-default-footer>
            <template v-slot:default="props">
              <v-card v-for="item in props.items" :key="item.productMasterItemID" class="mt-4">
                <v-card-text class="pa-0">
                  <v-row>


                    <v-col cols="12">

                      <b> {{ item.name }}</b>
                    </v-col>
                    <v-col cols="3">
                      <a v-if="item.photoLink != null && item.photoLink != ''" @click="OpenPhoto(item.photoLink)">
                        <img :src="item.photoLink" style="width:100%">
                      </a>
                      <a v-else style="width:100%">
                        <span class="bold-color-gray-12"> No Picture </span>
                      </a>
                    </v-col>
                    <v-col cols="9">
                      <v-row class="pa-0">
                        <v-col cols="12" class="pa-0">
                          <span v-if="item.prop1Description != null && item.prop1Description != ''"> {{
                            use_language.type }}
                            : {{ (item.prop1Description != null && item.prop1Description != "" ? item.prop1Description :
                              "")
                              + (item.prop2Description != null && item.prop2Description != "" ? " , " +
                                item.prop2Description :
                                "") }}</span>
                        </v-col>
                      </v-row>
                      <v-row class="pa-0">
                        <v-col cols="12" class="pa-0">
                          <span v-if="item.sku != null && item.sku != ''"> {{ use_language.sku }} : {{ item.sku
                          }}</span>
                        </v-col>
                      </v-row>
                      <v-row class="pa-0">
                        <v-col cols="12" class="pa-0">
                          <span v-if="item.barcode != null && item.barcode != ''"> {{ use_language.barcode }} : {{
                            item.barcode }}</span>
                        </v-col>
                      </v-row>
                      <v-row class="pa-0">
                        <v-col cols="12" class="pa-0">
                          <span> {{ use_language.selling_price }} : {{ format_price(item.salePrice) }}</span>
                        </v-col>
                      </v-row>
                      <v-row class="pa-0">
                        <v-col cols="12" class="pa-0">
                          <span> {{ use_language.quantity }} : {{ formatMoney(item.quantityAvailable) }}</span>
                        </v-col>
                      </v-row>
                      <v-row class="pa-0">
                        <v-col cols="12" v-if="item.isProductSet" align="left" class="pa-0">
                          <span class="fn-13">
                            <v-icon size="22" color="orange darken-3" disabled>mdi-package-variant-closed-plus</v-icon>
                            {{ use_language.set_products }}
                          </span>
                        </v-col>
                      </v-row>
                       <v-row class="pa-0">
                        <v-col cols="12" class="pa-0 ">
                          <span>{{ use_language.quantity }} :  </span>    <span> <v-text-field v-model.number="item.packedQuantity" autocomplete="off" dense hide-details outlined
                                ref="quantity" type="number"></v-text-field></span>  
                          
                         
                         
                        
                        </v-col>
                      
                           
                      </v-row>



                    </v-col>
                    <v-col cols="12">
                     
                      <v-btn v-if="item.selectProduct" style="width:100%" left depressed color="primary"
                        @click="ProductPackageSelect(item, addPackagePopup.Data.indexOf(item))"> <v-icon left>
                          mdi-checkbox-multiple-marked-circle-outline</v-icon> {{ use_language.choose }} </v-btn>
                      <v-btn v-else outlined depressed color="primary" style="width:100%"
                        @click="ProductPackageSelect(item, addPackagePopup.Data.indexOf(item))"> {{ use_language.choose }}
                      </v-btn>

                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
          </v-data-iterator>
        </v-card-text>
        <!-- Mobile -->

        <div v-if="addPackagePopup.pageLength > 1 && addPackagePopup.Data.length > 0" class="text-center pa-1"
          @click="btnChangePagePackage()">
          <v-pagination v-model="addPackagePopup.page" :length="addPackagePopup.pageLength"
            :total-visible="addPackagePopup.pageTotalVisible" color="error"></v-pagination>
        </div>

        <v-divider />
        <div class="height-57 pa-2 " align="right">
          <v-btn color="primary" class="mr-2" :loading="addPackagePopup.loading" @click="btnSubmitAddPackagePopup()">
            {{ use_language.add_product }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- add customer -->
    <v-dialog v-model="dialog_addcustomer" :fullscreen="false" scrollable max-width="50%" persistent>
      <v-form ref="form" lazy-validation>
        <v-card>
          <v-card-title>
            <span>{{ use_language.add_new_customers }}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeAddCustomer()">
              <v-icon color="danger">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
           <v-divider></v-divider>
          <v-card-text>
            <v-card class="v-card-bottom-30">
              <v-card-title>
                <span>{{ use_language.customers_info }}</span>
              </v-card-title>
              <v-divider />
              <v-card-text>
                
                <v-row>
                  <v-col class="pb-1" cols="12" md="4" lg="2">
                    <h4 > <span style="color: red;">*</span> {{ use_language.name }} : </h4>
                  </v-col>
                  <v-col class="pb-1" cols="12" md="8" lg="10">
                    <v-text-field :value="addCustomer.name"
                      @change="value => addCustomer.name = value" autocomplete="off"
                      ref="refNewCustomerName" outlined hide-details="auto"
                      :rules="rules.customername" dense 
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pb-1" cols="12" md="4" lg="2">
                    <h4 > <span style="color: red;">*</span> {{ use_language.tel }} : </h4>
                  </v-col>
                  <v-col class="pb-1" cols="12" md="8" lg="10">
                    <v-text-field :value="addCustomer.phone"
                      @change="value => addCustomer.phone = value" autocomplete="off"
                      ref="refNewCustomerPhone"  outlined
                      hide-details="auto"   :rules="rules.customerphone" dense 
                    />
                  </v-col>
                </v-row>
                 <v-row row class="pt-2">
                  <v-col cols="12" md="4" lg="2" class="py-0 pt-1" >
                    <h4> <span style="color: red;">*</span> {{ use_language.country }} :</h4>
                  </v-col>
                  <v-col cols="12" md="8" lg="10" class="py-0 pt-1">
                    <v-autocomplete v-model="countryCodeSelected" 
                    :items="countryCode" outlined return-object hide-details dense
                    :item-text="item=>item.country"   > 
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row row class="pt-2">
                  <v-col cols="12" md="4" lg="2" class="py-0 pt-1">
                    <h4> <span style="color: red;">*</span> {{ use_language.address }} : </h4>
                  </v-col>
                  <v-col cols="12" md="8" lg="10" class="py-0 pt-1">
                    <v-text-field :value="addCustomerShipping.address"
                      @change="value => addCustomerShipping.address = value" autocomplete="off"
                      ref="refNewShippingTextAddress" outlined hide-details="auto" dense 
                    />
                  </v-col>
                </v-row>
                <v-row row class="pt-2" v-if="countryCodeSelected && countryCodeSelected.id== 172 ">
                  <v-col class="py-0 pt-1" cols="12" md="4" lg="2"  >
                    <h4> <span style="color: red;">*</span> {{ use_language.zipcode }} :</h4>
                  </v-col>
                  <v-col class="py-0 pt-1" cols="12" md="8" lg="10" >
                    <v-autocomplete v-model="addCustomerShipping.postcodeMappingID"
                      ref="refShippingAddress"
                      :placeholder="use_language.all_address"
                      :items="postcode_mapping"
                      :item-text="item => item.postcode + ' ' + item.province + ' ' + item.district + ' ' + item.subDistrict"
                      outlined required return-object hide-details="auto" dense
                    >
                      <template v-slot:label> <span>{{ use_language.all_address }}</span> </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row row class="pt-2" v-if="countryCodeSelected&& countryCodeSelected.id!= 172 ">
                  <v-col cols="12" md="4" lg="2" class="py-0 pt-1">
                    <h4><span style="color: red;">*</span>{{ use_language.city }} :</h4>
                  </v-col>
                  <v-col cols="12" md="8" lg="10" class="py-0 pt-1">
                     <v-text-field :value="addCustomerShipping.city"
                      @change="value => addCustomerShipping.city = value" autocomplete="off"
                      ref="refShipAddressManagecity" outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
                <v-row row class="pt-2" v-if="countryCodeSelected && countryCodeSelected.id!= 172 ">
                  <v-col cols="12" md="4" lg="2" class="py-0 pt-1">
                    <h4><span style="color: red;">*</span>{{ use_language.zipcode }} :</h4>
                  </v-col>
                  <v-col cols="12" md="8" lg="10" class="py-0 pt-1">
                     <v-text-field :value="addCustomerShipping.postcode"
                      @change="value => addCustomerShipping.postcode = value" autocomplete="off"
                      ref="refShipAddressManagepostcode" outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
               <v-divider  class="mt-3" />
                <v-row >
                  <v-col class="pb-1" cols="12" md="4" lg="2">
                    <h4 > {{ use_language.customer_code }} : </h4>
                  </v-col>
                  <v-col class="pb-1" cols="12" md="8" lg="10">
                    <v-text-field :value="addCustomer.customerCode"
                      @change="value => addCustomer.customerCode = value" autocomplete="off"
                      ref="refNewCustomerCode" outlined hide-details="auto" dense 
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pb-1" cols="12" md="4" lg="2">
                    <h4 > {{ use_language.email }} : </h4>
                  </v-col>
                  <v-col class="pb-1" cols="12" md="8" lg="10">
                    <v-text-field :value="addCustomer.email"
                      @change="value => addCustomer.email = value" autocomplete="off"
                      ref="refNewCustomerEmail" outlined hide-details="auto" dense
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pb-1" cols="12" md="4" lg="2">
                    <h4 > {{ use_language.facebook }} : </h4>
                  </v-col>
                  <v-col class="pb-1" cols="12" md="8" lg="10">
                    <v-text-field :value="addCustomer.facebook"
                      @change="value => addCustomer.facebook = value" autocomplete="off"
                      ref="refNewCustomerFacebook" outlined hide-details="auto"
                      dense 
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pb-1" cols="12" md="4" lg="2">
                    <h4 > {{ use_language.line }} : </h4>
                  </v-col>
                  <v-col class="pb-1" cols="12" md="8" lg="10">
                    <v-text-field :value="addCustomer.line"
                      @change="value => addCustomer.line = value" autocomplete="off"
                      ref="refNewCustomerLine" outlined hide-details="auto" dense 
                      />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pb-1" cols="12" md="4" lg="2">
                    <h4 > {{ use_language.note }} : </h4>
                  </v-col>
                  <v-col class="pb-1" cols="12" md="8" lg="10">
                    <v-text-field :value="addCustomer.remark"
                      @change="value => addCustomer.remark = value" autocomplete="off"
                      ref="refNewCustomerRemark" outlined hide-details="auto" dense 
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
           
            <v-card>
              <v-card-title>
                <span>{{ use_language.add_bill_address }}</span>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row row class="pt-2">
                  <v-col cols="12" md="4" lg="2" class="py-0 pt-1">
                    <h4> {{ use_language.tax_invoice_number }} : </h4>
                  </v-col>
                  <v-col cols="12" md="8" lg="10" class="py-0 pt-1">
                    <v-text-field :value="addCustomerInvoice.taxID"
                      @change="value => addCustomerInvoice.taxID = value" autocomplete="off"
                      ref="refNewInvoiceTaxID" outlined hide-details="auto" dense
                       @keypress="isNumberWNoDot($event)" 
                    />
                  </v-col>
                </v-row>
                <v-row row class="pt-2">
                  <v-col cols="12" md="4" lg="2" class="py-0 pt-1">
                    <h4  > {{ use_language.name }} : </h4>
                  </v-col>
                  <v-col cols="12" md="8" lg="10" class="py-0 pt-1">
                    <v-text-field :value="addCustomerInvoice.name" @change="value => addCustomerInvoice.name = value"
                      autocomplete="off" ref="refNewInvoiceName" outlined hide-details="auto" dense 
                    />
                  </v-col>
                </v-row>
                <v-row row class="pt-2">
                  <v-col cols="12" md="4" lg="2" class="py-0 pt-1">
                    <h4  > {{ use_language.tel }} : </h4>
                  </v-col>
                  <v-col cols="12" md="8" lg="10" class="py-0 pt-1">
                    <v-text-field :value="addCustomerInvoice.phone"
                      @change="value => addCustomerInvoice.phone = value" autocomplete="off"
                      ref="refNewInvoicePhone" outlined hide-details="auto" dense
                     
                    />
                  </v-col>
                </v-row>
                <v-row row class="pt-2">
                  <v-col cols="12" md="4" lg="2" class="py-0 pt-1">
                    <h4  > {{ use_language.address }} : </h4>
                  </v-col>
                  <v-col cols="12" md="8" lg="10" class="py-0 pt-1">
                    <v-text-field :value="addCustomerInvoice.address"
                      @change="value => addCustomerInvoice.address = value" autocomplete="off"
                      ref="refNewInvoiceTextAddress" outlined hide-details="auto" dense 
                    />
                  </v-col>
                </v-row>
                <v-row row class="pt-2">
                  <v-col  class="py-0 pt-1" cols="12" md="4" lg="2">
                    <h4>{{ use_language.zipcode }} :</h4>
                  </v-col>
                  <v-col  class="py-0 pt-1" cols="12" md="8" lg="10">
                    <v-autocomplete v-model="addCustomerInvoice.postcodeMappingID"
                      ref="refNewInvoiceAddress"
                      :placeholder="use_language.all_address"
                      :items="postcode_mapping"
                      :item-text="item => item.postcode + ' ' + item.province + ' ' + item.district + ' ' + item.subDistrict"
                      outlined required return-object hide-details="auto" dense
                    >
                      <template v-slot:label> <span>{{ use_language.all_address }}</span></template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions  >
            <v-row class="pa-0">
              <v-col align="right" class="pa-0">
                  <v-btn color="primary" @click="AddCustomer()"> {{ use_language.record }} </v-btn>
                </v-col>

                </v-row>  
          
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- add shipping -->
    <v-dialog v-model="dialog_addshipping" :fullscreen="false" scrollable max-width="50%" persistent>
      <v-card>
        <v-card-title>
          <span v-if="addShipping.id==0">{{ use_language.add_address }}</span>
          <span v-else>{{ use_language.edit_address }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeAddShipping()">
            <v-icon color="danger">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-row row class="pt-2">
            <v-col cols="12" md="4" lg="3" class="py-0 pt-1">
              <h4  > {{ use_language.name }} : </h4>
            </v-col>
            <v-col cols="12" md="8" lg="9" class="py-0 pt-1">
              <v-text-field :value="addShipping.name" @change="value => addShipping.name = value"
                autocomplete="off" ref="refShippingName" outlined hide-details dense 
              />
            </v-col>
          </v-row>
          <v-row row class="pt-2">
            <v-col cols="12" md="4" lg="3" class="py-0 pt-1">
              <h4  > {{ use_language.tel }} : </h4>
            </v-col>
            <v-col cols="12" md="8" lg="9" class="py-0 pt-1">
              <v-text-field :value="addShipping.phone" @change="value => addShipping.phone = value"
                autocomplete="off" ref="refShippingPhone" outlined hide-details dense 
              />
            </v-col>
          </v-row>
          <v-row row class="pt-2">
            <v-col cols="12" md="4" lg="3" class="py-0 pt-1" >
              <h4> {{ use_language.country }} :</h4>
            </v-col>
            <v-col cols="12" md="8" lg="9" class="py-0 pt-1">
              <v-autocomplete v-model="countryCodeSelected" 
              :items="countryCode" outlined return-object hide-details dense
              :item-text="item=>item.country"   > 
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row row class="pt-2">
            <v-col cols="12" md="4" lg="3" class="py-0 pt-1">
              <h4  > {{ use_language.address }} : </h4>
            </v-col>
            <v-col cols="12" md="8" lg="9" class="py-0 pt-1">
              <v-text-field :value="addShipping.address" @change="value => addShipping.address = value"
                autocomplete="off" ref="refShippingTextAddress" outlined hide-details dense 
              />
            </v-col>
          </v-row>
          <v-row row class="pt-2"  v-if="countryCodeSelected && countryCodeSelected.id== 172 ">
            <v-col class="py-0 pt-1" cols="12" md="4" lg="3">
              <h4>{{ use_language.zipcode }} :</h4>
            </v-col>
            <v-col class="py-0 pt-1" cols="12" md="8" lg="9">
              <v-autocomplete :value="addShipping.postcodeMappingID"
                @change="value => addShipping.postcodeMappingID = value" ref="refShippingPostcode"
                :items="postcode_mapping"
                :item-text="item => item.postcode + ' ' + item.province + ' ' + item.district + ' ' + item.subDistrict"
                outlined dense hide-details autocomplete="off" required return-object
              >
                <!-- แก้จากเดิมเป็น 3 ภาษา -->
                <template v-slot:label> <span>{{ use_language.all_address }}</span> </template>

              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row row class="pt-2"   v-if="countryCodeSelected&& countryCodeSelected.id!= 172 ">
            <v-col cols="12" md="4" lg="3" class="py-0 pt-1">
              <h4>{{ use_language.city }} :</h4>
            </v-col>
            <v-col cols="12" md="8" lg="9" class="py-0 pt-1">
                <v-text-field :value="addShipping.city"
                @change="value => addShipping.city = value" autocomplete="off"
                ref="refShippingCity" outlined hide-details dense></v-text-field>
            </v-col>
          </v-row>
            <v-row row class="pt-2"   v-if="countryCodeSelected && countryCodeSelected.id!= 172 ">
            <v-col cols="12" md="4" lg="3" class="py-0 pt-1">
              <h4>{{ use_language.zipcode }} :</h4>
            </v-col>
            <v-col cols="12" md="8" lg="9" class="py-0 pt-1">
                <v-text-field :value="addShipping.postcode"
                @change="value => addShipping.postcode = value" autocomplete="off"
                ref="refShippingPostcode" outlined hide-details dense></v-text-field>
            </v-col>
          </v-row>
          <v-row row>
            <v-col class="pb-0" cols="12" md="4" lg="3">
              <h4>{{ use_language.set_default }} :</h4>
            </v-col>
            <v-col class="pb-0" cols="12" md="8" lg="9">
              <v-checkbox :readonly="false" v-model="addShipping.isDefault"></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12" md="12" align="right">
              <v-btn dark color="primary" @click="addShippingConfirm()" class="mr-1"> 
                <v-icon left>mdi-content-save</v-icon> {{ use_language.record }} 
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <!-- add shipping invoice -->
    <v-dialog v-model="dialog_addshipping_invoice" persistent scrollable max-width="800">
      <v-card elevation="1" class="ma-0">
        <v-card-title >
          <h4 v-if="address_invoice.id==0">{{ use_language.add_bill_address }}</h4>
          <h4 v-else>{{ use_language.edit_bill_address }}</h4>
          <v-spacer/>
          <v-btn icon @click="closeAddressInvoiceDialog"><v-icon color="danger">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider> </v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="2" lg="2" md="2" class="pb-0">
              <h4> {{use_language.tax_invoice_number}} :</h4>
            </v-col>
            <v-col cols="12" sm="8" lg="8" md="8" class="pb-0">
              <v-text-field
                ref="txt_taxid"
                autocomplete="off"
                :value="address_invoice.taxID"
                hide-details="auto"
                dense
                outlined
                required
                maxlength="13"
                @keypress="isNumberWNoDot($event)"
                @keyup.enter="$refs.txt_address_invoice_name.focus()" 
                @change="value => address_invoice.taxID = value"
              ></v-text-field>
            </v-col>
          </v-row>
          
          <v-row>
            <v-col cols="12" sm="2" lg="2" md="2" class="pb-0">
              <h4> {{use_language.name}} :</h4>
            </v-col>
            <v-col cols="12" sm="8" lg="8" md="8" class="pb-0">
              <v-text-field
                ref="txt_address_invoice_name"
                autocomplete="off"
                :value="address_invoice.name"
                hide-details="auto"
                dense
                outlined 
                required
                @keyup.enter="$refs.txt_address_invoice_tel.focus()"
                @change="value => address_invoice.name = value"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" lg="2" md="2" class="pb-0">
              <span class="red--text" v-if="address_invoice_validate.name">{{ use_language.please_fill }}</span>
            </v-col> 
          </v-row>
          <v-row>
            <v-col cols="12" sm="2" lg="2" md="2" class="pb-0">
              <h4> {{use_language.tel}} :</h4>
            </v-col>
            <v-col cols="12" sm="8" lg="8" md="8" class="pb-0">
              <v-text-field
                ref="txt_address_invoice_tel"
                :value="address_invoice.phone"
                autocomplete="off"
                type="number"
                hide-details="auto"
                dense
                outlined 
                required
                @keyup.enter="$refs.txt_address_invoice_address.focus()" 
                @change="value => address_invoice.phone = value"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" lg="2" md="2" class="pb-0">
              <span class="red--text" v-if="address_invoice_validate.phone">{{ use_language.please_fill }}</span>
            </v-col> 
          </v-row>
          <v-row>
            <v-col cols="12" sm="2" lg="2" md="2" class="pb-0">
              <h4> {{use_language.address}} :</h4>
            </v-col>
            <v-col cols="12" sm="8" lg="8" md="8" class="pb-0">
              <v-text-field
                ref="txt_address_invoice_address"
                autocomplete="off"
                :value="address_invoice.address"
                hide-details="auto"
                dense
                outlined 
                required
                @keyup.enter="$refs.cb_address_invoice_postcodeMappingId.focus()"
                @change="value => address_invoice.address = value"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" lg="2" md="2" class="pb-0">
              <span class="red--text" v-if="address_invoice_validate.address">{{ use_language.please_fill }}</span>
            </v-col> 
          </v-row>
          <v-row>
            <v-col cols="12" sm="2" lg="2" md="2">
              <h4> {{use_language.zipcode}} :</h4>
            </v-col>
            <v-col cols="12" sm="8" lg="8" md="8">
              <v-autocomplete
                ref="cb_address_invoice_postcodeMappingId"
                v-model="select_address_invoice_postcodeMapping"
                :items="postcode_mapping"
                :item-text="item => item.postcode + ' ' + item.province + ' ' + item.district + ' ' + item.subDistrict"
                item-value="id"
                hide-details="auto"
                dense
                outlined 
                required
                return-object
                @change="set_data_address_invoice_postcodeMappingId()"
              >
                <template v-slot:label> <span>{{use_language.all_address}}</span> </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="2" lg="2" md="2" class="pb-0">
              <span class="red--text" v-if="address_invoice_validate.postcode">{{ use_language.please_fill }}</span>
            </v-col> 
          </v-row>
          <v-row>
            <v-col cols="12" sm="2" lg="2" md="2">
              <h4> {{use_language.set_default}} :</h4>
            </v-col>
            <v-col cols="12" sm="10" lg="10" md="10">
              <v-checkbox v-model="address_invoice.isDefault"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider> </v-divider>
        <v-card-actions class="text-right">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="btnAddAddresInvoice()">
            {{ use_language.button_save }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as easings from 'vuetify/es5/services/goto/easing-patterns'
import Loading from '@/website/components/Loading'
import axios from 'axios'
import Swal from "sweetalert2"
import { generalService_dotnet, orderService_dotnet, shopService_dotnet, stockService_dotnet, logistic_Service, ecomService_dotnet } from '@/website/global'
import { formatDatetime, format_number, format_order_id, format_price, isNumberWNoDot, formatMoney, china_order_fornat, Trim_value, Trim_rules, get_languages, checkAuthorize, getPostcodeMapping } from '@/website/global_function'
// import { shippingStatusDict } from '@/website/statusDict'
// import VueBarcode from 'vue-barcode'
import { token_api } from '@/website/backend/token'
import moment from "moment";
import { reportService_dotnet } from '../../global'


export default {
  components: {
    Loading,
    // 'barcode': VueBarcode
  },

  data: () => ({
    // หน้านี้เป็นโหมดคลังประวัติ (อ่านอย่างเดียว) — ใช้ซ่อนปุ่ม/เมนูแก้ไขทั้งหมดด้วย v-if="!isArchive"
    isArchive: true,

    isSaving:false,
    hideNoDataProduct: true,
    printDocument: {"value" : 0 , "text": ""},
    //
    dialog_addcustomer: false,
    addCustomer: {
      "id": 0,
      "customerCode": null,
      "name": null,
      "phone": null,
      "email": null,
      "facebook": null,
      "line": null,
      "remark": null,
      "shopID": null,
      "created": null
    },
    addCustomerShipping: {
      "id": 0,
      "name": '',
      "phone": '',
      "address": '',
      "shopCustomerID": 0,
      "shopID": null,
      "isDefault": true,
      "postcodeMappingID": 0
    },
    addCustomerInvoice: {
      "id": 0,
      "taxID": '',
      "name": '',
      "phone": '',
      "address": '',
      "shopCustomerID": 0,
      "isDefault": true,
      "shopID": null,
      "postcodeMappingID": 0
    },

    dialog_addshipping: false,
    addShipping: {
      "id": 0,
      "name": null,
      "phone": null,
      "address": null,
      "shopCustomerID": 0,
      "shopID": null,
      "isDefault": false,
      "postcodeMappingID": 0
    },

    dialog_addshipping_invoice: false,
    address_invoice :{
      taxID:null,
      id:null,
      name:null,
      phone:null,
      address:null,
      subDistrict:null,
      district:null,
      province:null,
      postcode:null,
      postcodeMappingId:null,
      isDefault: null
    },
    address_invoice_validate:{
      phone:false,
      name:false,
      address:false,
      postcode:false
    },
    select_address_invoice_postcodeMapping:null,
    rules: {
      customername: [],
      customeremail: [],
      customerphone: [],
      customerfacebook: [],
      customerline: [],
      shippingname: [],
      shippingphone: [],
      shippingaddress: []
    },
    loadingAdd: false,
    //

    dialog_doc: false,
    input_doc_select: null,
    input_docFileUpload: null,
    checkPermission: JSON.parse(localStorage.getItem('permission')),
    customerWebsite: null,
    //
    detail_order:{},
    tab: 0,
    header_token: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('authorization_token') },
    shop_id:parseInt(localStorage.getItem("shop_id")),
    StaffShopID: localStorage.getItem("staff_id"),
    StaffBranchID: localStorage.getItem("staff_branch_id"),
    // ===== RMA Section (เฉพาะ shop ใน whitelist) =====
    allowedRMAShopIDs: [1888, 6265, 4869],
    rmaList: [],
    rmaLoading: false,
    platformReferenceSourceID: [3, 4,   11,1437],
    platformReferenceSourceID1: [3, 4, 8, 11,1437],
    platformReferenceSourceID2: [3, 4, 6, 8, 11,21,144,1000,1341,1437],
    edit_box_dialog: false,
    page_loading: true,
    loading: false,
    use_language: null,
    set_language: null,
    authorize: false, 
    FindStockPopupResultCount: 0,
    orderItemList: null,
    orderItemTempList: null,
    orderItemInvoiceList: null,
    orderItemInvoice_tmp: null,
    packageList: null,
    paymentBank: null,
    input_transferRemark: null,
    // แสดงภาพ
    ShowPhoto: false,
    ShowPhotoLink: '',
    fileAttach: [],
    // คลัง
    Warehouse_List: [],
    Warehouse: {},
    StockSearchType: 'ทั้งหมด',
    StockIsProductSet: 'ทั้งหมด',
    // สำหรับแก้ไข
    Warehouse_List_selected: null,
    Warehouse_List_selected_text: null,
    dialog_not_enough_stock: false,
    orderItemProductResponse: [],
    dialog_massage: '',
    order_detail_token: null,
    IsChangeStatusStage: true,
    IsApproveStage: true,
    IsDetailStage: true,
    IsCanEditCOD: true,
    // แก้ไข จำนวน ราคา เหมาๆ
    dialog_edit_item_mhao: false,
    edit_item_mhao_id: null,
    edit_item_mhao_quantity: null,
    edit_item_mhao_unit_price: null,

    IsHasSerial: false,
    canChangeStatusOrder: null,
    can_edit_warehouse: false,
    can_edit_status: false,

    // add slip
    dialog_add_slip: false,

    // edit product
    dialog_edit_stock: false,
    isFullscreen: false,

    StockList: [],
    searchStockModel: null,
    hideNoDataSearchStock: true,
    searchInputStock: null,
    productList: [],
    totalVat: 0,
    textField_deliveryCost: null,
    select_discountType: "฿",
    textField_discount: null,
    totalDiscount: 0,
    totalPrice: 0,
    select_vatType: 1,
    vat_percent: 7,
    textarea_remarkProduct: null,
    AllowChangeOrderStatus: false,
    edit_insurance_amount: null,


    // detail
    
    detail_order_product: null,
    detail_order_box: null,
    express_selected:null,
    ExpressList:null,
    OrderMaster:{
      ID:null, 
      OrderDiscount: 0,
      VATAmount:0,
      VATType:1,
    },
    detail_CreatedateTime: '',

    detailOrderProduct: [],
    detailOrderProduct_tmp: [],
    detailOrderBox: [],
    detailOrderPayment: [],
    detailOrderPayment_temp: [], 
    detail_statusId: '', 
 
     
    
    detail_edit_line: null,
    detail_edit_fackbook: null,
    detail_edit_email: null,

    // order b2b
    detail_saleType: '',
    detail_orderType: '',  
    

    select_order_type: null,
    txt_quotationNumber: null,
    txt_invoiceNo: null,
    txt_referenceNumber: null,
    menu_search_delivery_date: false,
    dt_due_delivery_date: null,
    menu_search_sale_date: false,
    dt_due_sale_date: null,

 
   
 
    
    detail_saleman1: null,
    detail_saleman2: null, 

    customerList: [],
   
    customerAddressList: [],
    customerAddress_selected:null,
    customerAddressInvoiceList: [],
    customerAddressInvoice_selected:null,
  
   
    customerSalemanList: [],
    //


    detail_parcelStatusId: '',
    detail_parcelStatusName: '',
    detail_ShippingAddress: '',
    detail_BankName: '',
    detail_AccountNumber: '',
    detail_AccountName: '',
    detail_Remark: '',
    detail_RemarkCustomer: '',
    detail_RemarkWarehouse: '',
    detail_BoxName: '',
    detail_Weight: '',
    detail_Width: '',
    detail_Height: '',
    detail_Long: '',
    detail_BoxPrice: '',
    detail_BubblePrice: '',
    detail_OtherServicePrice: '',
    detail_VrichTransactionFee: '',
    detail_CODPercent: '',
    detail_CODCharged: '',
    detail_Discount: '',
    detail_RemotePrice: '',
    detail_DeliveryPrice: '',
    detail_PackPrice: '',
    detail_TrackingNo: '',
    detail_ChannelName: '',
    detail_StaffName: '',
    detail_totalPrice: '',
    detail_orderTotalAmount: '',
    detail_DeliveryCost: '',
    detail_Token: '',
    detail_IsCOD: '',
    detail_CustomerType: '',
    get_token: '',
    detail_CODAmount: '',
    detail_SellerVoucher: '',
    detail_PlatformVoucher: '',
    detail_SellerDeliveryDiscount: '',
    detail_PlatformDeliveryDiscount: '',
    detail_ShopeeCoinDiscount: null,
    detail_PaymentDiscount: null,
    detail_BuyerPaidAmount: null,
    detail_isSellerOwnFleet: false,
    detail_InsuranceAmount: '',

    detail_sum_unintPrice: '',
    detail_sum_unintPrice_and_DeliveryCost: '',
    detail_RealTransferDatetime: '',
    detail_ExpressCompanyID: '',
    detail_SalemanName: null,
    detail_ShopBankAccountID: null,
    data_pic: [],
  

    // transfer
    detail_CustomerTransferBankID: '',
    detail_CustomerTransferAmount: '',
    detail_CustomerTransferPhotoLink: '',
    detail_CustomerTransferCreatedDatetime: '',
    detail_CustomerTransferInformDatetime: '',

    detail_CustomerTransferBankName: '',
    detail_CustomerTransferAccountNumber: '',
    detail_CustomerTransferAccountName: '',
    detail_IsPreOrder: null,

   
    // shopee 
    detail_referenceSourceID: null,
    ReferenceNumber: null,
    // TempSenderAddress: null,
    TempAddress: null,
    ChannelSourceLogoPic: null,

    detail_shiping_staus_update_select: null,
    IsHasItemInvoice: false,
    IsAbleToEditOrderItem: false,
    marketplace_status: null,

    // changStatus



    order_status_history_list: [],

    dialog_photo: false,
    dialog_photo_link: null,


    // แก้ไขข้อมูล remark
    edit_detail_remark: null,
    edit_detail_remarkCustomer: null,
    edit_detail_remarkWarehouse: null,
    can_edit_remark: false,
    can_edit_remarkCustomer: false,
    can_edit_remarkWarehouse: false,
    can_edit_product: false,
    can_edit_packaged: false,

    // แก้ไขที่อยู่
    can_edit_shipaddress: false,

    //แก้ไข b2b
    can_edit_b2b: false,
    
    // postcode_mapping: PostcodeMapping,
    postcode_mapping: [],
    ShipAddressManage: {
      "ID": null,
      "Name": null,
      "Phone": null,
      "TextAddress": null,
      "Address": null,
      "PostcodeMappingID": null,
      "ShopCustomerID": null
    },

    // แก้ไข cod ธนาคาร
    can_edit_data_cod: false,
    edit_cod_amount: null,
    edit_cod_bank: null,
    cod_bank_data: [],
    shop_bank_account: [],
    shop_bank_account_to_show: [],
    cod_list_select: null,
    countryCode :[],
    countryCodeSelected:null,
    // แก้ไข express
    can_edit_data_express: false,
    ExpressUniqueID: null, 

    currentShopCustomerID: null,
    input_transferStatusID: "2",
    input_transferId: 0,
    input_transferDueDate: '',
    input_transferFileUpload: null,
    input_transferPhotoLink: null,
    input_transferAmount: null,
    input_transferWithholdingAmount: null,
    menu_transfer_date: null,
    menu_due_date: null,
    select_transferDate: null,
    select_dueDate: null,
    select_transferHour: null,
    select_transferMinute: null,
    transferHourItems: [
      '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11',
      '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'
    ],
    transferMinuteItems: [
      '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
      '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
      '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
      '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
      '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
      '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'
    ],

    data_list_payment: [],

    // windowSize
    size: 'lg',
    window: {
      width: 0,
      height: 0,
    },

    // paginations
    page: 1,
    pageTemp: 1,
    pageLength: 1,
    pageTotalVisible: 9,
    limits: 15,
    offsets: 0,

    // popup
    Popupsearch: null,
    searchStockModelPopup: null,
    addOrderPopup: {
      "MaxWidth": "50%",
      "MaxHeight": 90,
      "Dialog": false,
      "headers": [],
      "Select_Product": [],
      "Data": [],
      "ProductID_List": [],
      "loading": false,
    },
    // แจ้งสถานะ เหมาๆ
    mhaoDialog: false,
    row_id: null,
    mh_line_item_id: null,
    mh_selectStatus: null,

    data_master_pic: [],
    data_master_media: [],
    media_type: null,

    // เปิด เลือกวันที่
    startDate: null,
    menuStartDate: false,
    checkStart: true,

    time: null,
    menu2: false,
    modal2: false,

    // endDate: null,
    // menuEndDate: false,
    // checkEnd: true,
    // ปิด เลือกวันที่
    update_data_pack: {},
    header_edit_item_show: [],

    ProductPrice: 0,

    // edit channel list
    editSaleman: false,
    channelList: [],
    channel: {},
    staffShopList: [],
    staffShop: {},

    IsHaveProductSet: false,

    // เรียกข้อมูล order
    order: null,

    
    isReserveQuantity: 0,
    //แยกออเดอร์
    splitPackageDataSet: {
      headers: [],
      dataSet: [],
      selected: [],
      radio: '0',
      moveTo: null
    },
    splitPackagePopup: {
      dialog: false,
      MaxWidth: "60%",
      MaxHeight: 250,
    },
    orderProfitList: null,
    orderProfitSum: null,
    orderItemProfit_tmp: [],
    orderProfit_tmp: null,
    purchaseOrder_item: null,
    addPackagePopup: {
      "MaxWidth": "50%",
      "MaxHeight": 400,
      "Dialog": false,
      "headers": [],
      "Select_Product": [],
      "Data": [],
      "ProductID_List": [],
      "loading": false,
      invoice_print: {
        ShopID: parseInt(localStorage.getItem("shop_id")),
        invorder : [],
        titleprint_main: null,
        titleprint_secondary: null,
        date: new Date().toISOString().substr(0, 10),
        type: null,
        billNo: null
      },
      sizepage: "a4", 

      // paginations
      page: 1,
      pageTemp: 1,
      pageLength: 1,
      pageTotalVisible: 9,
      limits: 15,
      offsets: 0,
      ResultCount: 0,
      Popupsearch: null,
      SelectPackage: [],

    },
    packageNo: null,
    profitSection_OrderItemInvoice: [],
    profitSection_OrderItemLot: [],
    profitSection_OrderItemLot_header: [],
    skipProductMasterItemIDList:[],
    promotion_item: null,
  }),

  computed: {
    printDocumentOption() {
      if (!this.use_language) return []
      return [
        {"value" : 1 , "text": this.use_language.quotation},
        {"value" : 2 , "text": this.use_language.tax_invoice},
        {"value" : 3 , "text": this.use_language.receipt},
        {"value" : 4 , "text": this.use_language.menu_delivery_note}
      ]
    },
    tab_list() {
      if (!this.use_language) return []
      return [{ id: 0, name: this.use_language.total_productCost }, { id: 1, name: this.use_language.expense }]
    },
    rmaHeaders() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.picture, value: 'photoLink', sortable: false, align: 'center', width: '70px' },
        { text: this.use_language.name_product, value: 'productName', sortable: false },
        { text: 'Barcode', value: 'barcode', sortable: false, width: '140px' },
        { text: 'SKU', value: 'sku', sortable: false, width: '140px' },
        { text: 'RMA Number', value: 'rmaNumber', sortable: false, width: '150px' },
        { text: this.use_language.quantity, value: 'quantity', sortable: false, align: 'center', width: '80px' },
        { text: this.use_language.date, value: 'created', sortable: false, align: 'center', width: '140px' },
      ]
    },
    orderTypeList() {
      if (!this.use_language) return []
      return [
        {text: this.use_language.quotation, value: 10},
        {text: this.use_language.sale_order, value: 30},
        {text: this.use_language.succeed, value: 70},
        {text: this.use_language.cancel, value: 90},
      ]
    },
    change_items_status() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.open_order, value: 10 },
        { text: this.use_language.wait_balance_check, value: 20 },
        { text: this.use_language.waiting_pack_goods, value: 30 },
        { text: this.use_language.packing, value: 40 },
        { text: this.use_language.neatly_packed, value: 50 },
        { text: this.use_language.prepare_ship, value: 60 },
        { text: this.use_language.hand_over_transport, value: 70 },
        { text: this.use_language.cancel, value: 90 },
        { text: this.use_language.delete_order, value: 91 },
      ]
    },
    cod_list() {
      if (!this.use_language) return []
      return [{ "ID": 0, "text": this.use_language.ordinary }, { "ID": 1, "text": "COD" }]
    },
    paymentTypeIDList() {
      if (!this.use_language) return []
      return [{ id: 1, name: this.use_language.draft }, { id: 1, name: this.use_language.awaiting_payment }, { id: 2, name: this.use_language.as_per_amount }, { id: 3, name: this.use_language.paid_already }]
    },
    orderStatusTableHeader() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.date, align: "center", sortable: false, value: "date" },
        { text: this.use_language.order_status_, align: "left", sortable: false, value: "shippingStatusName" },
        { text: this.use_language.parcel_status, align: "left", sortable: false, value: "packageStatusName" },
        { text: this.use_language.parcel_no, align: "left", sortable: false, value: "packageNo" },
        { text: this.use_language.warehouse_staff, align: "left", sortable: false, value: "packName" },
        { text: this.use_language.shop_staff, align: "left", sortable: false, value: "staffShopName" },
        { text: this.use_language.note, align: "left", sortable: false, value: "remark" },
      ]
    },
    mh_itemsStatus() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.please_select_status, value: null },
        { text: this.use_language.ordered_from_chinese_shop, value: 2 },
        { text: this.use_language.chinese_shop_exported, value: 3 },
        { text: this.use_language.goods_arrived_chinese_warehouse, value: 4 },
      ]
    },
    header_edit_item() {
      if (!this.use_language) return []
      return [
        { text: '#', value: 'Index', align: 'center', sortable: false, width: 10 },
        { text: this.use_language.picture, value: 'photoLink', align: 'center', sortable: false, width: 10 },
        { text: this.use_language.name_product, value: 'productName', align: 'left', sortable: false },
        { text: this.use_language.selling_price, value: 'unitPrice', align: 'center', sortable: false },
        { text: this.use_language.quantity, value: 'quantity', align: 'center', sortable: false },
        { text: this.use_language.discount_percent, value: 'discountPercent', align: 'center', sortable: false },
        { text: this.use_language.discount, value: 'discount', align: 'center', sortable: false },
        { text: this.use_language.total_price, value: 'itemPrice', align: 'right', sortable: false },
        { text: '', value: 'Delete', align: 'center', sortable: false, width: 10 }
      ]
    },
    header_edit_item_packag_show() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.image, value: 'photoLink', align: 'center', sortable: false, width: '100px', },
        { text: this.use_language.product, value: 'productName', align: 'left', sortable: false, width: '300px', },
        { text: this.use_language.barcode, value: 'barcode', align: 'left', sortable: false, width: '140px' },
        { text: 'SKU', value: 'sku', align: 'left', sortable: false, width: '140px' },
        { text: this.use_language.quantity, value: 'quantity', align: 'center', sortable: false, width: '100px' },
        { text: '', value: 'Delete', align: 'center', sortable: false, width: '50px' }
      ]
    },
    isReserveQuantityTypeList() {
      if (!this.use_language) return []
      return [
        {text: this.use_language.no_stock_reservations, value: 0},
        {text: this.use_language.reserve_stock, value: 1}
      ]
    },
    purchaseOrder_header() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.item_number, align: 'center', sortable: false, value: 'idText', width: '100px' },
        { text: this.use_language.bill_date, align: 'center', sortable: false, value: 'invoiceDate', width: '200px' },
        { text: this.use_language.company_name, align: 'center', sortable: false, value: 'supplierName', width: '180px' },
        { text: this.use_language.expense_type, align: 'center', sortable: false, value: 'expenseType', width: '130px' },
        { text: this.use_language.amount_money, align: 'center', sortable: false, value: 'amount', width: '120px' },
        { text: this.use_language.reference_number, align: 'center', sortable: false, value: 'referenceNumber', width: '120px' },
        { text: this.use_language.note, align: 'center', sortable: false, value: 'remark', width: '150px' },
        { text: this.use_language.update_date, align: 'center', sortable: false, value: 'updated', width: '150px' },
        { text: this.use_language.updated_by, align: 'center', sortable: false, value: 'updatedByName', width: '100px' },
      ]
    },
    headers_lot_import() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.import_bill_no, align: 'left', sortable: false, value: 'importExportMasterIDText', width: '100px' },
        { text: this.use_language.date_of_import, align: 'center', sortable: false, value: 'importDate', width: '110px' },
        { text: this.use_language.lot_name_label, align: 'center', sortable: false, value: 'lotName', },
        { text: this.use_language.reference_number, align: 'center', sortable: false, value: 'referenceNumber', },
        { text: this.use_language.note, align: 'center', sortable: false, value: 'remark', },
        { text: this.use_language.quantity, align: 'center', sortable: false, value: 'quantity', width: '60px' },
        { text: this.use_language.costprice, align: 'right', sortable: false, value: 'costPrice', width: '100px' },
        { text: this.use_language.sum_total, align: 'right', sortable: false, value: 'total', width: '120px' },
      ]
    },
    headers_lot_import1() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.import_bill_no, align: 'left', sortable: false, value: 'importExportMasterIDText', width: '100px' },
        { text: this.use_language.date_of_import, align: 'right', sortable: false, value: 'importDate', width: '90px' },
        { text: this.use_language.picture, align: 'left', sortable: false, value: 'photoLink', width: '100px' },
        { text: this.use_language.product, align: 'left', sortable: false, value: 'product', width: '250px' },
        { text: this.use_language.lot_name_label, align: 'center', sortable: false, value: 'lotName', },
        { text: this.use_language.reference_number, align: 'center', sortable: false, value: 'referenceNumber', },
        { text: this.use_language.note, align: 'center', sortable: false, value: 'remark', },
        { text: this.use_language.quantity, align: 'center', sortable: false, value: 'quantity', width: '60px' },
        { text: this.use_language.costprice, align: 'right', sortable: false, value: 'costPrice', width: '100px' },
        { text: this.use_language.sum_total, align: 'right', sortable: false, value: 'total', width: '120px' },
      ]
    },
    profitSection_OrderItemInvoice_header() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.picture, align: 'left', sortable: false, value: 'photoLink', width: '100px' },
        { text: this.use_language.product, align: 'left', sortable: false, value: 'product', width: '250px' },
        { text: this.use_language.quantity, align: 'center', sortable: false, value: 'quantity', width: '60px' },
        { text: this.use_language.selling_price, align: 'right', sortable: false, value: 'unitPrice', width: '100px' },
        { text: this.use_language.discount, align: 'right', sortable: false, value: 'discount', width: '60px' },
        { text: this.use_language.sum_total, align: 'right', sortable: false, value: 'total', width: '120px' },
      ]
    },
    promotion_header() {
      if (!this.use_language) return []
      return [
        { text: 'No',align: 'center',sortable: false,value: 'no', width: '60px'},
        { text: this.use_language.promotion_name,align: 'left',sortable: false,value: 'name', width: '300px'},
        { text: this.use_language.promo_received_date, align: 'center', sortable: false, value: 'formattedCreated', width: '100px' },
        { text: this.use_language.overlap_promotion,align: 'center',sortable: false,value: 'isOverlap' , width: '150px'},
        { text: this.use_language.promotion_type,align: 'left',sortable: false,value: 'isPromotionType', width: '150px'},
        { text: this.use_language.create_by,align: 'center',sortable: false,value: 'createdByName', width: '120px'},
      ]
    },

    ////////////////////////////////////////////////////////////////

    computed_transfer_date() {
      if (this.select_transferDate == null) {
        return null
      } else {
        return this.formatDate(this.select_transferDate)
      }
    },
    computed_due_date() {
      if (this.select_dueDate == null) {
        return null
      } else {
        return this.formatDate(this.select_dueDate)
      }
    },
    computed_search_delivery_date() {
      return this.formatDate_1(this.dt_due_delivery_date)
    },
    computed_search_sale_date() {
      return this.formatDate_1(this.dt_due_sale_date)
    },
},

  watch: {
    cod_list_select: function (val) {
      if (val == 0) {
        this.edit_cod_bank = this.detail_ShopBankAccountID
        this.input_transferFileUpload = null
        this.input_transferAmount = null
        this.input_transferWithholdingAmount = null
        this.select_transferDate = null
        this.select_transferHour = null
        this.select_transferMinute = null
        this.data_list_payment = []
      }
    },
    startDate: async function (newVal) {
      if (newVal) {
        this.$refs.menuStartDate.save(this.startDate)
      }
    },
    

  },

  destroyed() {
    // windowSize
    window.removeEventListener('resize', this.handleResize)
  },

  async created() {
    this.customerWebsite = window.location.origin + "/";
    this.postcode_mapping = await this.getPostcodeMapping();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.codeFacebook = urlParams.get('code')

    ///เก็บภาษามาไว้ใน use_language
    this.use_language = await this.get_languages(localStorage.getItem("set_language"));

    // rebuild i18n headers for mutable dialog objects (data() arrow cannot access this.use_language)
    this.addOrderPopup.headers = [
      { text: this.use_language.picture, align: 'center', sortable: false, value: 'photoLink', width: '60px' },
      { text: this.use_language.name, align: 'left', sortable: false, value: 'name' },
      { text: 'SKU', align: 'center', sortable: false, value: 'sku' },
      { text: this.use_language.price, align: 'right', sortable: false, value: 'unitPrice', width: '90px' },
      { text: this.use_language.balance, align: 'right', sortable: false, value: 'quantityAvailable', width: '90px' },
    ]
    this.addPackagePopup.headers = [
      { text: this.use_language.picture, align: 'center', sortable: false, value: 'photoLink', width: '60px' },
      { text: this.use_language.name, align: 'left', sortable: false, value: 'name' },
      { text: this.use_language.balance, align: 'right', sortable: false, value: 'quantityAvailable', width: '90px' },
      { text: this.use_language.quantity, align: 'right', sortable: false, value: 'packedQuantity', width: '90px' },
    ]
    this.splitPackageDataSet.headers = [
      { text: this.use_language.picture, align: "center", sortable: false, value: "photoLink", width: "50px", },
      { text: this.use_language.name, align: "center", sortable: false, value: "productName", width: "50px", },
      { text: 'SKU', align: "center", sortable: false, value: "sku", width: "50px", },
      { text: 'Barcode', align: "center", sortable: false, value: "barcode", width: "50px", },
      { text: this.use_language.available_quantity, align: "center", sortable: false, value: "quantity", width: "50px", },
      { text: this.use_language.split_quantity, align: "center", sortable: false, value: "moveQuantity", width: "50px", },
    ]

    //เช็คสิทธิ์แก้ไขหรือดูได้อย่างเดียว
    this.get_authorize_staffshop();

 
    //แบบเก่าแก้ไขไปบางส่วนที่ใช้แล้ว ชื่อ authorize
    // โหมดคลังประวัติ = อ่านอย่างเดียว → ไม่ให้เปลี่ยนสถานะ/อนุมัติ
    this.canChangeStatusOrder = false

    this.CanApprove = false

    this.header_edit_item_show = this.header_edit_item

    // windowSize
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    if (this.window.width < 960) { this.addOrderPopup.MaxWidth = '100%' }
    else { this.addOrderPopup.MaxWidth = '70%' }
    if (this.size == 'xs') {
      this.limits = 5
      this.addOrderPopup.MaxHeight = (90 * this.window.height) / 100
      this.window.widthname = this.window.width - 35 - 90 - 70 - 30
    } else {
      this.addOrderPopup.MaxHeight = (this.addOrderPopup.MaxHeight * this.window.height) / 100
      // cal limits
      this.limits = parseInt((this.addOrderPopup.MaxHeight - 253) / 80)
    }
    this.OrderMaster.ID = this.$route.query.id

    let order_master_token =  this.$route.query.token;
    
    if(order_master_token!=null &&order_master_token!='' && this.OrderMaster.ID==null){
      this.OrderMaster.ID = await this.get_orderid_by_token(order_master_token)
    }
    

    if (this.OrderMaster.ID != null) {
      await this.ShowDetailOrder_tmp(this.OrderMaster.ID)
      await this.get_order_master_pic_for_pack(this.OrderMaster.ID)
      document.title = this.use_language.menu_orders + " : " + this.format_order_id(this.OrderMaster.ID)
     
    }  
    
    // get staff channel list
    
    this.getFileAttach()
    // get shop express

    this.show_reject = false
    this.page_loading = false
    await this.GetProfitDetail(this.OrderMaster.ID);
  },

  methods: {
    async AddCustomer() {
      await this.rulesnewcustomer()
      if (this.$refs.form.validate()) {
         
        var date = new Date().toISOString()
        this.addCustomer.shopID = this.shop_id
        this.addCustomerShipping.shopID = this.shop_id
        this.addCustomerInvoice.shopID = this.shop_id
        this.addCustomer.created = date
        this.addCustomerShipping.phone = this.addCustomer.phone;
        this.addCustomerShipping.name = this.addCustomer.name;
        if(this.countryCodeSelected&& this.countryCodeSelected.id!= 172 ){
          this.addCustomerShipping.countryID = this.countryCodeSelected.id;
        }else{
          this.addCustomerShipping.countryID=null;
          this.addCustomerShipping.city=null;
          this.addCustomerShipping.postcode= null;
        }
        if (this.addCustomerShipping.postcodeMappingID != null) {
          this.addCustomerShipping.postcodeMappingID = this.addCustomerShipping.postcodeMappingID.id
        } else if (this.addCustomerShipping.postcodeMappingID == null) {
          this.addCustomerShipping.postcodeMappingID = 0
        }

        if (this.addCustomerInvoice.postcodeMappingID != null) {
          this.addCustomerInvoice.postcodeMappingID = this.addCustomerInvoice.postcodeMappingID.id
        } else if (this.addCustomerInvoice.postcodeMappingID == null) {
          this.addCustomerInvoice.postcodeMappingID = 0
        }
        
        this.loadingAdd = true

        var isAddCustomerShipping = false
        var isAddCustomerInvoice = false
        if ( this.addCustomerShipping.name != '' && this.addCustomerShipping.address != '' && this.addCustomerShipping.phone != '' && (this.addCustomerShipping.postcodeMappingID != 0||this.addCustomerShipping.countryID!=null)) {
          isAddCustomerShipping = true
        }
        if (this.addCustomerInvoice.name != '' && this.addCustomerInvoice.address != '' && this.addCustomerInvoice.phone != '' && this.addCustomerInvoice.postcodeMappingID != 0) {
          isAddCustomerInvoice = true
        }

       var shopcustomer= await
          axios.post(shopService_dotnet + 'Customer/new-customer', {
            'shopCustomer': this.addCustomer,
            'shippingAddress': isAddCustomerShipping == true ? this.addCustomerShipping : null,
            'shopCustomerAddressInvoice': isAddCustomerInvoice == true ? this.addCustomerInvoice : null
          }, { headers: this.header_token });
        
         
        if (shopcustomer.status == 200) {
          this.detail_order.shopCustomerID = shopcustomer.data.shopCustomerID;
          this.detail_order.shopCustomerName = this.addCustomer.name;
          this.detail_order.shopCustomerPhone = this.addCustomer.phone;
          this.$swal({
            timer: 1500,
            showConfirmButton: false,
            position: 'center',
            type: 'success',
            text: shopcustomer.data.message,
          })
          this.detail_order.shippingAddressID =null;
          this.detail_order.shippingAddressInvoiceID = null;
          this.detail_order.receiverName=null;
          this.detail_order.receiverPhone=null;
          this.detail_order.receiverAddress=null;
          this.detail_order.InvoiceName=null;
          this.detail_order.InvoiceTaxID=null;
          this.detail_order.InvoiceAddress=null;
          this.detail_order.InvoicePhone=null;

          await this.getShippingAddressList();
          this.customerAddress_selected=this.customerAddressList[0];
          if(this.customerAddressInvoiceList.length>0){
            this.customerAddressInvoice_selected=this.customerAddressInvoiceList[0];  
          }
          this.closeAddCustomer();
        }
        
        this.loadingAdd = false
      }
    },
    closeAddCustomer() {
      this.dialog_addcustomer = false
      this.addCustomer = {
        "id": 0,
        "customerCode": null,
        "name": null,
        "phone": null,
        "email": null,
        "facebook": null,
        "line": null,
        "remark": null,
        "shopID": null,
        "created": null
      }
      this.addCustomerShipping = {
        "id": 0,
        "name": '',
        "phone": '',
        "address": '',
        "shopCustomerID": 0,
        "shopID": null,
        "isDefault": true,
        "postcodeMappingID": 0
      }
      this.addCustomerInvoice = {
        "id": 0,
        "taxID": '',
        "name": '',
        "phone": '',
        "address": '',
        "shopCustomerID": 0,
        "isDefault": true,
        "shopID": null,
        "postcodeMappingID": 0
      }
      this.select_address_invoice_postcodeMapping = null
      this.rules = {
        customername: [],
        customeremail: [],
        customerphone: [],
        customerfacebook: [],
        customerline: [],
        shippingname: [],
        shippingphone: [],
        shippingaddress: []
      }
      this.loadingAdd = false
    },
    async rulesnewcustomer() {
      this.rules.customername = [v => !!v || this.use_language.please_fill]
      this.rules.customerphone = [v => !!v || this.use_language.please_fill]
    },
    async addShippingConfirm() {
      this.loadingAdd = true;
      if (this.addShipping.name == null || this.addShipping.name == '') {
        this.$refs.refShippingName.focus()
        this.loadingAdd = false;
        return
      } else if (this.addShipping.phone == null || this.addShipping.phone == '') {
        this.$refs.refShippingPhone.focus()
        this.loadingAdd = false;
        return
      }

      let postcodeMappingID = null;
      if(this.countryCodeSelected && this.countryCodeSelected.id != 172){
        this.addShipping.countryID = this.countryCodeSelected.id;
 

      }
      else{
        postcodeMappingID = this.addShipping.postcodeMappingID.id;
        this.addShipping.countryID = null;
        this.addShipping.city = null;
        this.addShipping.postcode = null;
      }
      this.loadingAdd = true;
       
      let response= await axios.post(shopService_dotnet + 'Customer/update-customer-address', {
          "id": this.addShipping.id,
          "name": this.addShipping.name,
          "phone": this.addShipping.phone,
          "address": this.addShipping.address,
          "shopCustomerID": this.detail_order.shopCustomerID,
          "IsDefault": this.addShipping.isDefault,
          "postcodeMappingID":postcodeMappingID,
          "postcode": this.addShipping.postcode,
          "countryID": this.addShipping.countryID,
          "city": this.addShipping.city
        }, { headers: this.header_token });

        if (response.status == 200) {
          this.loadingAdd = false;
          var res = response.data.at(-1)
          res.text = res.name+' '+res.phone+' '+ res.shortAddress;
          this.customerAddress_selected = res
      
          if(this.addShipping.id != 0){
            var index = this.customerAddressList.findIndex(x => x.id === this.addShipping.id);
            if (index !== -1) {
              this.customerAddressList.splice(index, 1);
            }
          }
          this.customerAddressList.unshift(res)
            
          this.closeAddShipping()
        } else {
          this.loadingAdd = false;

          this.$swal({
            type: 'warning',
            title: this.use_language.some_error_try_again + '!',
          })
        }
      
    },
    closeAddShipping() {
      this.dialog_addshipping = false
      this.addShipping={
        id: 0,
        name:null,
        phone:null,
        countryID:this.customerAddress_selected.countryID,
        postcodeMappingID:null,
        city:null,
        postcode:null,
        address:null,
        isDefault:false
      },
      this.countryCodeSelected = null;
      
 
    },
    async OpenEditShippingInvoice(){
      this.address_invoice = {
        id: this.customerAddressInvoice_selected.id,
        taxID:  this.customerAddressInvoice_selected.taxID,
        name:  this.customerAddressInvoice_selected.name,
        phone:  this.customerAddressInvoice_selected.phone,
        address:  this.customerAddressInvoice_selected.address, 
        isDefault: this.customerAddressInvoice_selected.isDefault
      }
      if(this.customerAddressInvoice_selected.postcodeMappingID != null){
        this.select_address_invoice_postcodeMapping = this.postcode_mapping.find(x => x.id === this.customerAddressInvoice_selected.postcodeMappingID);
      }
    },
    async btnAddAddresInvoice() {
      var ispass = true;
      if(this.address_invoice.phone == null || this.address_invoice.phone == ''){
        this.address_invoice_validate.phone = true;
        ispass = false;
      }
      if(this.address_invoice.name == null || this.address_invoice.name == ''){
        this.address_invoice_validate.name = true;
        ispass=false;
      }
      if(this.address_invoice.address == null || this.address_invoice.address == ''){
        this.address_invoice_validate.address = true;
        ispass=false;
      }
      if(this.select_address_invoice_postcodeMapping == null ){
        this.address_invoice_validate.postcode = true;
        ispass = false;
      }
      if(!ispass){
        return;
      }
      this.loadingAdd = true
      let response = await
   
        axios.post(shopService_dotnet + 'Customer/update-customer-invoice-address',
        {
          "id": this.address_invoice.id,
          "taxID": this.address_invoice.taxID,
          "name": this.address_invoice.name,
          "phone": this.address_invoice.phone,
          "address": this.address_invoice.address,
          "shopCustomerID": this.detail_order.shopCustomerID,
          "isDefault": (this.address_invoice.isDefault? this.address_invoice.isDefault:false),
          "postcodeMappingID": this.select_address_invoice_postcodeMapping.id
        }, 
        { headers: this.header_token });
     
       
        if (response.status == 200) {
          var res = response.data.at(-1)
          res.text = res.name+(res.taxID? ' (' + res.taxID + ')' : '')+' '+res.phone+' '+ res.shortAddress;
            
          if(this.address_invoice.id != 0){
            var index = this.customerAddressInvoiceList.findIndex(x => x.id === this.address_invoice.id);
            if (index !== -1) {
              this.customerAddressInvoiceList.splice(index, 1);
            }
          }
          this.customerAddressInvoice_selected = res
          this.customerAddressInvoiceList.push(res)
        } else {
          this.$swal({
            type: 'warning',
            title: this.use_language.warning_error_try_again,
          })
        }
        this.loadingAdd = false
    

      this.loadingAdd = false
      this.closeAddressInvoiceDialog()
    },
    closeAddressInvoiceDialog() {
      this.dialog_addshipping_invoice = false;
      this.address_invoice_validate = {
          phone: false,
          name: false,
          address: false,
          postcode: false
        }
      this.address_invoice = {

          taxID: null,
          id: 0,
          name: null,
          phone: null,
          address: null,
          isDefault: false

        }
      this.select_address_invoice_postcodeMapping = null
    },
   
    async GetShopCustomer(id){
      let response = await axios.get(
        shopService_dotnet + 'Customer/get-shop-customer?id='+id, 
        { headers: this.header_token}
      )
      if(response.status == 200){
        this.detail_order.shopCustomerName = response.data.name
        this.detail_order.shopCustomerPhone = response.data.phone
      }
    },
   
 
  
    async genOrderNumber() {
      if (this.select_order_type.value <= 60) {
        if ((this.txt_quotationNumber == '' || this.txt_quotationNumber == null) || (this.txt_invoiceNo == '' || this.txt_invoiceNo == null)) {
          let response = await axios.post(
            orderService_dotnet +'Order/get-number-order-type',
            {
              'shopID': this.shop_id,
              'customerType': 2,
              'orderType': this.select_order_type.value <= 20 ? 1 : 2
            },
            { headers: this.header_token}
          )
          if (response.status == 200) {
            if (this.select_order_type.value == 10 && (this.txt_quotationNumber == '' || this.txt_quotationNumber == null)) {
              this.txt_quotationNumber = response.data
            } else if (this.select_order_type.value == 30 && (this.txt_invoiceNo == '' || this.txt_invoiceNo == null)) {
              this.txt_invoiceNo = response.data
            }
          }
        }
      }
    },
    async SubmitEditOrderInfo() {
      if(this.isSaving){
        return;
      }
      this.isSaving=true;
      if (this.detail_order.shopCustomerID == null
        && (!this.platformReferenceSourceID.includes(this.detail_order.referenceSourceID) || this.detail_order.isSellerOwnFleet)
      ) {
        this.$swal({
          position: 'top',
          type: 'info',
          title: this.use_language.please_select_customer,
          text: this.use_language.select_or_add_customer,
        })
        this.$vuetify.goTo(this.$refs.refCustomerSelect, { offset: 50 })
        this.$refs.refCustomerSelect.focus()
        this.loading = false
        this.isSaving=false;
        return
      }
      if (this.select_order_type.value >= 30 && this.select_order_type.value <= 60 && this.customerAddress_selected == null
        && (!this.platformReferenceSourceID.includes(this.detail_order.referenceSourceID) || this.detail_order.isSellerOwnFleet)
      ) {
        this.$swal({
          position: 'top',
          type: 'info',
          title: this.use_language.please_select_delivery_address,
          text: this.use_language.select_or_add_shipping_address,
        })
        this.$vuetify.goTo(this.$refs.refCustomerAddressSelect, { offset: 50 })
        this.$refs.refCustomerAddressSelect.focus()
        this.loading = false
        this.isSaving=false;
        return
      }

   

      let branchExpressID = null;
      let shopExpressID = null;
      let expressCompanyID = null;
      if(this.express_selected != null){
        let splited = this.express_selected.uniqueID.split('_');
        shopExpressID = parseInt(splited[1])
        branchExpressID = parseInt(splited[0])
        expressCompanyID = parseInt(splited[2])
      }
      this.detail_order.shippingStatusID = this.select_order_type.value;
      if(this.detail_order.customerType==2)
      {
        // b2b order
        try {
          if(this.select_order_type.value != 10 ){
            this.isReserveQuantity=0;
          }
          let response = await axios.post(
            orderService_dotnet + 'Order/update-order-b2b',
            {
              "orderID": parseInt(this.OrderMaster.ID),
              "isQuotation": this.select_order_type.value == 10 ? true : false,
              "quotationNumber": this.txt_quotationNumber == null || this.txt_quotationNumber == '' ? null : this.txt_quotationNumber,
              "invoiceNo": this.txt_invoiceNo == null || this.txt_invoiceNo == '' ? null : this.txt_invoiceNo,
              "referenceNumber": this.txt_referenceNumber == null || this.txt_referenceNumber == '' ? null : this.txt_referenceNumber,
              "dueDeliveryDate": this.dt_due_delivery_date == null || this.dt_due_delivery_date == '' ? null : this.dt_due_delivery_date,
              "dueSaleDate": this.dt_due_sale_date == null || this.dt_due_sale_date == '' ? null : this.dt_due_sale_date,
              "shopCustomerID": this.detail_order.shopCustomerID,
              "shippingAddressID": this.customerAddress_selected == null ? null : this.customerAddress_selected.id,
              "shippingAddressInvoiceID": this.customerAddressInvoice_selected == null ? null : this.customerAddressInvoice_selected.id,
              "expressCompanyID": expressCompanyID,
              "branchExpressID":branchExpressID,
              "shopExpressID": shopExpressID,
              "referenceSourceID": this.channel.id,
              "salemanID": this.detail_saleman1.value,
              "salemanID2": this.detail_saleman2 == null ? null : this.detail_saleman2.value,
              "updateBy": parseInt(localStorage.getItem('staff_id')),
              'orderType': this.select_order_type.value ,
              'isReserveStock': (this.isReserveQuantity==0? false : true) 
            }, 
            { headers: this.header_token }
          )
          if (response.data.status == "success") {
            Swal.fire({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: 'top',
              type: 'success',
              title: 'Success'
            })
           
           

            
          } else {
            this.$swal({ 
              type: "warning", 
              text: response.data.error_description,
            })
          }
        } catch (error) {
          this.$swal({ 
            type: "error", 
            text: this.use_language.cannot_process_contact + " IT",
          })
        }
      }
      else{

        var dataRequest ={};
        dataRequest.isUpdateChannel=false;
        dataRequest.isUpdateSaleman=false;
        dataRequest.isUpdateReferenceNumber=false;
        dataRequest.isUpdateExpress = false;
        if(!this.platformReferenceSourceID2.includes(this.detail_order.referenceSourceID))
        {
          if(this.channel.id!=this.detail_order.referenceSourceID){
            dataRequest.isUpdateChannel=true;
          } 
          if(this.detail_saleman1.value!=this.detail_order.salemanID){
            dataRequest.isUpdateSaleman=true;
          } 
          if(this.txt_referenceNumber!=this.detail_order.referenceNumber){
            dataRequest.isUpdateReferenceNumber=true;
          } 
          // update ช่องทางการขาย 
          // และ พนักงานขายได้
          // เลขอ้างอิง
        }

        if(!this.platformReferenceSourceID.includes(this.detail_order.referenceSourceID) || this.detail_order.isSellerOwnFleet){
          // update ขนส่งได้
          dataRequest.isUpdateExpress = true;
        } 

        dataRequest.orderID = parseInt(this.OrderMaster.ID);
        dataRequest.referenceNumber = this.txt_referenceNumber == null || this.txt_referenceNumber == '' ? null : this.txt_referenceNumber;
        dataRequest.shopCustomerID=this.detail_order.shopCustomerID;
        dataRequest.shippingAddressID = this.customerAddress_selected == null ? null : this.customerAddress_selected.id;
        dataRequest.shippingAddressInvoiceID = this.customerAddressInvoice_selected == null ? null : this.customerAddressInvoice_selected.id;
        dataRequest.expressCompanyID = expressCompanyID;
        dataRequest.branchExpressID = branchExpressID;
        dataRequest.shopExpressID = shopExpressID;
        dataRequest.referenceSourceID = this.channel.id;
        dataRequest.salemanID = this.detail_saleman1.value;
        dataRequest.salemanID2 = this.detail_saleman2 == null ? null : this.detail_saleman2.value;
        dataRequest.updateBy = parseInt(localStorage.getItem('staff_id'));  

         let response = await axios.post(
            orderService_dotnet + 'Order/update-order-detail',
            dataRequest, 
            { headers: this.header_token });
        if (response.data.status == "success") {
          Swal.fire({
            toast: true,
            timer: 1500,
            showConfirmButton: false,
            position: 'top',
            type: 'success',
            title: 'Success'
          })
          
        } else {
          this.$swal({ 
            type: "warning", 
            text: response.data.error_description,
          })
        }
      }

      this.detail_orderType = this.orderTypeList.filter(i => i.value == this.select_order_type.value)[0].text
      this.detail_order.quotationNumber = this.txt_quotationNumber
      this.detail_order.invoiceNo = this.txt_invoiceNo
      this.detail_order.referenceNumber = this.txt_referenceNumber;
      this.detail_order.dueDeliveryDate = this.dt_due_delivery_date
      this.detail_order.confirmedOrderDate = this.dt_due_sale_date 
      this.detail_order.isReserveStock = (this.isReserveQuantity==0? false : true) ;
      this.detail_order.expressCompanyName = (this.express_selected != null ? this.express_selected.expressCompanyName : null);
      this.detail_order.expressCompanyLogo = (this.express_selected != null ? this.express_selected.logoPic  : null);
      this.detail_order.expressCompanyID =expressCompanyID;
      this.detail_order.branchExpressID =branchExpressID;
      this.detail_order.shopExpressID =shopExpressID;
      this.detail_order.channelLogo = (this.channel != null ? this.channel.logoPic : null);
      this.detail_order.channelName = (this.channel != null ? this.channel.channelName : null);
      this.detail_order.referenceSourceID = (this.channel != null ? this.channel.id : null);
      this.detail_order.salemanName = this.detail_saleman1.text;
      this.detail_order.salemanID = this.detail_saleman1.value;
      this.detail_order.salemanName2 = (this.detail_saleman2 != null ? this.detail_saleman2.text : null)
      this.detail_order.salemanID2 = (this.detail_saleman2 != null ? this.detail_saleman2.value : null)
        
      this.detail_order.receiverName
      if(this.customerAddress_selected==null){
        this.detail_order.receiverName = null
        this.detail_order.receiverPhone = null
        this.detail_order.receiverAddress = null
        this.detail_order.shippingAddressID = null
      }else{
        this.detail_order.receiverName = this.customerAddress_selected.name;
        this.detail_order.receiverPhone = this.customerAddress_selected.phone;
        this.detail_order.receiverAddress = this.customerAddress_selected.shortAddress;
        this.detail_order.shippingAddressID = this.customerAddress_selected.id
      }

      if(this.customerAddressInvoice_selected==null){
        this.detail_order.InvoiceName = null
        this.detail_order.InvoiceTaxID = null
        this.detail_order.InvoicePhone = null
        this.detail_order.InvoiceAddress = null
        this.detail_order.shippingAddressInvoiceID = null
      }else{
        this.detail_order.InvoiceName = this.customerAddressInvoice_selected.name;
        this.detail_order.InvoiceTaxID = this.customerAddressInvoice_selected.taxID;
        this.detail_order.InvoicePhone = this.customerAddressInvoice_selected.phone;
        this.detail_order.InvoiceAddress = this.customerAddressInvoice_selected.shortAddress;
        this.detail_order.shippingAddressInvoiceID = this.customerAddressInvoice_selected.id
      }
      this.can_edit_b2b = false
      this.isSaving=false;
    },
    get_languages,
    checkAuthorize,
    getPostcodeMapping,
    async getStaffShop() {
      try {
        if(this.platformReferenceSourceID2.includes(this.detail_order.referenceSourceID)){
          this.customerSalemanList=[{'text':this.detail_order.salemanName,'value':this.detail_order.salemanID}];
          this.detail_saleman1 = this.customerSalemanList[0];
          
          
          return;
        }
        let response = await axios.post(shopService_dotnet + 'Shop/get-shop-staff', {
          "shopID": localStorage.getItem('shop_id'),
        }, { headers: this.header_token })
        if (response.status == 200) {
          this.staffShopList = response.data
          this.staffShop = this.staffShopList.filter(x => x.id == this.detail_order.salemanID)[0]
          this.customerSalemanList = response.data.map((item) => ({
                                        'text': item.name, 
                                        'value': item.id
                                      }))
          this.detail_saleman1 = this.customerSalemanList.filter(x => x.value == this.detail_order.salemanID)[0]
          this.detail_saleman2 = (this.detail_order.salemanID2 != null ? this.customerSalemanList.filter(x => x.value == this.detail_order.salemanID2)[0] : null)
        }
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "get-shop-staff " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }

    },
    ConvertBase64ToPDF(base64Data){
      

      // Convert base64 to blob
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(blob);

      const newWindow = window.open(pdfUrl);
 

      // downloadLink.href = linkSource;
      // downloadLink.download = fileName;
      // downloadLink.click();
    },
    async getFileAttach() {
      try {
        let response = await axios.post(orderService_dotnet + 'Order/get-order-file-attach',
          { "orderID": this.OrderMaster.ID },
          { headers: this.header_token }
        )
        if (response.status == 200) {
          this.fileAttach = response.data.data
        }
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "get-shop-staff " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }

    },

    async submit_docFile() {
      if (this.input_doc_select == null) {
        this.$refs.input_doc_select.focus()
        return
      }
      if (this.input_docFileUpload == null) {
        this.$refs.input_docFileUpload.focus()
        return
      }

      var typeID = null
      if (this.input_doc_select == 'ใบปะหน้า') {
        typeID = 1
      } else {
        typeID = 2
      }
      var url_file = await this.upload_file_py(this.input_docFileUpload)
      var ext = url_file.substr(url_file.length - 3)

      let response = await axios.post(
        orderService_dotnet + 'Order/add-order-file-attach',
        {
          "id": 0,
          "orderMasterID": parseInt(this.OrderMaster.ID),
          "createdDatetime": new Date().toISOString(),
          "documentType": this.input_doc_select,
          "documentTypeID": typeID,
          "extension": ext, //jpg png pdf
          "fileUrl": url_file

        },
        { headers: this.header_token }
      )
      if (response.data.status == 'success') {
        this.fileAttach = response.data.data
        this.dialog_doc = false
        this.input_docFileUpload = null
        this.input_doc_select = null
      } else {
        this.$swal({
          position: "top",
          type: "error",
          text: this.use_language.cannot_process_please_try_again,
        })
      }
    },
 
    async upload_file_py(file_data) {
      var from_data = new FormData()
      from_data.append('bucket', 'Doc_file')
      from_data.append('file', file_data)
      // อัพโหลดภาพ
      let UploadFileResponse = await axios.post(
        generalService_dotnet + 'General/upload-file-with-bucket',
        from_data,
        {
          headers: { "Content-Type": "multipart/form-data", "Authorization": "Bearer " + token_api }
        }
      )

      if (UploadFileResponse.status == 200 && UploadFileResponse.data.status == "success") {
        return UploadFileResponse.data.file_path
      } else {
        this.$swal({
          position: "top",
          type: "error",
          text: this.use_language.cannot_process_please_try_again,
        })
      }
    },

    async DeleteFileAttach(id) {
      Swal.fire({
        type: "warning",
        title: this.use_language.confirm_delete,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          this.loading = true;
          try {
            let response = await axios.get(orderService_dotnet + 'Order/delete-order-file-attach?ID=' + id, { headers: this.header_token })
            this.loading = false;
            if (response.status == 200 && response.data.status == "success") {
              this.fileAttach = response.data.data
            } else {
              Swal.fire({
                type: "error",
                title: response.data.error_description
              });
            }
          } catch (e) {
            this.loading = false;
            Swal.fire({
              type: "error",
              title: this.use_language.error_contact_it,
            })
          }
        }
      });
    },

    async getChannelList() {
      try {
        if(this.platformReferenceSourceID2.includes(this.detail_order.referenceSourceID)){
          this.channelList = [{ 
                              'channelName': this.detail_order.channelName,
                              'id':this.detail_order.referenceSourceID,
                              'logoPic': this.detail_order.channelLogo
                            }];
          this.channel = this.channelList[0];
         
          
          return
        }else{

          let response = await axios.post(shopService_dotnet + 'Shop/get-shop-channel', {
            "shopID": this.shop_id,
          }, { headers: this.header_token })
          if (response.status == 200) {
            this.channelList = response.data
            this.channel = this.channelList.filter(x => x.id == this.detail_order.referenceSourceID)[0]
        
            
          }
        }
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "get-shop-channel " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }

    },

    async SummitSaleman() {
      try {
        this.loading = true
        let response = await axios.post(orderService_dotnet + 'Order/update-sale-channel', {
          "Id": this.detail_order.id,
          "salemanID": this.staffShop.id,
          "referenceSourceID": this.channel.id,
          "referenceNumber": this.detail_order.referenceNumber == '' ? null : this.detail_order.referenceNumber,
        }, { headers: this.header_token })
        this.loading = false
        if (response.status == 200) {
          Swal.fire({
            toast: true,
            timer: 1500,
            showConfirmButton: false,
            position: 'top',
            type: 'success',
            title: 'Success'
          })
          this.detail_order.salemanID = this.staffShop.id
          this.detail_order.salemanName = this.staffShop.name
          this.detail_order.referenceSourceID = this.channel.id
          this.detail_order.channelName = this.channel.channelName
          this.detail_order.channelLogo = this.channel.logoPic
          this.editSaleman = false
        } else {
          this.loading = false
          Swal.fire({
            position: "top",
            type: "error",
            text: this.use_language.cannot_perform_operation,
          })
        }
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "update-sale-channel " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }

    },

    formatDatetime,
    format_number,
    format_order_id,
    format_price,
    isNumberWNoDot,
    formatMoney,
    china_order_fornat,
    Trim_value,
    Trim_rules,

    can_edit_cod() {
      if (this.detail_IsCOD == true) {
        this.cod_list_select = 1
      } else {
        this.cod_list_select = 0
      }

    },

    allowedDates: val => val <= new Date().toISOString().substr(0, 10),

    formatDate(date) {
      date = [date]
      if (date.length == 0) return null

      if (date.length == 1) {
        const [year, month, day] = date[0].split('-')
        return `${day}-${month}-${year}`
      } else {
        const [year_from, month_from, day_from] = date[0].split('-')
        const [year_to, month_to, day_to] = date[1].split('-')
        if (date[0] < date[1]) {
          return `${day_from}-${month_from}-${year_from} ~ ${day_to}-${month_to}-${year_to}`
        } else {
          return `${day_to}-${month_to}-${year_to} ~ ${day_from}-${month_from}-${year_from}`
        }
      }
    },

    // windowSize
    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
      if (this.window.width < 600) {
        this.size = 'xs'
      } else if (this.window.width >= 600 && this.window.width < 960) {
        this.size = 'sm'
      } else if (this.window.width >= 960 && this.window.width < 1264) {
        this.size = 'md'
      } else if (this.window.width >= 1264 && this.window.width < 1904) {
        this.size = 'lg'
      } else if (this.window.width >= 1904) {
        this.size = 'xl'
      }
    },
    OpenPhoto(Photo) {
      this.ShowPhotoLink = Photo
      this.ShowPhoto = true
    },
    Opentap(PhotoLink) {
      window.open(PhotoLink);
    },

    async getShopExpress() {

      try {

        let response1 = await axios.post(shopService_dotnet + 'Shop/get-shop-express-addorder', { 'shopID': this.shop_id }, { headers: this.header_token })

     
        this.ExpressList = response1.data.map((item) => ({
                            'expressCompanyName': item.expressCompanyName, 
                            'shopExpressID': item.id,
                            'expressCompanyID': item.expressCompanyID,
                            'logoPic': item.logoPic,
                            'uniqueID':item.uniqueID
                          })) 
        if (this.detail_order.shopExpressID != null) {
          let selected = this.ExpressList.filter(i => i.shopExpressID == this.detail_order.shopExpressID);
          if(selected.length > 0){
            this.express_selected = selected[0];
          } 
        }
        
        if(this.express_selected==null){
          const myArray = this.ExpressUniqueID.split("_");
        
          var expressCompanyID = parseInt(myArray[2])
          var shopExpressID = parseInt(myArray[1])
          var branchExpressID = parseInt(myArray[0])
          if (branchExpressID == 0) {
            branchExpressID = null
          }
          if (shopExpressID == 0) {
            shopExpressID = null
          }
          
          
          if (branchExpressID == null && shopExpressID == null) {
            
            for (let index = 0; index < this.ExpressList.length; index++) {
              if (expressCompanyID == this.ExpressList[index].expressCompanyID) {
                this.ExpressUniqueID = this.ExpressList[index].uniqueID;
                this.express_selected = this.ExpressList[index];
                index = this.ExpressList.length;
              }
            }
          }

          if(this.express_selected==null){
            response1 = await axios.post(logistic_Service + 'Logistic/get-express-list-by-id?ID='+expressCompanyID, {},  { headers: this.header_token })
            if(response1.status == 200){
              this.ExpressList.push({
                          'expressCompanyName': response1.data[0].name, 
                          'shopExpressID': null,
                          'expressCompanyID': response1.data[0].id,
                          'logoPic': response1.data[0].logoPic,
                          'uniqueID': this.ExpressUniqueID
                        });
              this.express_selected = this.ExpressList[this.ExpressList.length - 1];
            }
          }
        }
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "detail-order-get-express-for-edit " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }

    },


    async update_shop_express_id() {
      try {

        if (this.ExpressUniqueID == "" || this.ExpressUniqueID == null) {
          this.$swal({
            type: "warning",
            title: this.use_language.please_select_shipping
          })
          return;
        }

        const myArray = this.ExpressUniqueID.split("_");
        var expressCompanyID = parseInt(myArray[2])
        var shopExpressID = parseInt(myArray[1])
        var branchExpressID = parseInt(myArray[0])
        if (branchExpressID == 0) {
          branchExpressID = null
        }
        if (shopExpressID == 0) {
          shopExpressID = null
        }
        if (branchExpressID == null || shopExpressID == null) {
          this.$swal({
            type: "warning",
            title: this.use_language.please_select_shipping
          })
          return;
        }
        this.loading = true
        let response = await axios.post(orderService_dotnet + 'Order/edit-order-express-company',
          {
            "orderMasterID": this.OrderMaster.ID,
            "expressCompanyID": expressCompanyID,
            "branchExpressID": branchExpressID,
            "shopExpressID": shopExpressID,
          },
          { headers: this.header_token }
        )
        if (response.data.status == "success") {
          this.can_edit_data_express = false
          this.ShowDetailOrder_tmp(this.OrderMaster.ID)
        } else {
          this.loading = false
          this.$swal({
            type: "warning",
            title: this.use_language.error_contact_it,
            text: response.data.error_description,
          })
        }
        this.loading = false
      } catch (e) {
        this.$swal({
          position: "top",
          type: "warning",
          title: "detail-order-get-express-for-edit " + this.use_language.error_occurred_contact + " IT !!"
        })
      }

    },

    remove_data_product(data_product) {
      let StockID= data_product.stockShopId
      // ลบข้อมูลใน this.detailOrderProduct_tmp
      if(data_product.orderItemID!=0){
        for (let n = 0; n < this.detailOrderProduct_tmp.length; n++) {
          if (data_product.orderItemID == this.detailOrderProduct_tmp[n]['orderItemID']) {
            this.detailOrderProduct_tmp.splice(n, 1)
            break;
          }
        }
      }
      else if(data_product.orderItemInvoiceID!=0){
        for (let n = 0; n < this.detailOrderProduct_tmp.length; n++) {
          if (data_product.orderItemInvoiceID == this.detailOrderProduct_tmp[n]['orderItemInvoiceID']) {
            this.detailOrderProduct_tmp.splice(n, 1)
            break;
          }
        }
      }
 

      this.calculateTotalStockPrice()
    },

    async update_data_product() {
      try {
        this.loading = true
        let self = this
        self.orderItem = []

        var string_alert = ""
        var orderItem_dict = {}
        for (var i = 0; i < self.detailOrderProduct_tmp.length; i++) {

          orderItem_dict = {
            "orderItemID": self.detailOrderProduct_tmp[i].orderItemID,
            "orderItemInvoiceID": self.detailOrderProduct_tmp[i].orderItemInvoiceID,
            "stockShopId": self.detailOrderProduct_tmp[i].stockShopId,
            "quantity": self.detailOrderProduct_tmp[i].quantity,
            "unitPrice": self.detailOrderProduct_tmp[i].unitPrice,
            "discountPercent": self.detailOrderProduct_tmp[i].discountPercent,
            "discount": self.detailOrderProduct_tmp[i].discount,
            "isLock": true,
            "isProductSet": self.detailOrderProduct_tmp[i].isProductSet,
            "productMasterID": self.detailOrderProduct_tmp[i].productMasterId,
            "productMasterItemID": self.detailOrderProduct_tmp[i].productMasterItemId
          }
         
          self.orderItem.push(orderItem_dict)

        }

        var isCod = false;
        var codAmount = null;
        if (this.IsCanEditCOD) {
          isCod = this.detail_IsCOD;
          if (isCod) {
            codAmount = this.edit_cod_amount;

          } else {
            codAmount = null
          }

          if (codAmount == null || codAmount == 0) {
            isCod = false;
          }

        } else {
          isCod = this.detail_IsCOD
          codAmount = this.detail_CODAmount;
        }
        var isConfirm = true;
        if (this.detail_CODAmount != codAmount) {
          await Swal.fire({
            type: "question",
            title: this.use_language.cod_amount_changed,
            text: this.use_language.confirm_change_cod_from + " " + this.detail_CODAmount + " " + this.use_language.is + " " + codAmount + " " + this.use_language.please_confirm,
            confirmButtonText: this.use_language.confirm,
            cancelButtonText: this.use_language.cancel,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            allowOutsideClick: false,
          }).then(async (result) => {
            if (!result.value) {
              isConfirm = false;
            }
          });
        }

        var insureAmount = null
        if (this.edit_insurance_amount == '' || this.edit_insurance_amount == null || this.edit_insurance_amount == '0') {
          insureAmount = null
        } else {
          insureAmount = Number(this.edit_insurance_amount)
        }

        if (isConfirm) {

          var orderMasterParam_tmp = {
            "orderMasterID": this.OrderMaster.ID,
            "isCod": isCod,
            "codAmount": codAmount,
            "vatPercent": this.vat_percent,
            "deliveryCost": this.textField_deliveryCost,
            "orderDiscountPercent": (this.select_discountType == '฿' ? null : this.textField_discount),
            "orderDiscount": (this.select_discountType == '%' ? this.totalDiscount : this.textField_discount),
            "vatType": this.select_vatType,
            "vatAmount": this.totalVat,
            "totalPrice": this.totalPrice,
            "insuranceAmount": insureAmount
          }


          let response = await axios.post(orderService_dotnet + 'Order/detail-order-edit-items', {
            "orderItemInvoice": self.orderItem,
            "orderMasterParam": orderMasterParam_tmp,
            "staffShopID": this.StaffShopID,
            "staffBranchID": this.StaffBranchID
          }, { headers: this.header_token })
          self.loading = false
          if (response.data.orderItemProductResponse != null && response.data.orderItemProductResponse.length > 0) {


            // ขึ้นเตือนสินค้าสต๊อกไม่พอ
            self.dialog_not_enough_stock = true
            self.orderItemProductResponse = []
            self.dialog_massage = response.data.error_description
            self.orderItemProductResponse = response.data.orderItemProductResponse
          } else if (response.data.status == "error") {
            this.$swal({
              position: "top",
              type: "info",
              title: "detail-order-edit-items " + this.use_language.error_occurred_contact + " IT !!",
              text: response.data.status,
            })
          } else {
            Swal.fire({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: 'top',
              type: 'success',
              title: this.use_language.edit_success
            })
            this.ShowDetailOrder_tmp(this.OrderMaster.ID)
            this.can_edit_product = false;
          }
        }
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "detail-order-edit-items " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }

    },

    discountPercent(item) {
      if (item.discountPercent != "") {
        var discount = (Number(item.unitPrice) * Number(item.quantity) * Number(item.discountPercent)) / 100
        item.discount = discount.toFixed(2)
      } else {
        item.discount = null
      }
    },

    async unitPriceInput(item) {

      if (item.unitPrice == "") {
        await this.$swal({
          position: "top",
          type: "info",
          text: this.use_language.please_enter_product_price,
        })
        item.VueComponentFocus.unitPrice()
      } else {
        item.unitPrice = Number(item.unitPrice).toFixed(2)
        this.calculateDiscountPercent(item)
        this.calculateTotalStockPrice()
      }
    },

    async quantityInput(item) {
      var quantity = item.quantity
      if (quantity == "" || quantity == null) {
        await this.$swal({
          position: "top",
          type: "info",
          text: this.use_language.please_enter_product_quantity,
        })
        item.VueComponentFocus.quantityInput()
      } else {
        this.calculateDiscountPercent(item)
        this.calculateTotalStockPrice()
      }
    },

    calculateDiscountPercent(item) {
      var discountPercent = Number(item.discountPercent)
      if (!Number.isNaN(discountPercent) && discountPercent != 0) {
        var price = Number(item.unitPrice)
        var quantity = Number(item.quantity)
        item.discount = Number((price * quantity * discountPercent) / 100).toFixed(2)
      } else {
        item.discountPercent = null
        item.discount = null
      }
    },

    calculateTotalStockPrice() {
      this.totalPrice = 0
      var price = 0
      var quantity = 0
      var discountPercent = 0
      var discount = 0
      for (var i = 0; i < this.detailOrderProduct_tmp.length; i++) {
        price = Number(this.detailOrderProduct_tmp[i].unitPrice)
        quantity = Number(this.detailOrderProduct_tmp[i].quantity)
        if (quantity > 0 && price >= 0) {
          discount = (Number.isNaN(Number(this.detailOrderProduct_tmp[i].discount)) ? 0 : Number(this.detailOrderProduct_tmp[i].discount))
          // this.productList[i]['itemPrice'] = price * quantity - discount
          this.detailOrderProduct_tmp[i]['itemPrice'] = price * quantity - discount
          this.totalPrice += price * quantity - discount
        }
      }
      this.ProductPrice = this.totalPrice
      this.calculateDiscountOrder()
      this.calculateVAT()

    },

    calculateVAT() {
      this.totalVat = 0
      // Set COD Amount
      this.vat_percent = 0
      this.textfield_codAmount = (this.totalPrice + Number(this.textField_deliveryCost) - this.totalDiscount).toFixed(2)
      if (this.select_vatType == 2) {
        this.vat_percent = 7
        this.totalVat = ((this.totalPrice + Number(this.textField_deliveryCost) - this.totalDiscount) * this.vat_percent) / 107
      }
      else if (this.select_vatType == 3) {
        this.vat_percent = 7
        this.totalVat = ((this.totalPrice + Number(this.textField_deliveryCost) - this.totalDiscount) * this.vat_percent) / 100
        // Set COD Amount
        this.textfield_codAmount = (Number(this.textfield_codAmount) + this.totalVat).toFixed(2)
      }

      // สำหรับ cod Amount
      this.edit_cod_amount = (this.totalPrice + Number(this.textField_deliveryCost) - this.totalDiscount) + (this.select_vatType == 3 ? this.totalVat : 0)
    },

    calculateDiscountOrder() {
      if (this.select_discountType == "฿") {
        this.totalDiscount = Number(this.textField_discount)
      } else {
        this.totalDiscount = ((this.totalPrice + Number(this.textField_deliveryCost)) * Number(this.textField_discount)) / 100
      }
      this.calculateVAT()
    },


    black_to_order_page() {
      window.close()
    },

    async print_page (item) {
      if (this.printDocument.value == 0) {return}
      // window.open('print-tax-invoice?id='+item,'_blank');
      
      let response = await axios.post(reportService_dotnet+'ShopInvoiceOrder/get-invoice-no-before-print', {
        "orderList":[item],
        "ShopID": this.shop_id
      },
      { headers: this.header_token})

      if (!this.invoice_print || typeof this.invoice_print !== 'object') {
        
        this.invoice_print = {
          ShopID: this.shop_id,
          invorder: [],
          titleprint_main: null,
          titleprint_secondary: null,
          date: new Date().toISOString().substr(0, 10),
          type: null,
          billNo: null
        }
        
      } else {
        // ถ้ามีอยู่แล้ว แค่ล้าง invorder ก่อนใช้งานใหม่
        this.invoice_print.invorder = []
      }
      // this.invoice_print.invorder = []
      for (var i=0; i<response.data.length; i++ ) {
        var splitedText=response.data[i]['dateString'].split('-')
        this.invoice_print.invorder.push(
        {
          "orderId":response.data[i]['orderMasterID'],
          "invoiceNo":response.data[i]['invoiceNo'],
          "dateString":response.data[i]['dateString'],
          "date": splitedText[2]+'-'+splitedText[1]+'-'+splitedText[0],
          "startDateMenu":false,
        })
      }
      var tiltleMain = null
      var titleSecondary = null
      var billNo = null
      if (this.printDocument.value == 1) {
        tiltleMain = {'text': this.use_language.quotation, 'value': 6}
        titleSecondary = {'text': this.use_language.please_select_, 'value': 0}
        billNo = this.detail_order.quotationNumber != null && this.detail_order.quotationNumber != '' ? this.detail_order.quotationNumber : this.format_order_id(this.OrderMaster.ID)
      } else if (this.printDocument.value == 2) {
        tiltleMain = {'text': this.use_language.receipt, 'value': 1}
        titleSecondary = {'text': this.use_language.tax_invoice, 'value': 2}
        billNo = this.detail_order.invoiceNo
      } else if (this.printDocument.value == 3) {
        tiltleMain = {'text': this.use_language.receipt, 'value': 1}
        titleSecondary = {'text': this.use_language.please_select_, 'value': 0}
      } else if (this.printDocument.value == 4) {
        tiltleMain = {'text': this.use_language.menu_delivery_note, 'value': 7}
        titleSecondary = {'text': this.use_language.please_select_, 'value': 0}
      }
      const today = new Date();
      const date = today.getFullYear()+'-'+(this.set_zero(today.getMonth()+1))+'-'+this.set_zero(today.getDate());
      this.invoice_print.date = date
      // this.invoice_print.titleprint_main = {'text':"ใบเสร็จรับเงิน",'value':1}
      // this.invoice_print.titleprint_secondary = {'text':"ใบกำกับภาษี",'value':2}
      this.invoice_print.titleprint_main = tiltleMain
      this.invoice_print.titleprint_secondary = titleSecondary
      this.invoice_print.type = this.printDocument.value
      this.invoice_print.billNo = billNo

      localStorage.setItem('INVPrint',  JSON.stringify(this.invoice_print))
      localStorage.setItem('Sizepage',  this.sizepage)
      window.open('/print-tax-invoice');
        
    },
    
    set_format_date_time(val) {
      if (val != null) {
        var date_tmp = val.substring(0, 10)
        const date_split = date_tmp.split('-');
        var time_tmp = val.substring(11, 19)
        var set_dattime = date_split[2] + '-' + date_split[1] + '-' + date_split[0] + ' ' + time_tmp
        return set_dattime
      } else {
        return ""
      }
    },

    bank_id_to_text(id) {
      for (var e = 0; e < this.cod_bank_data.length; e++) {
        if (this.cod_bank_data[e]['ID'] == id) {
          return this.cod_bank_data[e]['text']
        }
      }
    },




    approvePaymentAlert(payment_id) {
      this.$swal({
        position: "top", type: 'warning', title: this.use_language.confirm_approve_transfer + ' !!', confirmButtonText: this.use_language.confirm, cancelButtonText: this.use_language.cancel, showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', allowOutsideClick: false
      }).then(async (result) => { if (result.value) { this.ApprovePayment(payment_id) } })
    },

    async ApprovePayment(payment_id) {
      try {
        this.loading = true
        let response = await axios.post(orderService_dotnet + 'Order/detail-order-approv-order-payment', {
          "paymentID": payment_id,
          "orderMasterID": this.OrderMaster.ID,
          "staffShopID": this.StaffShopID
        }, { headers: this.header_token })

        if (response.data.status) {

          this.ShowDetailOrder_tmp(this.OrderMaster.ID)
        }
        this.loading = false
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "detail-order-approv-order-payment " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }
    },

    rejectPaymentAlert(payment_id) {
      this.$swal({
        position: "top", type: 'warning', title: this.use_language.confirm_reject_transfer + ' !!', confirmButtonText: this.use_language.confirm, cancelButtonText: this.use_language.cancel, showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', allowOutsideClick: false
      }).then(async (result) => { if (result.value) { this.RejectPayment(payment_id) } })
    },

    async RejectPayment(payment_id) {
      try {
        this.loading = true
        let response = await axios.post(orderService_dotnet + 'Order/detail-order-reject-order-payment', {
          "paymentID": payment_id,
          "orderMasterID": this.OrderMaster.ID,
          "staffShopID": this.StaffShopID
        }, { headers: this.header_token })

        if (response.data.status) {

          this.ShowDetailOrder_tmp(this.OrderMaster.ID)
        }
        this.loading = false
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "detail-order-reject-order-payment " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }

    },

    async backStatusOrderToOpen() {
      try {
        this.loading = true
        let response = await axios.post(orderService_dotnet + 'Order/detail-order-back-status-order-to-open', {
          "orderMasterID": this.OrderMaster.ID,
          "staffShopID": this.StaffShopID
        }, { headers: this.header_token })

        if (response.data.status) {

          this.ShowDetailOrder_tmp(this.OrderMaster.ID)
        }
        this.loading = false
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "detail-order-back-status-order-to-open " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }
    },
    async LoadDataEditAddress(){
      await this.LoadCountry();
      this.addShipping={
        id: this.customerAddress_selected.id,
        name:this.customerAddress_selected.name,
        phone:this.customerAddress_selected.phone,
        countryID:this.customerAddress_selected.countryID,
         
        city:this.customerAddress_selected.city,
        postcode:this.customerAddress_selected.postcode,
        address:this.customerAddress_selected.address,
        isDefault:this.customerAddress_selected.isDefault
      };
      if(this.customerAddress_selected.postcodeMappingID!=null){
        this.countryCodeSelected=this.countryCode.filter(i => i.id == 172)[0]
        this.addShipping.postcodeMappingID = this.postcode_mapping.filter(i => i.id == this.customerAddress_selected.postcodeMappingID)[0]
      }else{
        this.countryCodeSelected=this.countryCode.filter(i => i.id == this.customerAddress_selected.countryID)[0]
      }
     

    },
    async OpenAddShippingAddress(){
      await this.LoadCountry(); 
     
    },
    async LoadCountry(){
      if(this.countryCode.length!=0){
        return;
      }
      try {
        this.loading = true
        let response = await axios.get(shopService_dotnet + 'Customer/get-country', 
           { headers: this.header_token })
      
        this.countryCode = response.data;
      
        
        this.loading = false
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "get country code " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }
    },
    async getWarehouseList(){
      if(this.Warehouse_List.length > 0){
        return;
      }

      var response = await axios.post(shopService_dotnet + 'Shop/get-warehouse-list',{'shopID':this.shop_id}, { headers: this.header_token })
      this.Warehouse_List=response.data; 
      
      if(this.detail_order.warehouseID){
        let selected=this.Warehouse_List.filter(i => i.id == this.detail_order.warehouseID);
        if(selected.length > 0){
          this.Warehouse_List_selected=selected[0]
        }
      }
      
    },
    async ClickEditWarehouse(){
      this.can_edit_warehouse = !this.can_edit_warehouse;
      if(!this.can_edit_warehouse){
        return;
      }
      await this.getWarehouseList();
      
    },
    async ClickEditOrderDetail(){
      this.can_edit_b2b = !this.can_edit_b2b;
      if(!this.can_edit_b2b){
        return;
      }

      this.ExpressUniqueID = (this.detail_order.branchExpressID == null ? "0" : this.detail_order.branchExpressID.toString())
          + "_" + (this.detail_order.shopExpressID == null ? "0" : this.detail_order.shopExpressID.toString())
          + "_" + (this.detail_order.expressCompanyID == null ? "0" : this.detail_order.expressCompanyID.toString());

      var shipId = this.detail_order.shippingStatusID <= 20 ? 10 : (this.detail_order.shippingStatusID >= 30 && this.detail_order.shippingStatusID <= 60) ? 30 : this.detail_order.shippingStatusID
      this.express_selected=null
      this.select_order_type = this.orderTypeList.filter(i => i.value == shipId)[0]
      this.txt_quotationNumber = this.detail_order.quotationNumber
      this.txt_invoiceNo = this.detail_order.invoiceNo
      this.txt_referenceNumber = this.detail_order.referenceNumber;
      this.dt_due_delivery_date = this.detail_order.dueDeliveryDate != null ? this.detail_order.dueDeliveryDate.substr(0, 10) : null
      this.dt_due_sale_date = this.detail_order.confirmedOrderDate != null ? this.detail_order.confirmedOrderDate.substr(0, 10) : null

      var getChannel_Task= this.getChannelList();
      var getStaff_task = this.getStaffShop();
      var getShippingAddressList_task = this.getShippingAddressList();
      var getShopExpressData_task = this.getShopExpress();
      await getChannel_Task;
      await getStaff_task;
      await getShippingAddressList_task; 
      await getShopExpressData_task;
    },
    async getShippingAddressList() {
      this.customerAddressList = []
      this.customerAddress_selected = null

      this.customerAddressInvoiceList = []
      this.customerAddressInvoice_selected = null

      if(this.detail_order.shopCustomerID == null) {
       
        return
      }
      let response = await axios.post(
        shopService_dotnet + 'Customer/get-customer-info', 
        { 'ShopCustomerID': this.detail_order.shopCustomerID },
        { headers: this.header_token }
      );

 
     
      this.customerAddressList = response.data.shippingAddressList;

      this.customerAddressList.forEach(element => {
        element.text= element.name+' '+element.phone+' ' + element.shortAddress
      });
    
      if(this.detail_order.shippingAddressID){
        let selected= this.customerAddressList.filter(i => i.id == this.detail_order.shippingAddressID) 
        if(selected.length > 0){
          this.customerAddress_selected = selected[0]
        }
        else{
          selected = this.customerAddressList.filter(i => i.isDefault == true)
          if(selected.length > 0){
            this.customerAddress_selected = selected[0]
          }
        }
      }
      this.customerAddressInvoiceList = response.data.invoiceAddressList;
      this.customerAddressInvoiceList.forEach(element => {
        element.text= element.name+' '+(element.taxID ? ' ('+element.taxID+')' : '')+' '+element.phone+' ' + element.shortAddress;
      });
      
      if(this.detail_order.shippingAddressInvoiceID){
        let selected= this.customerAddressInvoiceList.filter(i => i.id == this.detail_order.shippingAddressInvoiceID) 
        if(selected.length > 0){
          this.customerAddressInvoice_selected = selected[0]
        }
      }


     
    },
  

    async get_shippingAddress_loadpage(val) {

      try {
        // getshippingAddress
        let res2 = await axios.post(shopService_dotnet + 'Shop/get-shipping-address-list', { "id": val, "isAscending": true },
          { headers: this.header_token })
         

        this.detail_edit_line = res2.data[0].customerLine
        this.detail_edit_fackbook = res2.data[0].customerFacebook
        this.detail_edit_email = res2.data[0].customerEmail

        if (res2.data[0].province) {
          this.detail_order.receiverAddress = res2.data[0].address + ' ' + res2.data[0].subDistrict + ' ' + res2.data[0].district + ' ' + res2.data[0].province + ' ' + res2.data[0].postcode
        } else if (res2.data[0].country) {
          this.detail_order.receiverAddress = res2.data[0].address + (res2.data[0].address2 ? ' ' + res2.data[0].address2 : '') + (res2.data[0].address3 ? ' ' + res2.data[0].address3 : '') + ' ' + res2.data[0].city + ' ' + res2.data[0].country + ' ' + res2.data[0].postcode
        }


        if (this.detail_order.tempAddress == null) {
          this.detail_order.tempAddress = res2.data[0].name + ' ' + res2.data[0].phone + ' ' + this.detail_order.receiverAddress
        }
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "get-shipping-address-list " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }

    },

    async get_shippingAddressInvoice(id) {

      try {
        // get Shipping Address Invoice
        let response = await axios.get(shopService_dotnet + 'Customer/get-customer-invoice-address-by-address-id?InvoiceAddressID=' + id, { headers: this.header_token });
         
        this.detail_order.InvoiceName = response.data.name
        this.detail_order.InvoicePhone = response.data.phone
        this.detail_order.InvoiceAddress = (!response.data.shortAddress? response.data.fullAddress:response.data.shortAddress);
        this.detail_order.InvoiceTaxID = response.data.taxID;
 
      } catch (e) {
        this.$swal({
          position: "top",
          toast: true,
          timer : 1500,
          type: "error",
          title: "get-shipping-address-invoice " + this.use_language.error_occurred_contact + " IT !!",
           
        })
      }

    },
    async get_shippingAddressInvoiceList(ShopCustomerID) {

      try {
        // getshippingAddress
        let response = await axios.get(shopService_dotnet + 'Customer/get-customer-invoice-address-by-customerid?ShopCustomerID=' + ShopCustomerID,  { headers: this.header_token });
         
      
      } catch (e) {
        this.$swal({
          position: "top",
          toast: true,
          timer : 1500,
          type: "error",
          title: "get-shipping-address-invoice-list " + this.use_language.error_occurred_contact + " IT !!",
          
        })
      }

    },

    async get_order_shop_bank_by_id(val) {
      if (val == null || val == 0) {
        return;
      }
      try {
        // getshippingAddress
        let res = await axios.post(orderService_dotnet + 'Order/get-order-shop-bank-by_id', { "shopBankID": val },
          { headers: this.header_token })
        this.detail_BankName = res.data[0].bankNameTH
        this.detail_AccountNumber = res.data[0].accountNumber
        this.detail_AccountName = res.data[0].accountName
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "get-order-shop-bank-by_id " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }

    },
    async GetOrderPayment(OrderID) {
      var response = await axios.post(orderService_dotnet + 'Order/get-order-payment', { 'orderID': OrderID }, { headers: this.header_token });
      this.detailOrderPayment = response.data.items;
      this.detailOrderPayment_temp = JSON.parse(JSON.stringify(response.data.items));

      if (this.detailOrderPayment.length > 1) {
        var sumAmount = this.detailOrderPayment.reduce((partialSum, a) => partialSum + a.amount, 0);
        var sumWithholdingAmount = this.detailOrderPayment.reduce((partialSum, a) => partialSum + a.withholdingAmount, 0);
        this.detailOrderPayment.push({ amount: sumAmount, withholdingAmount: sumWithholdingAmount, id: 0 });
      }

    },
    async GetPackageInfo() {
      await axios.all([
        axios.post(orderService_dotnet + 'Package/get-order-package-info-archive', { 'orderID': this.OrderMaster.ID }, { headers: this.header_token }),
        axios.get(logistic_Service + 'Logistic/get-track-status-archive?OrderMasterID=' + this.OrderMaster.ID, { headers: this.header_token }).catch(() => ({ data: { packages: [] } })),
      ]).then(axios.spread((res_PackageList, res_TrackStatus) => {
        this.orderItemList = res_PackageList.data.orderItemList || [];
        this.orderItemTempList = res_PackageList.data.orderItemTempList || [];
        this.orderItemInvoiceList = res_PackageList.data.orderItemInvoiceList || [];
        this.packageList = res_PackageList.data.packageList || [];

        var trackPackages = (res_TrackStatus && res_TrackStatus.data && res_TrackStatus.data.packages) ? res_TrackStatus.data.packages : [];
        this.packageList.forEach(element => {
          element.itemList = this.orderItemList.filter(packageno => packageno.packageNo == element.packageNo);
          var trackStatusTemp = trackPackages.filter(packageno => packageno.packageNo == element.packageNo);
          if (trackStatusTemp.length > 0) {
            element.trackStatus = trackStatusTemp[0];
          }
        });
        this.packageList.sort((a, b) => a.packageNo - b.packageNo);

        let stockShopIdList = this.orderItemList.map(a => a.stockShopId);

        const duplicates = stockShopIdList.filter((item, index) => stockShopIdList.indexOf(item) !== index)
        if (duplicates.length == 0 && this.packageList.length == 1
          && this.detail_order.shippingStatusID <= 40
          && this.packageList[0].packageStatusID < 80
        ) {
          this.IsAbleToEditOrderItem = true;
        } else {
          this.IsAbleToEditOrderItem = false;
        }

      }));



    },
    async get_orderid_by_token (token) {
      let response = await axios.post(orderService_dotnet+'Order/get-orderid-by-token',{"token": token} , { headers: this.header_token})
      this.order_token = response.data.id
      return this.order_token

    },
    // โหลดรายการ RMA ของ order — เฉพาะ shop ใน whitelist
    async loadRMARequestList(orderID) {
      if (!this.allowedRMAShopIDs.includes(this.shop_id)) return;
      this.rmaLoading = true;
      try {
        let res = await axios.get(
          orderService_dotnet + 'Package/get-rma-request-list?orderID=' + orderID,
          { headers: this.header_token }
        );
        if (res.data && res.data.status === 'success') {
          this.rmaList = res.data.items || [];
        } else {
          this.rmaList = [];
        }
      } catch (e) {
        console.error('Failed to load RMA list', e);
        this.rmaList = [];
      }
      this.rmaLoading = false;
    },

    async ShowDetailOrder_tmp(OrderID) {

      await axios.all([
        
        // โหมด Archive: master/package-info/status-history อ่านจากตาราง *_Archive — ที่เหลือยังอ่าน live ได้
        axios.post(orderService_dotnet + 'Package/get-order-package-info-archive', { 'orderID': OrderID }, { headers: this.header_token }),
        axios.post(orderService_dotnet + 'Order/get-order-payment', { 'orderID': OrderID }, { headers: this.header_token }),
        axios.post(orderService_dotnet + 'Order/get-order-master-archive',{ 'orderID': OrderID }, { headers: this.header_token }),
        axios.post(orderService_dotnet + 'Order/get-order-satus-history-archive', { 'orderID': OrderID }, { headers: this.header_token }), // order_status_history_list
        axios.get(logistic_Service + 'Logistic/get-track-status-archive?OrderMasterID=' + OrderID, { headers: this.header_token }).catch(() => ({ data: { packages: [] } })),
        axios.post(orderService_dotnet + 'Order/get-order-promotion', {'orderMasterID': OrderID }, { headers: this.header_token }),
      ]).then(axios.spread(( res_PackageList, res_OrderPaymentList, res_OrderMasterDict, res_StatusHistory, res_TrackStatus, res_Promotion) => {
        var detail_order = res_OrderMasterDict.data

        this.detail_order = res_OrderMasterDict.data
        this.orderItemList = res_PackageList.data.orderItemList || [];
        this.orderItemTempList = res_PackageList.data.orderItemTempList || [];
        this.orderItemInvoiceList = res_PackageList.data.orderItemInvoiceList || [];
        this.promotion_item = (res_Promotion && res_Promotion.data) ? res_Promotion.data : []

        // โหลดรายการ RMA (เฉพาะ shop ใน whitelist) — fire-and-forget
        this.loadRMARequestList(OrderID);

 
 


        this.promotion_item.forEach(x => {
          const datetimeStart = new Date(x.startDate)
          const datetimeEnd = new Date(x.endDate)
          const datetimeCreate = new Date(x.created)
          const start = this.formateDate(datetimeStart)
          const end = this.formateDate(datetimeEnd)
          const cre = this.formateDate(datetimeCreate)
          x.formattedDateStart = start;
          x.formattedDateEnd = end;
          x.formattedCreated = cre;
        });

        if (this.orderItemInvoiceList == null || this.orderItemInvoiceList.length == 0) {
          this.orderItemInvoice_tmp = this.orderItemList;
        } else {
          this.orderItemInvoice_tmp = this.orderItemInvoiceList
        }
        this.packageList = res_PackageList.data.packageList || [];

        var trackPackages = (res_TrackStatus && res_TrackStatus.data && res_TrackStatus.data.packages) ? res_TrackStatus.data.packages : [];
        this.packageList.forEach(element => {

          element.itemList = this.orderItemList.filter(packageno => packageno.packageNo == element.packageNo);
          var trackStatusTemp = trackPackages.filter(packageno => packageno.packageNo == element.packageNo);
          if (trackStatusTemp.length > 0) {
            element.trackStatus = trackStatusTemp[0];
          }

        });
        this.packageList.sort((a, b) => a.packageNo - b.packageNo);

        let stockShopIdList = this.orderItemList.map(a => a.stockShopId);

        const duplicates = stockShopIdList.filter((item, index) => stockShopIdList.indexOf(item) !== index)
        if (duplicates.length == 0 && this.packageList.length == 1
          && this.detail_order.shippingStatusID <= 40
          && this.packageList[0].packageStatusID < 80
        ) {
          this.IsAbleToEditOrderItem = true;
        } else {
          this.IsAbleToEditOrderItem = false;
        }
        if (res_OrderMasterDict.data.shopID != this.shop_id) {
          window.close();
        }
        this.orderItemList.forEach(item => {
          if (item.serialNumber != null) {
            this.IsHasSerial = true;
          }
        });
        // getshopAddress
        if (this.detail_order.shopAddressID) {
          this.detail_order.senderAddress = this.detail_order.senderAddress + ' ' + this.detail_order.senderSubDistrict + ' ' + this.detail_order.senderDistrict + ' ' + this.detail_order.senderProvince + ' ' + this.detail_order.senderPostcode
          if (this.detail_order.tempSenderAddress == null) {
            this.detail_order.tempSenderAddress = this.detail_order.senderName + ' ' + this.detail_order.senderPhone + ' ' + this.detail_order.senderAddress
          }
        }
        // getshippingAddress
        if (this.detail_order.shippingAddressID) {
          this.get_shippingAddress_loadpage(this.detail_order.shippingAddressID)
        }
        else if(this.detail_order.receiverAddress){
          if(this.platformReferenceSourceID.includes(this.detail_order.platformReferenceSourceID) && !this.detail_order.isSellerOwnFleet){
            this.detail_order.receiverAddress = this.detail_order.receiverAddress
            + (!this.detail_order.receiverSubDistrict? '' : ' ' + this.detail_order.receiverSubDistrict) 
            + (!this.detail_order.receiverDistrict? '' : ' ' + this.detail_order.receiverDistrict)
            + (!this.detail_order.receiverProvince? '' : ' ' + this.detail_order.receiverProvince)
            + (!this.detail_order.receiverPostcode? '' : ' ' + this.detail_order.receiverPostcode);
            if(this.detail_order.shopCustomerID==null){
              this.detail_order.shopCustomerName = this.detail_order.receiverName;
              this.detail_order.shopCustomerPhone = this.detail_order.receiverPhone;
            }
          }else{
            this.detail_order.receiverAddress = "";
            this.detail_order.receiverName   = "";
            this.detail_order.receiverPhone  = "";
          }
        }

        if(this.detail_order.shopCustomerID){
          this.GetShopCustomer(this.detail_order.shopCustomerID)
        }

        if(this.detail_order.shippingAddressInvoiceID){
          this.get_shippingAddressInvoice(this.detail_order.shippingAddressInvoiceID)
        }

        if (this.detail_order.shopBankAccountID != null) {
          this.get_order_shop_bank_by_id(this.detail_order.shopBankAccountID)
        } else {
          this.detail_BankName = null
          this.detail_AccountNumber = null
          this.detail_AccountName = null
        }
        if (this.detail_order.customerType == 2) {
          this.detail_saleType= 'B2B'
        } else {
          this.detail_saleType= 'B2C'
        }
        // if (detail_order.quotationNumber != null && detail_order.confirmedOrderDate == null) {
        //   this.detail_orderType= 'ใบเสนอราคา'
        // } else if(detail_order.invoiceNo != null && detail_order.confirmedOrderDate != null) {
        //   this.detail_orderType= 'ใบสั่งขาย'
        // }else {
        //   this.detail_orderType= '-'
        // }
        if (detail_order.shippingStatusID <= 20) {
          this.detail_orderType= this.use_language.quotation
        } else if(detail_order.shippingStatusID >= 30 && detail_order.shippingStatusID <= 60) {
          this.detail_orderType= this.use_language.sale_order
        } else if (detail_order.shippingStatusID ==  70){
          this.detail_orderType= this.use_language.succeed
        } else if (detail_order.shippingStatusID ==  90){
          this.detail_orderType= this.use_language.cancel
        } else {
          this.detail_orderType= '-'
        }
        if(this.detail_order.isReserveStock !=null){
          if(this.detail_order.isReserveStock){
            this.isReserveQuantity=1;
          }else{
            this.isReserveQuantity=0;
          }
        }
      
   
        
 
    
 

        this.OrderMaster.ID = detail_order['id']
        this.detail_statusId = detail_order['shippingStatusID']
        this.detail_shiping_staus_update_select = detail_order['shippingStatusID']

        this.change_items_status.forEach(element => {
          if (parseInt(detail_order['shippingStatusID']) == element.value) {
            this.detail_shiping_staus_update_select = element;
          }
        });
    
        

        this.detail_parcelStatusId = detail_order['parcelStatusID']
        this.detail_parcelStatusName = detail_order['parcelStatusName']
      
        this.detail_Remark = detail_order['remark']
        this.detail_RemarkCustomer = detail_order['noteForCustomer']
        this.detail_RemarkWarehouse = detail_order['noteForWarehouse']
        this.detail_BoxName = detail_order['boxName']
        this.detail_Weight = detail_order['weight']
        this.detail_Width = detail_order['cubic1']
        this.detail_Long = detail_order['cubic2']
        this.detail_Height = detail_order['cubic3']
        this.detail_BoxPrice = detail_order['boxPrice']
        this.detail_BubblePrice = detail_order['bubblePrice']
        this.detail_OtherServicePrice = detail_order['otherServicePrice']
        this.detail_VrichTransactionFee = detail_order['vrichTransactionFee']
        this.detail_CODPercent = detail_order['codPercent']
        this.detail_CODCharged = detail_order['codCharged']
        this.detail_Discount = detail_order['discount']
        this.detail_RemotePrice = detail_order['remotePrice']
        this.detail_DeliveryPrice = detail_order['deliveryPrice']
        this.detail_PackPrice = detail_order['packPrice']
        this.detail_IsPreOrder = detail_order['isPreOrder']
        this.detail_totalPrice = parseFloat(detail_order['totalPrice'] == null ? 0 : detail_order['totalPrice'])
        this.detail_DeliveryCost = parseFloat(detail_order['deliveryCost'] == null ? 0 : detail_order['deliveryCost'])
        this.vat_percent = detail_order['vatPercent']
        this.textField_deliveryCost = parseFloat(detail_order['deliveryCost'] == null ? 0 : detail_order['deliveryCost'])
        this.select_vatType = detail_order['vatType']
        if (detail_order['vatType'] == null) {
          this.select_vatType = 2
        }
 
        if (detail_order['orderDiscountPercent'] == null) {
          this.select_discountType = '฿'
          this.textField_discount = detail_order['orderDiscount']
        } else {
          this.select_discountType = '%'
          this.textField_discount = detail_order['orderDiscountPercent']
        }

        this.OrderMaster.OrderDiscount = parseFloat(detail_order.orderDiscount == null ? 0 : detail_order.orderDiscount)
        this.OrderMaster.VATAmount = parseFloat(detail_order.vatAmount == null ? 0 : detail_order.vatAmount)
        this.OrderMaster.VATType = this.select_vatType

        // set data tmp
        this.vat_percent_tmp = JSON.parse(JSON.stringify(this.vat_percent))
        this.textField_deliveryCost_tmp = JSON.parse(JSON.stringify(this.textField_deliveryCost))
        this.select_discountType_tmp = JSON.parse(JSON.stringify(this.select_discountType))
        this.textField_discount_tmp = JSON.parse(JSON.stringify(this.textField_discount))
        this.select_vatType_tmp = JSON.parse(JSON.stringify(this.select_vatType))

        this.detail_TrackingNo = detail_order['trackingNo']
        this.get_token = detail_order['token']
        this.detail_IsCOD = detail_order['isCOD']
        this.detail_CustomerType = detail_order['customerType']
        this.detail_CODAmount = detail_order['codAmount']
        this.detail_RealTransferDatetime = detail_order['realTransferDatetime']
        let ct = detail_order['createToken'];
        this.detail_Token = this.customerWebsite + 'purchase-order?id=' + OrderID+(ct == null ? '&t=' + this.get_token :  '&ct=' + ct);
        this.detail_ExpressCompanyID = detail_order['expressCompanyID']
        this.detail_SellerVoucher = detail_order['totalSellerDiscount']
        this.detail_orderTotalAmount = detail_order['orderTotalAmount']
        this.detail_SellerDeliveryDiscount = detail_order['sellerDeliveryDiscount']
        this.detail_PlatformDeliveryDiscount = detail_order['platformDeliveryDiscount']
        this.detail_PlatformVoucher = detail_order['totalPlatformDiscount']
        this.detail_ShopeeCoinDiscount = detail_order['totalShopeeCoinDiscount']
        this.detail_PaymentDiscount = detail_order['paymentDiscount']
        this.detail_BuyerPaidAmount = detail_order['buyerPaidAmount']
        this.detail_isSellerOwnFleet = detail_order['isSellerOwnFleet']
        if(this.detail_order.isSellerOwnFleet == null){
          this.detail_order.isSellerOwnFleet = false;
        }
        this.detail_InsuranceAmount = detail_order['insuranceAmount']

        if (this.detail_isSellerOwnFleet == null) {
          this.detail_isSellerOwnFleet = false;
        }
        if(!this.detail_isSellerOwnFleet){
          this.packageList.forEach(element => {
            if(element.isSellerOwnFleet){
              this.detail_isSellerOwnFleet = element.isSellerOwnFleet
            }
          });
        }
       

        this.ExpressUniqueID = (detail_order.branchExpressID == null ? "0" : detail_order.branchExpressID.toString())
          + "_" + (detail_order.shopExpressID == null ? "0" : detail_order.shopExpressID.toString())
          + "_" + (detail_order.expressCompanyID == null ? "0" : detail_order.expressCompanyID.toString());



        this.detail_StaffName = detail_order['createdByStaffShopName']
        this.detail_SalemanName = detail_order['salemanName']

        this.detail_ShopBankAccountID = detail_order['shopBankAccountID']

        // data shopee 
        this.detail_referenceSourceID = detail_order['referenceSourceID']
        this.detail_ReferenceSourceID = detail_order['referenceSourceID']
        this.detail_ReferenceNumber = detail_order['referenceNumber']
        this.detail_RealReferenceNumber = detail_order['realReferenceNumber']

        this.detail_ChannelSourceLogoPic = detail_order['channelLogo']

        // โหมด Archive: ไม่ดึงสถานะ marketplace แบบสด (check-marketplace-order-by-id อ่าน OrderMaster live
        // → ออเดอร์เก่าไม่มี → 500) และสถานะสดไม่เกี่ยวกับออเดอร์ที่ปิดแล้ว

        if (this.detail_referenceSourceID == 3 || this.detail_referenceSourceID == 4 || this.detail_referenceSourceID == 11) {
          this.AllowChangeOrderStatus = false;
        }
        else {
          if (this.detail_order.isPackhaiWarehouse) {
            if (this.detail_order.shippingStatusID <= 30) {
              this.AllowChangeOrderStatus = true;
            } else {
              this.AllowChangeOrderStatus = false;
            }
          } else {
            this.AllowChangeOrderStatus = true;
          }
        }
     

        // get bank data
        this.get_bank_cod(detail_order)

        if (this.orderItemList.length != 0 || this.orderItemInvoiceList.length != 0) {


          // ถ้ามีสินค้าเป็น set ใช้ข้อมูลจาก order item invoice
          this.IsHaveProductSet = false
          for (var ic = 0; ic < this.orderItemInvoiceList.length; ic++) {
            if (this.orderItemInvoiceList[ic].isProductSet == true) {
              this.IsHaveProductSet = true
              break;
            }
          }


          this.detail_sum_unintPrice_and_DeliveryCost = 0
          for (var i = 0; i < this.orderItemInvoiceList.length; i++) {
            var item_quantity = this.orderItemInvoiceList[i]['quantity'] == null ? 0 : this.orderItemInvoiceList[i]['quantity']
            var item_unitPrice = this.orderItemInvoiceList[i]['unitPrice'] == null ? 0 : this.orderItemInvoiceList[i]['unitPrice']
            this.detail_sum_unintPrice += parseFloat(item_quantity) * parseFloat(item_unitPrice)
          }
          this.detail_sum_unintPrice_and_DeliveryCost = parseFloat(this.detail_sum_unintPrice) + parseFloat(this.detail_DeliveryCost)

          // add data StockList
          
        }

        // get tracking status

        // Select Warehouse
      
       

        //  orderPayment (archive: อาจไม่มี items → default [])
        this.detailOrderPayment = (res_OrderPaymentList.data && res_OrderPaymentList.data.items) ? res_OrderPaymentList.data.items : [];
        this.detailOrderPayment_temp = JSON.parse(JSON.stringify(this.detailOrderPayment));
        if (this.detailOrderPayment.length > 1) {
          var sumAmount = this.detailOrderPayment.reduce((partialSum, a) => partialSum + a.amount, 0);
          var sumWithholdingAmount = this.detailOrderPayment.reduce((partialSum, a) => partialSum + a.withholdingAmount, 0);
          this.detailOrderPayment.push({ amount: sumAmount, withholdingAmount: sumWithholdingAmount, id: 0 });
          
        }

        // data_pic
        this.data_pic = res_OrderMasterDict.data.imagePack

        // order status history
        this.order_status_history_list = res_StatusHistory.data || []
        for (let index = 0; index < this.order_status_history_list.length; index++) {
          if (this.order_status_history_list[index].staffName != null && this.order_status_history_list[index].staffName != "") {
            this.order_status_history_list[index].description = this.order_status_history_list[index].description + " " + "(" + this.order_status_history_list[index].staffName + ")"
          }

        }
      }));
 
      if (this.platformReferenceSourceID.includes(this.detail_referenceSourceID)) {
        this.IsCanEditCOD = false;
      }

    },

    // หมายเหตุ: get_status_order_marketplace ถูกตัดออกจากโหมด archive (ไม่ดึงสถานะ marketplace สด)

    async detail_edit_remark(order_id, type) {
      try {
        var res = null
        this.loading = true

        if (type == 0) {
          if (this.edit_detail_remark == '') { this.edit_detail_remark = '-' }
          let response = await axios.post(
            orderService_dotnet + 'Order/edit-order-remark', 
            { 
              "orderMasterID": this.OrderMaster.ID, 
              "remark": this.edit_detail_remark
            }, 
            { headers: this.header_token }
          )
          res = response
        } else {
          if (this.edit_detail_remarkCustomer == '') { this.edit_detail_remarkCustomer = '-' }
          if (this.edit_detail_remarkWarehouse == '') { this.edit_detail_remarkWarehouse = '-' }
          let response = await axios.post(
            orderService_dotnet + 'Order/edit-order-remark-v2',
            { 
              "orderMasterID": this.OrderMaster.ID, 
              "remark": type == 1 ? this.edit_detail_remarkCustomer : this.edit_detail_remarkWarehouse,
              "type": type
            }, 
            { headers: this.header_token }
          )
          res = response
        } 

        if (res.data.status == "success") {
          this.$swal({
            toast: true,
            timer: 1500,
            showConfirmButton: false,
            position: 'top',
            type: 'success',
            title: this.use_language.edit_remark_success
          })

          this.can_edit_remark = false
          this.can_edit_remarkCustomer = false
          this.can_edit_remarkWarehouse = false
          this.edit_detail_remark = null
          this.edit_detail_remarkCustomer = null
          this.edit_detail_remarkWarehouse = null
          this.ShowDetailOrder_tmp(this.OrderMaster.ID)
          this.loading = false
        } else {
          this.loading = false
          this.$swal({
            type: "warning",
            title: this.use_language.cannot_perform_operation,
            text: res.data.error_description,
          })
        }
        this.loading = false
      } catch (e) {
        this.$swal({
          type: "warning",
          title: this.use_language.error_contact_it,
          text: e.message,
        })
      }
    },

    async shop_change_shipping_status() {
      var isEdit = true
      if (this.detail_shiping_staus_update_select.value == 91) {
        await this.$swal({
          position: "top",
          type: 'warning',
          title: this.use_language.confirm_delete_this_order + ' !!',
          confirmButtonText: this.use_language.confirm,
          cancelButtonText: this.use_language.cancel,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          allowOutsideClick: false
        }).then(async (result) => {
          if (result.value) {
            isEdit = true
          } else {
            isEdit = false
          }
        })
      }

      if (isEdit == true) {
        try {
          this.loading = true
          let response = await axios.post(
            orderService_dotnet + 'Order/change-order-status',
            {
              "orderID": this.OrderMaster.ID,
              "shippingStatusID": this.detail_shiping_staus_update_select.value,
              "staffShopID": this.StaffShopID
            }, { headers: this.header_token })
          if (response.data.status == 'success') {
            this.$swal({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: 'top',
              type: 'success',
              title: this.use_language.save_data_success
            })
            this.ShowDetailOrder_tmp(this.OrderMaster.ID)
            this.loading = false
          } else {
            this.loading = false
          }
        } catch (e) {
          this.$swal({
            position: "top",
            type: "info",
            title: "change-order-status " + this.use_language.error_occurred_contact + " IT !!",
            text: e.message,
          })
        }
      }
    },

    copyTrackingCode() {
      if (this.detail_ExpressCompanyID == 2) {
        window.open('https://th.kerryexpress.com/en/track/?track=' + this.detail_TrackingNo)
      } else if (this.detail_ExpressCompanyID == 3) {
        window.open('https://track.thailandpost.co.th/')
      } else if (this.detail_ExpressCompanyID == 4) {
        window.open('https://track.thailandpost.co.th/')
      } else if (this.detail_ExpressCompanyID == 5) {
        window.open('https://track.thailandpost.co.th/')
      } else if (this.detail_ExpressCompanyID == 6) {
        window.open('https://www.nimexpress.com/web/p/tracking')
      } else if (this.detail_ExpressCompanyID == 10) {
        window.open('https://www.scgexpress.co.th/tracking')
      } else if (this.detail_ExpressCompanyID == 11) {
        window.open('https://www.jtexpress.co.th/index/query/gzquery.html')
      } else if (this.detail_ExpressCompanyID == 12) {
        window.open('https://www.ninjavan.co/th-th/tracking')
      } else if (this.detail_ExpressCompanyID == 13) {
        window.open('https://www.dhl.com/th-th/home/tracking.html')
      }
    },

    image_click(photo_link, mediaType) {
      this.media_type = mediaType
      if (mediaType == 0) {
        this.dialog_photo_link = photo_link
        this.dialog_photo = true
      }
      // else {
      //   this.dialog_photo_link = photo_link.replace("preview", "view")
      // }



    },


 

   
    async get_bank_cod() {
      try {
        this.loading = true
        let res2 = await axios.post(shopService_dotnet + 'Shop/get-shop-bank-list', { "shopID": this.shop_id },
          { headers: this.header_token })
        var bank_list_tmp = []
        this.shop_bank_account = res2.data;
        if (res2.data != null && res2.data.length != 0) {
          for (var i = 0; i < res2.data.length; i++) {
            var back_dict = {
              "ID": res2.data[i]['id'],
              "text": res2.data[i]['fullBankName']
            }
            bank_list_tmp.push(back_dict)
          }
        } else {
          this.cod_bank_data = []
        }

        this.cod_bank_data = bank_list_tmp
        this.loading = false
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "get-shop-bank-list  " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }

    },






    async order_update_iscod_status(type) {
      if (type == 1) {
        var codAmount = null
        var shopBankAccountID = null
        if (this.cod_list_select == 1) {
          if (this.edit_cod_amount == null || this.edit_cod_amount == '') {
            this.$refs.edit_cod_amount.focus()
            return
          } else if (this.edit_cod_bank == null) {
            alert(this.use_language.please_select_bank_warning)
            return
          }
          codAmount = this.edit_cod_amount
          shopBankAccountID = this.edit_cod_bank
        }

        try {
          this.loading = true
          let response = await axios.post(orderService_dotnet + 'Order/detail-order-edit-status-iscod', {
            "orderMasterID": this.OrderMaster.ID,
            "isCOD": this.cod_list_select,
            "codAmount": (codAmount == "" ? 0 : codAmount),
            "shopBankAccountID": shopBankAccountID
          },
            { headers: this.header_token })
          if (response.data.status) {
            this.can_edit_data_cod = false

            this.ShowDetailOrder_tmp(this.OrderMaster.ID)
          }
          this.loading = false
        } catch (e) {
          this.$swal({
            position: "top",
            type: "info",
            title: "detail-order-edit-status-iscod  " + this.use_language.error_occurred_contact + " IT !!",
            text: e.message,
          })
        }
      } else {

        try {
          let cod = this.edit_cod_amount == "" ? "0" : this.edit_cod_amount
          let response2 = await axios.post(orderService_dotnet + 'Order/detail-order-edit-status-iscod', {
            "orderMasterID": this.OrderMaster.ID,
            "isCOD": cod == "0" ? 0 : 1,
            "codAmount": this.edit_cod_amount == "" ? 0 : this.edit_cod_amount,
            "shopBankAccountID": this.detail_ShopBankAccountID
          },
            { headers: this.header_token })
          this.ShowDetailOrder_tmp(this.OrderMaster.ID)
        } catch (e) {
          this.$swal({
            position: "top",
            type: "info",
            title: "detail-order-edit-status-iscod  " + this.use_language.error_occurred_contact + " IT !!",
            text: e.message,
          })
        }
      }

    },

    delete_data_payment_alert(item) {
      this.$swal({

        type: 'question',
        title: this.use_language.confirm_delete_prefix,
        text: this.use_language.elite + ' : ' + item.amount + " " + this.use_language.confirm_delete_suffix,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        allowOutsideClick: false
      }).then(async (result) => {
        if (result.value) {
          await this.delete_data_payment(item)
        }

      })
    },

    async delete_data_payment(item) {
      try {
        this.loading = true
        //  let response = await axios.post(orderService_dotnet+'Order/detail-order-delete-order-payment', {
        //    "id": item.id
        //  },
        //  { headers: this.header_token})
        //  if(response.data.status){

        //    if(item.photoLink != null){
        //      let response2 = await axios.post(generalService_dotnet+'General/delete-file', {
        //        "url": item.photoLink
        //      },
        //      { headers: this.header_token})
        //    }
 
        //  }

        var keepdata = {}
        var axios = require('axios');
        var config = {
          method: 'post',
          url: orderService_dotnet + 'Order/delete-order-payment?id=' + item.id + "&staffShopID=" + this.StaffShopID,
          headers: { 
            'Content-Type': 'application/json', 
            'Authorization': 'Bearer ' + localStorage.getItem('authorization_token') 
          }
        };
        await axios(config)
        .then(function (response) {keepdata = response.data})
        .catch(function (error) {
          this.$swal({
            position: "top",
            type: "info",
            title: "detail-order-delete-order-payment  " + this.use_language.error_occurred_contact + " IT !!",
            text: error.message,
          })
        });
        if (keepdata.status) {
          this.ShowDetailOrder_tmp(this.OrderMaster.ID)
        }
        this.loading = false
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "detail-order-delete-order-payment  " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }

    },


    async get_data_stock_for_edit() {
      await this.getWarehouseList();
      if (this.orderItemInvoiceList.length == 0) {
        this.detailOrderProduct_tmp = [...this.orderItemList]
        this.detailOrderProduct_tmp.forEach(element => {
          element.isProductSet = false;
          element.orderItemID = element.orderItemId;
          element.orderItemInvoiceID=0;
        });
      } else {
    
      
        this.detailOrderProduct_tmp = [...this.orderItemInvoiceList]
          
        this.IsHasItemInvoice = true;
        this.detailOrderProduct_tmp.forEach(element => { 
          element.orderItemInvoiceID = element.id;
          element.orderItemID=0;
        });
      }

      this.vat_percent = JSON.parse(JSON.stringify(this.vat_percent_tmp))
      this.textField_deliveryCost = JSON.parse(JSON.stringify(this.textField_deliveryCost_tmp))
      this.select_discountType = JSON.parse(JSON.stringify(this.select_discountType_tmp))
      this.textField_discount = JSON.parse(JSON.stringify(this.textField_discount_tmp))
      this.select_vatType = JSON.parse(JSON.stringify(this.select_vatType_tmp))

      this.calculateTotalStockPrice()
      this.can_edit_product = true
      // this.dialog_edit_stock = true
    },


    async changePage() {
      if (this.pageLength != 1 && this.pageTemp != this.page) {
        this.offsets = (this.page * this.limits) - this.limits
        this.loading = true
        await this.getSelectProduct(this.limits, this.offsets, this.Popupsearch, this.page, false)
     
        
        if(this.addOrderPopup.Select_Product.length > 0) {
          for (var item_1 of this.addOrderPopup.Select_Product) {
            for (var item_2 of this.addOrderPopup.Data ) {
              if(item_1.productMasterItemID == item_2.productMasterItemID){
                item_2.selectProduct = true
                continue
              }
            }
          }
        }

        this.pageTemp = this.page
      }
    },
    async PopupsearchStock(limits, offsets) {
      if (this.searchStockModelPopup != null) {
        this.Popupsearch = this.searchStockModelPopup.trim()
        this.loading = true
        if (this.Popupsearch.length > 0) {
          this.getSelectProduct(limits, offsets, this.Popupsearch, 1, true)
        } else {
          this.getSelectProduct(limits, offsets, null, 1, true)
        }
      }
    },
    async OpenPopup(limits, offsets) {


      this.loading = true
      this.searchStockModelPopup = null
      this.addOrderPopup.SelectPackage = []
      this.addOrderPopup.Data = [] 
      this.addOrderPopup.loading = false
      this.Popupsearch = null
      this.skipProductMasterItemIDList = []
      for (var i in this.detailOrderProduct_tmp) {
       
        if (this.detailOrderProduct_tmp[i]["productMasterItemId"] != null) {
          this.skipProductMasterItemIDList.push(this.detailOrderProduct_tmp[i]["productMasterItemId"])
        }
        
      }

      this.page = 1
      this.pageTemp = 1
      this.getSelectProduct(limits, offsets, this.searchStockModelPopup, this.page, true)
    },
    async getSelectProduct(limits, offsets, searchstock, page, isNeedResultCount) {
      try {
        this.loading = true
        let keyword = (this.StockSearchType == "ทั้งหมด" ? searchstock : null);
        let name = (this.StockSearchType == "ชื่อ" ? searchstock : null);
        let sku = (this.StockSearchType == "sku" ? searchstock : null);
        let barcode = (this.StockSearchType == "barcode" ? searchstock : null);

        let response = await axios.post(stockService_dotnet + 'Stock/get-stock-list-addorder', {
          "shopID": this.shop_id,
          "keyword": keyword,
          "sku": sku,
          "name": name,
          "barcode": barcode,
          "warehouseID": this.detail_order.warehouseID,
          "isNeedResultCount": isNeedResultCount,
          "isProductSet": (this.StockIsProductSet == "ทั้งหมด" ? null : (this.StockIsProductSet == "สินค้าไม่จัดเซ็ท" ? false : true)),
          "skipProductMasterItemIDList": this.skipProductMasterItemIDList,
          "skip": offsets,
          "take": limits,
        },
          { headers: this.header_token })


        if (response.status == 200) {
          if (isNeedResultCount) {
            this.FindStockPopupResultCount = response.data.resultCount;
          }
          this.pageLength = (Math.ceil(this.FindStockPopupResultCount / this.limits))
          if (this.pageLength <= 0) { this.pageLength = 1 }
          this.page = page
          this.pageTemp = page

          var StockShopID_list = []
          if (this.size == 'xs' || this.size == 'sm') {
            // await this.SetUp_Product()
            // var StockShopID_list = []

            for (var a in response.data.stockList) {

              response.data.stockList[a]['unitPrice'] = response.data.stockList[a]['salePrice']

              if (StockShopID_list.includes(response.data.stockList[a]["id"])) {
                response.data.stockList[a]["selectProduct"] = true
              } else {
                response.data.stockList[a]["selectProduct"] = false
              }

            }
          } else {
            for (var b in response.data.stockList) {

              response.data.stockList[b]['unitPrice'] = response.data.stockList[b]['salePrice']

            }
          }
          this.addOrderPopup.Data = response.data.stockList
           this.addOrderPopup.Data.forEach(element => {
            element.selectProduct = false;
          });
          for (var i in this.addOrderPopup.Select_Product) {
            StockShopID_list.push(this.addOrderPopup.Select_Product[i]["id"])
          }
          this.loading = false
          this.addOrderPopup.Dialog = true
         
          
        } else {
          this.loading = false
          this.$swal({
            position: "top",
            type: "error",
            text: this.use_language.cannot_perform_operation,
          })
        }
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "get-stock-list-addorder  " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }
    },
    ProductSelect(item, index) {
      this.addOrderPopup.Data[index]["selectProduct"] = !item["selectProduct"]
      if(this.addOrderPopup.SelectPackage == null){
        this.addOrderPopup.SelectPackage = []
      } 
      if (item["selectProduct"] == true) { //นำเข้า Select_Product
        this.addOrderPopup.SelectPackage.splice(0, 0, item)
      } else { //นำออก Select_Product
        var data = this.addOrderPopup.SelectPackage
        for (var i in data) {
          if (data[i]["productMasterItemID"] == item["productMasterItemID"]) {
            this.addOrderPopup.SelectPackage.splice(i, 1)
            break
          }
        }
      }
 
      
    },
    ProductPackageSelect(item, index) {
    
      
      
      this.addPackagePopup.Data[index]["selectProduct"] = !item["selectProduct"]
      if(this.addPackagePopup.SelectPackage == null){
        this.addPackagePopup.SelectPackage = []
      } 
      if (item["selectProduct"] == true) { //นำเข้า Select_Product
        this.addPackagePopup.SelectPackage.splice(0, 0, item)
      } else { //นำออก Select_Product
        var data = this.addPackagePopup.SelectPackage
        for (var i in data) {
          if (data[i]["productMasterItemID"] == item["productMasterItemID"]) {
            this.addPackagePopup.SelectPackage.splice(i, 1)
            break
          }
        }
      }
      this.$forceUpdate();
      
    },
  
    async Submit_addOrderPopup() {
      this.addOrderPopup.loading = true
      let itemlist=[]

      
      
      for (let i in this.addOrderPopup.SelectPackage)
      {
        if(this.addOrderPopup.SelectPackage[i].stockShopID==0){
          let thisstock = {
            "stockShopID": 0,
            "productMasterItemID": this.addOrderPopup.SelectPackage[i].productMasterItemID,
            "warehouseID": this.addOrderPopup.SelectPackage[i].warehouseID
          }
          itemlist.push(thisstock);
        }
      }
      if(itemlist.length>0){
        let response = await axios.post(stockService_dotnet+'Stock/add-stockshop', {
          "itemList": itemlist 
        },
        { headers: this.header_token})
      
        if (response.status == 200){ 
          response.data.itemList.forEach(element => {
            let thisproduct= this.addOrderPopup.SelectPackage.find(i=>i.productMasterItemID == element.productMasterItemID);
            thisproduct.stockShopID = element.stockShopID;
          });
        }
      }

      for (var i in this.addOrderPopup.SelectPackage) {
        await this.searchStockModel_push(this.addOrderPopup.SelectPackage[i])
      }
      this.addOrderPopup.loading = false
      this.addOrderPopup.Dialog = false


    },
    async searchStockModel_push(product) {
      if (product != null) {
       
        
        var IsFound = false
        if (product.isProductSet == true || product.isProductSet == 1) {
          for (var i2 = 0; i2 < this.detailOrderProduct_tmp.length; i2++) {
            if ((this.detailOrderProduct_tmp[i2].isProductSet == true || this.detailOrderProduct_tmp[i2].isProductSet == 1) && this.detailOrderProduct_tmp[i2].productMasterItemId == product.productMasterItemID) {
              IsFound = true;
              break;
            }
          }
        } else {
          for (var i1 = 0; i1 < this.detailOrderProduct_tmp.length; i1++) {
            if (this.detailOrderProduct_tmp[i1].stockShopId == product.stockShopID) {
              IsFound = true
              break;
            }
          }
        }

        if (!IsFound) {
          var data_set = {
            "orderItemTempID": null,
            "discount": null,
            "discountPercent": null,
            "productName": product['name'],
            "orderMasterId": this.OrderMaster.ID,
            "photoLink": product['photoLink'],
            "quantity": 1,
            // "stockID": value['ID'],
            "stockShopId": product['stockShopID'],
            "unitPrice": product['unitPrice'],
            "prop1Description": product['prop1Description'],
            "sku": product['sku'],
            "barcode": product['barcode'],
            "prop2Description": product['prop2Description'],
            "id": 0,
            "orderItemId": 0,
            "isProductSet": product['isProductSet'] == 0 ? false : true,
            "productMasterId": product['productMasterId'],
            "productMasterItemId": product['productMasterItemID']
          }
          // this.productList.push(value)
          this.detailOrderProduct_tmp.push(data_set)
          // this.detailOrderProduct_tmp_insert.push(data_set)
    
          
          
          this.calculateTotalStockPrice()
        }
      }
    },

    

    copyToken() {
      // this.detail_Token
      let TokenCodeToCopy = document.querySelector('#testing-code')
      TokenCodeToCopy.setAttribute('type', 'text')    // 不是 hidden 才能複製
      TokenCodeToCopy.select()

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? this.use_language.succeed : this.use_language.fail;
        this.$swal({
          toast: true,
          timer: 1500,
          showConfirmButton: false,
          position: 'top',
          type: 'success',
          title: this.use_language.copied + msg
        })
      } catch (err) {
        this.$swal({
          type: 'warning',
          title: this.use_language.something_went_wrong,
          text: this.use_language.copy_failed,
        })
      }

      /* unselect the range */
      TokenCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },

    set_zero(num) {
      num = parseInt(num)
      if (num < 10) {
        num = '0' + num.toString()
      } else {
        num = num.toString()
      }
      return num
    },

    status_eng_to_thai(test_eng) {
      if (test_eng != null) {
        if (test_eng == 'shipping-from-chinese-shop') {
          return this.use_language.sent_from_chinese_shop
        } else if (test_eng == 'arrive-at-chinese-warehouse') {
          return this.use_language.arrived_china_warehouse
        } else if (test_eng == 'shipping-from-chinese-warehouse') {
          return this.use_language.exported_from_chinese_warehouse
        } else if (test_eng == 'arrive-at-thai-warehouse') {
          return this.use_language.arrived_thai_warehouse
        }
      } else {
        return ''
      }
    },

    openMhaoDialog(MhaoGuidID, mh_line_item_id, row_id, status) {
      var date = new Date().toISOString().substr(0, 10)
      var current = new Date()
      var status_convert = null
      if (status == 'สั่งแล้ว') { status_convert = 2 }
      if (status == 'รอรับสินค้า') { status_convert = 3 }
      if (status == 'สำเร็จ') { status_convert = 4 }
      this.mh_selectStatus = status_convert
      this.MhaoGuidID = MhaoGuidID
      this.row_id = row_id
      this.startDate = date
      this.mh_line_item_id = mh_line_item_id
      this.mhaoDialog = true
      this.time = this.set_zero(current.getHours().toString()) + ':' + this.set_zero(current.getMinutes().toString())

    },


    img_express_return(express_id) {
      if (express_id != null) {
        if (express_id == 1) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/BESTSmallLogo.JPG'
        }
        else if (express_id == 2) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/kerry_ExpressLogo.png'
        }
        else if (express_id == 3) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/EMSSmallLogo.JPG'
        }
        else if (express_id == 4) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/thaipost.jpg'
        }
        else if (express_id == 5) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/thaipost.jpg'
        }
        else if (express_id == 6) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/NimSmallLogo.JPG'
        }
        else if (express_id == 7) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/FlashSmallLogo.JPG'
        }
        else if (express_id == 8) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/shopee.png'
        }
        else if (express_id == 9) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/lazada.png'
        }
        else if (express_id == 10) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/SCGSmallLogo.JPG'
        }
        else if (express_id == 11) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/JandTSmallLogo.png'
        }
        else if (express_id == 12) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/ninjavan_logo.png'
        }
        else if (express_id == 13) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/dhl.PNG'
        }
      } else {
        return null
      }
    },


    open_dialog_update_item_mhao(item) {
      this.dialog_edit_item_mhao = true
      this.edit_item_mhao_id = item['itemId']
      this.edit_item_mhao_quantity = item['Quantity']
      this.edit_item_mhao_unit_price = item['UnitPrice']
    },



    async check_stock_item_product_set(productMasterID, quantity) {
      try {
        let response = await axios.post(stockService_dotnet + 'Stock/check-stock-avalible-in-product-set', {
          "productMasterID": productMasterID,
          "quantity": quantity
        },
          { headers: this.header_token })
        return response.data
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "check-stock-avalible-in-product-set  " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }
    },

    async get_order_master_pic_for_pack(orderID) {
      try {
        let response = await axios.post(orderService_dotnet + 'Order/get-order-master-pic', { "orderID": orderID }, { headers: this.header_token })

        if (response.data != null) {
          for (var item of response.data) {
            if (item.mediaType == 0) {
              this.data_master_pic.push(item)
            } else {
              this.data_master_media.push(item)
            }
          }
        }
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "get-order-master-pic  " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }
    },

    async shop_change_warehouse() {

      try {
        for (var item of this.Warehouse_List) {
          if (this.Warehouse_List_selected.id == item.id) {
            this.detail_order.warehouseID = item.id;
            this.detail_order.warehouseName = item.name;
            
            break;
          }
        }

        this.loading = true
        let response = await axios.post(orderService_dotnet + 'Order/change-warehouse', {
          "orderMasterID": this.OrderMaster.ID,
          "warehouseID": this.detail_order.warehouseID,
        }, { headers: this.header_token })
        this.loading = false
        this.can_edit_warehouse = false
        this.ShowDetailOrder_tmp(this.OrderMaster.ID)
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: "change-warehouse  " + this.use_language.error_occurred_contact + " IT !!",
          text: e.message,
        })
      }

    },
    async get_authorize_staffshop() {
      // โหมดคลังประวัติ = อ่านอย่างเดียว → บังคับไม่มีสิทธิ์แก้ไข (ซ่อนปุ่ม/เมนูแก้ไขที่ gate ด้วย authorize)
      this.authorize = false
    },



    async getSelectPackage(limits, offsets, searchstock, page, isNeedResultCount ) {
      
      try {
        
   
      
        return await axios.post(stockService_dotnet + 'Stock/get-stock-list-addorder', {
          "shopID": this.shop_id,
          "keyword": searchstock,
          "sku": null,
          "name": null,
          "barcode": null,
          "warehouseID": this.detail_order.warehouseID,
          "isNeedResultCount": isNeedResultCount,
          "isProductSet": false,
          "skipProductMasterItemIDList": this.skipProductMasterItemIDList,
          "skip": offsets,
          "take": limits,
        },
          { headers: this.header_token })
          .then(async (res) => {
            return res.data;
          })
          .catch((error) => {
            this.$swal({
              position: "top",
              type: "info",
              title: this.use_language.error_contact_it,
              text: error,
            })
            return false;
          });
      } catch (error) {
        // nothing
        this.$swal({
            position: "top",
            type: "info",
            title: this.use_language.error_contact_it,
            text: error,
          });
      }
    },
    async UpdateSplitPackageForOrderDetailPage(body) {


      return await axios
        .post(
          orderService_dotnet + "Package/split-package-for-order-detail-page", body,
          { headers: this.header_token }
        )
        .then(async (res) => {
          return res.data
        })
        .catch((error) => {
          this.loading = false;
          this.AlertError();
          return false;
        });
    },
    async btnDeletePacked(item, index) {
      try {

        this.packageList[item.packageNo - 1].itemList.splice(index, 1);




        let newObj = this.packageList[item.packageNo - 1].itemList.filter((i) => i !== index)
        if (newObj != null) {
          this.$set(this.packageList[item.packageNo - 1], "itemList", newObj);
        }

        if (this.packageList.length > 1) {


          // หลังจากแยกเสร็จให้ ปรับรูปตาราง
          let sortPackageList = this.packageList.filter(x => x.itemList.length > 0)
          let indexSort = 1;
          for (let sort of sortPackageList) {
            sort.packageNo = indexSort;
            sort.id = sort.id == null ? indexSort : sort.id;
            let setpackageNo = sort.itemList.map(Sort => {
              return { ...Sort, packageNo: indexSort };
            });
            sort.trackStatus = indexSort
            sort.itemList = setpackageNo


            indexSort++;

          }
          this.packageList = sortPackageList


        }
        this.$forceUpdate();
      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: this.use_language.error_contact_it,
          text: e.message,
        })
      }

    },
    async btnSplitPackage(itemList) {

      let cloneItem = [...itemList.select];


      cloneItem.forEach(element => {
        element.moveQuantity = element.quantity;
      });
      this.splitPackageDataSet.dataSet = cloneItem;

      this.splitPackagePopup.dialog = true;
    },
    OpenImportExport(ImportExportMasterID) {
      window.open("transfer-list/update?id=" + btoa(ImportExportMasterID));
    },
    async btnSubmitSplitPackage() {

      let checkQuantityPack = this.splitPackageDataSet.dataSet.filter(c => { return c.quantity < c.moveQuantity || c.moveQuantity == null || c.moveQuantity == "" || c.moveQuantity == 0 })
      if (checkQuantityPack.length > 0) {
        this.alertError(this.use_language.invalid_split_quantity)
        return false
      }
      if (this.splitPackageDataSet.radio == '1' && !this.splitPackageDataSet.moveTo) {
        this.alertError(this.use_language.please_enter_box_to_move)
        return false
      }
      if (this.splitPackageDataSet.radio == '1' && this.splitPackageDataSet.moveTo) {
        // if(this.packageList.length == this.splitPackageDataSet.moveTo ){
        //   this.alertError("ไม่สามารถย้ายใส่กล่องกล่องเดิมได้")
        //   return false
        // }
        if (this.splitPackageDataSet.moveTo == 0) {
          this.alertError(this.use_language.please_enter_valid_box_to_move)
          return false
        }
        if (this.packageList.length < this.splitPackageDataSet.moveTo - 1) {
        
          

          this.splitPackageDataSet.radio = '0'
          // this.splitPackageDataSet.moveTo = this.packageList.length+1
          // this.alertError("ย้ายใส่กล่องไม่ถูกต้อง")
          // return false
        }


      }
      this.splitPackageDataSet.dataSet.forEach(element => {
        element.moveQuantity = parseInt(element.moveQuantity);
      });
      // if (this.splitPackageDataSet.radio == '0') {
      //   var maxPackage = Math.max.apply(Math, this.packageList.map(function (o) { return o.packageNo; })) + 1;
      //   this.moveSplitPackage(this.splitPackageDataSet.dataSet, maxPackage);
      // } else {
      //   this.moveSplitPackage(this.splitPackageDataSet.dataSet, this.splitPackageDataSet.moveTo);
      // }

      let packageToMoveTo = this.splitPackageDataSet.moveTo;
      if (this.splitPackageDataSet.radio == '0') {
        packageToMoveTo = Math.max.apply(Math, this.packageList.map(function (o) { return o.packageNo; })) + 1;
      
      } 
      var checkPackage = this.packageList.find(i=>i.packageNo ==packageToMoveTo );

      if(checkPackage&& checkPackage.packageStatusID>60 && (checkPackage.endPackingDate != null ||checkPackage.packedByStatusMoveDate!=null )){
        this.alertError(this.use_language.parcel_no + " "+packageToMoveTo+" " + this.use_language.packed_cannot_move)
         return false;
      }
      this.moveSplitPackage(this.splitPackageDataSet.dataSet,packageToMoveTo);

    },
    async moveSplitPackage(data, newPackageNo) {
      let backupItems = [];

      if (newPackageNo == null || newPackageNo == '') {
        newPackageNo = Math.max.apply(Math, this.packageList.map(function (o) { return o.packageNo; })) + 1;

      }



      let packageIndex = this.packageList.findIndex(x => x.packageNo == data[0].packageNo);

      for (let item of data) {

        let temp = this.packageList[packageIndex].itemList.find(i => i.stockShopId == item.stockShopId)

        if (temp != undefined) {
          let checkCount = parseInt(temp.quantity) - parseInt(item.moveQuantity)
          if (checkCount == 0) {
            let index = this.packageList[packageIndex].itemList.findIndex(i => i.stockShopId == item.stockShopId);
            let removedItem = this.packageList[packageIndex].itemList.splice(index, 1);
            this.$forceUpdate(this.packageList);
            backupItems.push(...removedItem);
          }
          else {
            let realDiscount=null;
            if(temp.discount!=null && temp.discount!=0){
              let tempDiscount = temp.discount /parseFloat(temp.quantity);
           
              
              temp.discount = tempDiscount * (checkCount);
              realDiscount = tempDiscount * item.moveQuantity;
            }
            temp.quantity = checkCount
          
            let addItem = { ...temp, quantity: temp.moveQuantity,discount: realDiscount}
            backupItems.push(addItem);
          }
        }
      }
      this.$set(this.packageList[packageIndex], 'itemList', [...this.packageList[packageIndex].itemList]);

      this.$set(this.packageList[packageIndex], "select", []);

      let newPackageIndex = 0;
      for (let move of data) {


        newPackageIndex = this.packageList.findIndex(x => x.packageNo == newPackageNo);

        if (newPackageIndex == -1) {
          newPackageIndex = this.packageList.findIndex(x => x.packageNo == newPackageNo);
          var newPackage = { packageNo: newPackageNo, id: 0, itemList: [], trackStatus: [] }
          this.packageList.push(newPackage);
          newPackageIndex = this.packageList.findIndex(x => x.packageNo == newPackageNo);
        }

        let temp = this.packageList[newPackageIndex].itemList.find(i => i.stockShopId == move.stockShopId)
        if (temp == null) {

          let addMove = { ...move, packageNo: newPackageNo, quantity: move.moveQuantity }


          this.packageList[newPackageIndex].itemList.push(addMove)
          this.$set(this.packageList[newPackageIndex], 'itemList', [...this.packageList[newPackageIndex].itemList]);
        }
        else {

          temp.quantity = temp.quantity + move.moveQuantity
        }

      }

      this.$set(this.packageList[newPackageIndex], 'itemList', [...this.packageList[newPackageIndex].itemList]);
      this.$set(this.packageList[newPackageIndex], "select", []);

      if (this.packageList.filter(x => x.itemList.length == 0).length > 0) {
        newPackageNo = 1;
        let sortPackageList = JSON.parse(JSON.stringify(this.packageList.filter(x => x.itemList.length > 0)));

        var index = 0;
        for (let element of sortPackageList) {
          if (element.dueDeliveryDate == undefined) {
            element.dueDeliveryDate = null
          }
          this.packageList[index].itemList = element.itemList
          this.packageList[index].dueDeliveryDate = element.dueDeliveryDate;
          this.packageList[index].packageNo = newPackageNo;
          this.packageList[index].itemList.forEach(element => {
            element.packageNo = newPackageNo;
          });
          newPackageNo++;
          index++;
        }

        if (this.packageList.length > index) {
          this.packageList.splice(index);
        }

      }

      this.splitPackageDataSet.moveTo = null
      this.splitPackageDataSet.radio = '0'
      this.splitPackagePopup.dialog = false;


    },
    async btnEditPackaged() {
      this.loading = true;
      await this.GetPackageInfo();
      this.loading = false;
      var data = this.packageList.map((entry) => {

        entry.showDateMenu = false;
        if (entry.dueDeliveryDate !== null) {

          entry.dueDeliveryDateShow = this.set_format_date_time(entry.dueDeliveryDate).substring(0, 10)
          entry.dueDeliveryDateTemp = entry.dueDeliveryDate.substring(0, 10)

        }

        // อัปเดต packedQuantity ใน itemList
        entry.itemList = entry.itemList.map((item) => ({
          ...item,
          moveQuantity: item.quantity
        }));

        return entry;
      });

      this.can_edit_packaged = true;
    },
    checkSplitBtn(itemList) {

      if (itemList.select && itemList.select.length > 0 && itemList.select != undefined && itemList.packageStatusID<80 && itemList.endPackingDate==null && itemList.packedByStatusMoveDate==null ) {
        // let checkQuantityPack = itemList.select.filter( (item )=> 
        //   {  
        //     return item.quantity < item.packedQuantity 

        //     || item.packedQuantity == null 
        //      ||  item.packedQuantity == ""

        //   }

        // )
        // if(!checkQuantityPack.length == 0 ){ return  true}
        return false;
      }
      return true;
    },
    checkSplitBtn1(itemList) {

      if (  itemList.packageStatusID<80 && itemList.endPackingDate==null && itemList.packedByStatusMoveDate==null) {
        // let checkQuantityPack = itemList.select.filter( (item )=> 
        //   {  
        //     return item.quantity < item.packedQuantity 

        //     || item.packedQuantity == null 
        //      ||  item.packedQuantity == ""

        //   }

        // )
        // if(!checkQuantityPack.length == 0 ){ return  true}
        return false;
      }
      return true;
    },
    async alertError(error_description) {
      Swal.fire({
        text: error_description,
        title: this.use_language.cannot_perform_operation,
        type: "error",
      });
    },
    async alertSuccess(error_description) {
      Swal.fire({
        text: error_description,
        title: this.use_language.transaction_success,
        type: "success",
      });
    },

    async OpenPopupAddPackage(data, limits, offsets) {
      try {


        let ResultCount = 0
        this.loading = true;
        this.addPackagePopup.searchStockModelPopup = null;
        this.addPackagePopup.Select_Product = [];
        this.addPackagePopup.Data = [];
        this.addPackagePopup.ProductIDList = [];
        this.addPackagePopup.loading = false;
 
        this.skipProductMasterItemIDList =data.itemList.map(m => m.productMasterItemId);
        this.addPackagePopup.Popupsearch = null
        
        this.addPackagePopup.page = 1
        this.addPackagePopup.pageTemp = 1
        let response = await this.getSelectPackage(this.addPackagePopup.limits, this.addPackagePopup.offsets, this.addPackagePopup.searchStockModelPopup, this.addPackagePopup.page, true )
     


        if (response.resultCount) {
          ResultCount = response.resultCount;


          this.addPackagePopup.pageLength = (Math.ceil(ResultCount / this.addPackagePopup.limits))

          if (this.addPackagePopup.pageLength <= 0) { this.addPackagePopup.pageLength = 1 }
        }

        this.addPackagePopup.Data = response.stockList

        this.loading = false
        this.addPackagePopup.Dialog = true

      } catch (e) {
        this.$swal({
          position: "top",
          type: "info",
          title: this.use_language.error_contact_it,
          text: e.message,
        })
      }

      


    },
    async btnChangePagePackage() {
      if (this.addPackagePopup.pageLength != 1 && this.addPackagePopup.pageTemp != this.addPackagePopup.page) {
        this.addPackagePopup.offsets = (this.addPackagePopup.page * this.addPackagePopup.limits) - this.addPackagePopup.limits
        this.loading = true
        let response = await this.getSelectPackage(this.addPackagePopup.limits, this.addPackagePopup.offsets, this.addPackagePopup.Popupsearch, this.addPackagePopup.page, false )

        this.addPackagePopup.Data = response.stockList

        this.addPackagePopup.pageTemp = this.addPackagePopup.page
      }
      this.loading = false;
    },
    async btnSubmitAddPackagePopup() {
      this.loading = true


      // this.addPackagePopup.SelectPackage =[ ...
      //   {orderItemId: this.addPackagePopup.SelectPackage.id,
      //   productName : this.addPackagePopup.SelectPackage.name,
      //   packageNo : this.packageNo,
      //   packedQuantity:null,
      //   quantity:1,}
      //   ]
      // this.addPackagePopup.SelectPackage.orderItemId = this.addPackagePopup.SelectPackage.id

      // this.addPackagePopup.SelectPackage.productName = this.addPackagePopup.SelectPackage.name
      // this.addPackagePopup.SelectPackage.packageNo = this.packageNo
      // this.addPackagePopup.SelectPackage.packedQuantity = null
      // this.addPackagePopup.SelectPackage.quantity = 1
      let itemlist =[];
      for (let i in this.addPackagePopup.SelectPackage)
      {
        if(this.addPackagePopup.SelectPackage[i].stockShopID==0){
          let thisstock = {
            "stockShopID": 0,
            "productMasterItemID": this.addPackagePopup.SelectPackage[i].productMasterItemID,
            "warehouseID": this.addPackagePopup.SelectPackage[i].warehouseID
          }
          itemlist.push(thisstock);
        }
      }

      if(itemlist.length>0){
        let response = await axios.post(stockService_dotnet+'Stock/add-stockshop', {
          "itemList": itemlist 
        },
        { headers: this.header_token})
      
        if (response.status == 200){

          response.data.itemList.forEach(element => {
            let thisproduct= this.addPackagePopup.SelectPackage.find(i=>i.productMasterItemID == element.productMasterItemID);
            thisproduct.stockShopID = element.stockShopID;
          });
        }
      }

      let transformedItems = this.addPackagePopup.SelectPackage.map((item) => {

        return {
          ...item,
          orderItemId:0,
          stockShopId: item.stockShopID || 0,
          productName: item.name || '',
          packageNo: this.packageNo || 0,
          packedQuantity: null,
          quantity: item.packedQuantity == undefined ? 1 : item.packedQuantity,
          productMasterItemId : item.productMasterItemID 
        };
      });

      // เพิ่มรายการที่แปลงแล้วไปใน packageList
      // this.packageList[this.packageNo-1].itemList.push(...transformedItems)

      // let newList = this.packageList[this.packageNo - 1].itemList

      transformedItems.push(...this.packageList[this.packageNo - 1].itemList)

   
      

    
      


      this.$set(this.packageList[this.packageNo - 1], 'itemList', transformedItems);

          

      // this.$set(this.packageList[item.packageNo - 1],"itemList", newObj);   

      this.$forceUpdate();
      this.addPackagePopup.SelectPackage = []
      this.loading = false
      this.addPackagePopup.Dialog = false


    },
    async btnSearchPackagek(limits, offsets) {
      let response = []
      let ResultCount = 0
 

      if (this.addPackagePopup.searchStockModelPopup != null) {
        this.addPackagePopup.Popupsearch = this.addPackagePopup.searchStockModelPopup.trim()
        this.loading = true
        if (this.addPackagePopup.Popupsearch.length > 0) {
          response = await this.getSelectPackage(limits, offsets, this.addPackagePopup.Popupsearch, 1, true )
        } else {
          response = await this.getSelectPackage(limits, offsets, null, 1, true )
        }
        if (response.resultCount) {
          ResultCount = response.resultCount;


          this.addPackagePopup.pageLength = (Math.ceil(ResultCount / this.addPackagePopup.limits))

          if (this.addPackagePopup.pageLength <= 0) { this.addPackagePopup.pageLength = 1 }
        }

        this.addPackagePopup.Data = response.stockList
        this.loading = false
      }


      this.loading = false;
    },

    async btnSaveChangePackage() {
      let body = {
        "orderMasterID": this.OrderMaster.ID,
        "staffShopID": this.StaffShopID,
        "staffBranchID": this.staffBranchID,
        "packages": []
      };


      for (let packageData of this.packageList) {
        // สร้าง packagesBody เป็น object 
        packageData.dueDeliveryDate = packageData.dueDeliveryDateTemp;
        let packagesBody = {
          packageNo: packageData.packageNo,
          dueDeliveryDate: packageData.dueDeliveryDateTemp,
          items: packageData.itemList.map(item => ({
            orderItemID : item.orderItemId,
            stockShopID: item.stockShopId, 
            quantity: item.quantity,
            unitPrice:item.unitPrice,
            itemDiscount : item.itemDiscount,
            sellerDiscount : item.sellerDiscount,
            platformDiscount : item.platformDiscount,
            discount : item.discount,
          }))
        };

        // เพิ่ม packagesBody ลงใน body.packages
        body.packages.push(packagesBody);
      }




      // เรียกใช้ฟังก์ชัน API หรือการอัปเดตข้อมูล
      let res = await this.UpdateSplitPackageForOrderDetailPage(body);
      if (res.status == "success") {
        this.alertSuccess();
        this.can_edit_packaged = false
        //await this.GetPackageInfo();
      } else {
        this.alertError(res.error_description)
      }


    },
    async btnSavePayment() {
      if (this.input_transferAmount == null || this.input_transferAmount == '' || this.input_transferAmount == '0') {
        this.$refs.input_transferAmount.focus()
        this.$swal({
          type: "warning",
          text: this.use_language.please_specify_amount,
        })
        return
      }
      if (parseInt(this.input_transferStatusID) < 4) {
        if (this.select_dueDate == null) {
          this.$swal({
            type: "warning",
            text: this.use_language.please_specify_due_date,
          })
          return
        }
        else {
          this.select_transferDate = null;
          this.paymentBank = null;
        }

      }
      if (parseInt(this.input_transferStatusID) == 4) {
        if (this.select_transferDate == null) {
          this.$swal({
            type: "warning",
            text: this.use_language.please_specify_actual_payment_date,
          })
          return
        }
      }
      if (this.input_transferFileUpload) {
        let resUpload = await this.UploadFile(this.input_transferFileUpload)
        if (resUpload.status == "success") {
          this.input_transferPhotoLink = resUpload.file_path
        } else {
          this.alertStop();
        }
      }
      var transfer_date = null;
      var due_date = null;
      if (this.select_transferDate !== null) {
        let hours = this.select_transferHour ?? "00"
        let Minute = this.select_transferMinute ?? "00"
        transfer_date = this.select_transferDate + "T" + hours + ":" + Minute + ":00"
      }
      if (this.select_dueDate) {
        due_date = this.select_dueDate;
      }
      var transferWithholdingAmount = null
      if (this.input_transferWithholdingAmount != '' && this.input_transferWithholdingAmount != 0) {
        transferWithholdingAmount = this.input_transferWithholdingAmount
      }

      // var data_list_payment = []
      var payment_data = {
        "id": this.input_transferId == null ? 0 : this.input_transferId,
        "orderMasterId": this.OrderMaster.ID,
        "shopCustomerID": (this.paymentBank == null ? null : (this.paymentBank.id == -1 ? this.currentShopCustomerID : null)),
        "bankAccountID": (this.paymentBank == null || this.paymentBank.id == -1 ? null : this.paymentBank.id),
        "amount": parseFloat(Number(this.input_transferAmount).toFixed(2)),
        "withholdingAmount": parseFloat(Number(transferWithholdingAmount).toFixed(2)),
        "photoLink": this.input_transferPhotoLink,
        "informDatetime": transfer_date,
        "dueDate": due_date,
        "staffShopID": this.StaffShopID,
        "statusID": parseInt(this.input_transferStatusID),
        "remark": this.input_transferRemark,
        "orderTypeID": this.detail_saleType == 'B2B' ? 2 : null
      }
      this.loading = true;
      let resUPdate = await this.updateOrderPayment(payment_data);

      if (resUPdate.status == "success") {
        // เคลียข้อมูล
        this.edit_cod_bank = null
        this.input_transferFileUpload = null
        this.input_transferAmount = null
        this.input_transferWithholdingAmount = null
        this.select_transferDate = null
        this.select_transferHour = null
        this.select_transferMinute = null

        this.btnClosePayment();
        this.GetOrderPayment(this.OrderMaster.ID)

      }
      this.loading = false;

    },
    async GetProfitDetail(OrderID) {
      await axios.all([
        axios.get(orderService_dotnet + 'Order/get-profit-report-detail?OrderMasterID=' + OrderID, { headers: this.header_token }),
      ]).then(axios.spread((res_OrderProfit) => {

        this.orderProfitList = res_OrderProfit.data.orderItems;
        this.orderProfitSum = res_OrderProfit.data.detailTable;
        this.orderItemProfit_tmp = this.orderProfitList;
        this.orderProfit_tmp = this.orderProfitSum;
        this.purchaseOrder_item = res_OrderProfit.data.purchaseOrder;


        if (res_OrderProfit.data.orderItemInvoices.length != 0) {
          var index = 0;
          this.profitSection_OrderItemInvoice = res_OrderProfit.data.orderItems;
          res_OrderProfit.data.orderItems.forEach(element => {

            element.lotData.forEach(item => {
              this.profitSection_OrderItemLot.push(item);
              this.profitSection_OrderItemLot[index].barcode = element.barcode;
              this.profitSection_OrderItemLot[index].photoLink = element.photoLink;
              this.profitSection_OrderItemLot[index].productCode = element.productCode;
              this.profitSection_OrderItemLot[index].productName = element.productName;
              this.profitSection_OrderItemLot[index].prop1Description = element.prop1Description;
              this.profitSection_OrderItemLot[index].prop2Description = element.prop2Description;
              this.profitSection_OrderItemLot[index].sku = element.sku;
              index++;
            });

          });
        }

      }));
    },
    async btnOpenAddSlip() {
      this.currentShopCustomerID = null;
      let shopcustomer = await axios.get(orderService_dotnet + 'Order/get-shop-customer-by-orderid?OrderID=' + this.OrderMaster.ID, { headers: this.header_token });
      this.currentShopCustomerID = shopcustomer.data.id;

      this.select_transferDate = null
      this.select_transferHour = null
      this.select_transferMinute = null
      this.select_dueDate = null;
      this.input_transferStatusID = "2";
      this.shop_bank_account_to_show = JSON.parse(JSON.stringify(this.shop_bank_account));

      var sumAmount = this.detailOrderPayment_temp.reduce((partialSum, a) => partialSum + a.amount, 0);

      if (shopcustomer.data.balance >= parseFloat(this.detail_orderTotalAmount) - sumAmount) {
        var bank_balance1 = { id: -1, fullBankName: "Balance" };
        this.shop_bank_account_to_show.push(bank_balance1);
      }
      this.input_transferAmount = parseFloat(this.detail_orderTotalAmount) - sumAmount
      this.input_transferWithholdingAmount
      this.input_transferId = 0;
      this.input_transferFileUpload = null
      this.input_transferPhotoLink = null
      this.input_transferRemark = null
      this.dialog_add_slip = true;
    },
    async btnEditPayment(data) {
      this.currentShopCustomerID = null;
      let shopcustomer = await axios.get(orderService_dotnet + 'Order/get-shop-customer-by-orderid?OrderID=' + data.orderMasterId, { headers: this.header_token });
      this.currentShopCustomerID = shopcustomer.data.id;

      if (data.informDatetime) {
        let date = data.informDatetime.substr(0, 10);
        let hours = moment(data.informDatetime, "YYYY-MM-DDTHH:mm:ss.SS").format("HH");
        let minute = moment(data.informDatetime, "YYYY-MM-DDTHH:mm:ss.SS").format("mm");


        this.select_transferDate = date
        this.select_transferHour = hours
        this.select_transferMinute = minute
      }

      if (data.dueDate) {
        let date1 = data.dueDate.substr(0, 10);
        this.select_dueDate = date1
      } else {
        this.select_dueDate = null;
      }

      this.shop_bank_account_to_show = JSON.parse(JSON.stringify(this.shop_bank_account));

      if (data.bankAccountText == "Balance") {
        var bank_balance = { id: -1, fullBankName: "Balance" };
        this.shop_bank_account_to_show.push(bank_balance);
        this.paymentBank = bank_balance;
        this.currentShopCustomerID = data.shopCustomerID;
      }
      else {
        let bankAccountID = this.shop_bank_account.filter(b => b.id == data.bankAccountID)


        if (bankAccountID.length > 0)
          this.paymentBank = bankAccountID[0];
        else
          this.paymentBank = null

        if (shopcustomer.data.balance >= data.amount) {
          var bank_balance1 = { id: -1, fullBankName: "Balance" };
          this.shop_bank_account_to_show.push(bank_balance1);
        }


      }
      this.input_transferId = data.id
      this.input_transferStatusID = data.statusID.toString();
      this.input_transferFileUpload = null
      this.input_transferPhotoLink = data.photoLink
      this.input_transferAmount = data.amount
      this.input_transferWithholdingAmount = data.withholdingAmount
      this.input_transferRemark = data.remark
      this.dialog_add_slip = true
    },
    async btnClosePayment() {
      this.input_transferFileUpload = null
      this.input_transferPhotoLink = null;
      this.input_transferAmount = null
      this.input_transferWithholdingAmount = null
      this.input_transferDueDate = null
      this.input_transferStatusID = "2"
      this.select_transferDate = null
      this.select_dueDate = null
      this.select_transferHour = null
      this.select_transferMinute = null
      this.input_transferId = 0
      this.input_transferRemark = null;
      this.paymentBank = null;

      this.dialog_add_slip = false
    },
    async UploadFile(files) {
      let bodyUploadFile = [];


      var from_data = new FormData();
      from_data.append("bucket", "Doc_file");
      from_data.append("file", files);
      bodyUploadFile = from_data;

      return await axios
        .post(
          generalService_dotnet + "General/upload-file-with-bucket",
          bodyUploadFile,
          { headers: this.header_token }
        )
        .then(async (res) => {
          return res.data
        })
        .catch((error) => {
          this.loading = false;
          this.AlertError();
          return false;
        });
    },
    async updateOrderPayment(body) {
      this.loading = true;
      return await axios
        .post(
          orderService_dotnet + "Order/update-order-payment",
          body,
          { headers: this.header_token }
        )
        .then(async (res) => {
          this.loading = false;
          return res.data
        })
        .catch((error) => {
          this.loading = false;
          this.AlertError();
          return false;
        });
    },

    formatDateTimeToISO(dateTime) {
      return moment(dateTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DDTHH:mm:ss.SS");
    },
    formatDateTimeToThai(pack) {
      pack.showDateMenu = false;
      if (!pack.dueDeliveryDateTemp) return null
      const [year, month, day] = pack.dueDeliveryDateTemp.split('-')
      return `${day}-${month}-${year}`
    },
    OpenEditBoxDialog(item) {
      
      this.update_data_pack = {
        id: item.id,
        packageNo: item.packageNo,
        boxName: item.boxName,
        weight: item.weight,
        cubic1: item.cubic1,
        cubic2: item.cubic2,
        cubic3: item.cubic3,
        boxPrice: item.boxPrice,
        packPrice: item.packPrice,
        remotePrice: item.remotePrice,
        deliveryPrice: item.deliveryPrice,
        codPercent: item.codPercent,
        codCharged: item.codCharged,
        discount: item.discount,
        branchBoxCost: item.branchBoxCost,
        branchDeliveryCost: item.branchDeliveryCost,
        BranchCODChargedCost: item.BranchCODChargedCost,
        expressCompanyID: item.expressCompanyID,
        expressCompanyLogo: item.expressCompanyLogo,
        expressCompanyName: item.expressCompanyName,
        trackingNo: item.trackingNo,
        isSellerOwnFleet: item.isSellerOwnFleet,
        referenceSourceID: item.referenceSourceID,
        branchExpressID: item.branchExpressID,
        shopExpressID: item.shopExpressID,
        shopExpressList: item.shopExpressList,
        shopExpressSelected: item.shopExpressSelected,
        isPackhaiWarehouse:item.isPackhaiWarehouse
      };


      this.edit_box_dialog = true;
    },
    async update_data_pack_function() {
      try {
        this.loading = true;
        if (this.update_data_pack.shopExpressSelected != null) {
          this.update_data_pack.expressCompanyID = this.update_data_pack.shopExpressSelected.expressCompanyID;
          this.update_data_pack.branchExpressID = this.update_data_pack.shopExpressSelected.branchExpressID;
          this.update_data_pack.shopExpressID = this.update_data_pack.shopExpressSelected.shopExpressID
        }
        let response = await axios.post(
          orderService_dotnet + "Order/update-data-pack",
          {
            orderMasterId: this.OrderMaster.ID,
            packageId: this.update_data_pack.id,
            boxName: this.update_data_pack.boxName,
            weight: this.update_data_pack.weight,
            cubic1: this.update_data_pack.cubic1,
            cubic2: this.update_data_pack.cubic2,
            cubic3: this.update_data_pack.cubic3,
            boxPrice: this.update_data_pack.boxPrice,
            packPrice: this.update_data_pack.packPrice,
            deliveryPrice: this.update_data_pack.deliveryPrice,
            codPercent: this.update_data_pack.codPercent,
            codCharged: this.update_data_pack.codCharged,
            remotePrice: this.update_data_pack.remotePrice,
            discount: this.update_data_pack.discount,
            branchBoxCost: this.update_data_pack.branchBoxCost,
            branchCODChargedCost: this.update_data_pack.branchCODChargedCost,
            branchDeliveryCost: this.update_data_pack.branchDeliveryCost,
            expressCompanyID: this.update_data_pack.expressCompanyID,
            trackingNo: this.update_data_pack.trackingNo,
            branchExpressID: this.update_data_pack.branchExpressID,
            shopExpressID: this.update_data_pack.shopExpressID
          },
          { headers: this.header_token }
        );
        this.loading = false;
        this.edit_box_dialog = false;
        this.GetPackageInfo();
        Swal.fire({
          position: "top",
          timer: 1500,
          icon: "success",
          text: this.use_language.save_complete,
          toast: true
        });
      } catch (e) {
        this.loading = false;
        Swal.fire({
          position: "top",
          icon: "error",
          text: e.message,
        });
      }
    },
    SeeTabDetails(id) {

      this.tab = id;
    },
    editPurchase(id) {
      window.open("addExpense?id=" + id);
    },
    OpenPromotion(item)
    {
      window.open("promotion/update?id=" + item.promotionID); 
    },
    formateDate(date) {
      var year= date.getFullYear()
      var month= date.getMonth() + 1
      var day= date.getDate()
      var hours= date.getHours()
      var minutes= date.getMinutes().toString().padStart(2, '0')
      var second= date.getSeconds().toString().padStart(2, '0')
      const dateformat = `${day}/${month}/${year} ${hours}:${minutes}:${second}`
      return dateformat
    },
    formatDate_1 (date) {
      if (date == null){
        return null
      } else {
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      }
    },
    set_data_address_invoice_postcodeMappingId () {
      if(this.select_address_invoice_postcodeMapping  != null){
        this.address_invoice.postcodeMappingId = this.select_address_invoice_postcodeMapping.id;
        this.address_invoice.postcode = this.select_address_invoice_postcodeMapping.postcode;
        this.address_invoice.province = this.select_address_invoice_postcodeMapping.province;
        this.address_invoice.district = this.select_address_invoice_postcodeMapping.district;
        this.address_invoice.subDistrict = this.select_address_invoice_postcodeMapping.subDistrict;
      }
    },
  }
}
</script>
<style scoped>
/* >>>.v-dialog {
      -webkit-box-shadow: none;
      box-shadow: none;
  } */
.data-table-select-column {
  display: inline-block;
  width: 2px;
  text-align: center;

}

>>>.v-autocomplete.v-select--is-menu-active .v-input__icon--append .v-icon {
  transform: none;
}

>>>.bex48-logo {
  width: 12.533vw;
  height: 11.2vw;
  display: block;
  /* margin: 8.8vw auto 1.6vw; */
  margin: 1.6vw auto 1.6vw;
}

>>>.slide-fade-enter-active {
  transition: all .3s ease;
}

>>>.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

>>>.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
  {
  transform: translateY(10px);
  opacity: 0;
}

.packhai-border-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.packhai-border-table thead {
  color: white;
}

.packhai-border-table thead tr th {

  font-weight: bold;
  font-size: 1rem;
}

.return-order-table {
  width: 100%;
}

.padding-for-order-dialog {
  padding: 0px !important;
}

@media screen and (min-width: 768px) {
  .return-order-table {
    width: 300px;
  }

  .padding-for-order-dialog {
    padding: 15px !important;
  }
}

.packhai-border-preview {
  border-top: solid 1px black;
  border-left: solid 1px black;
  border-right: solid 1px black;
  border-bottom: solid 1px black;
  border-radius: 10px;
}

.px-15 {
  padding-left: 15px;
  padding-right: 15px;
}

.fz-12 {
  font-size: 12px !important;
}

.fz-14 {
  font-size: 14px !important;
}

.text-green {
  color: green;
  font-weight: bold;
}

.text-red {
  color: red;
  font-weight: bold;
}

.smallheader {
  font-size: 11px;
  color: gray
}
</style>
